/// <reference path="HighchartsWrapper.js"/>
/// <reference path="LayoutControls.js"/>
/// <reference path="GuiEvents.js"/>
/// <reference path="Constants.js"/>
/// <reference path="Helpers.js"/>
/// <reference path="RespondentTableSetup\RespondentTableSetup.js"/>
/// <reference path="DynamicImageSetup\DynamicImageSetup.js"/>
/// <reference path="WordCloudSetup\WordCloudSetup.js"/>
/// <reference path="SummarySetup\SummarySetup.js"/>
/// <reference path="AdvancedAnalyticsSetup\AdvancedAnalyticsSetup.js"/>
/// <reference path="admin.input.events.js" />
/// <reference path="DataFieldSetup.js"/>
/// <reference path="GeneralSettings.js" />
/// <reference path="MyStory\MyStories.js" />

// stuff for handling layout creation
(function (sb) {
	sb.LayoutDesigner = (sb.LayoutDesigner || {});

	var isAdmin = false;
	var itemTypes = Storyboard.Constants.itemTypes;
	var slideShowMode = true;
	var deviceLimitEnabled = false;
	var showBgInExportOnly = false;
	var elementsProgress = { total: 0, inProgress: 0 };
	var translatedLayoutElements = [];
    var fonts = [];
    var contentLoadErrors = [];
	var drilldownElementsLoaded = false;
	var defaultFont = { name: "Arial", family: "arial,helvetica,sans-serif" };
	var defaultExportFileName = "";
    var canUserEditExportFileName = true;
    var currentTokens = [];
    var exportEmailsEnabled = false;
    var exportReportAsScreenshot = false;
	var imageQuality = 3;
	var hideSlideNavigationCurrentSlide =-1;
	var selectedGroupId = 0;
	var excludedSlides = [];
	var enableMasterSlideLayout = false;
	var reportSettings;
	var myStoriesSharingType;
	var enableMyStoriesSharing;
	var numberOfSlides = {};

	var currentPageNo = 1;
	function getCurrentPageNo() {
		return currentPageNo;
	}
	
	function setCurrentPageNo(newPageNo, doNotTriggerContentLoadOnPageSet) {
		// we also support shortcuts for navigation: last,first,next, previous
		if (newPageNo === 'last') newPageNo = getPageCount();
		else if (newPageNo === 'first') newPageNo = 1;
		else if (newPageNo === 'next') newPageNo = parseInt(currentPageNo, 10) + 1;
		else if (newPageNo === 'previous') newPageNo = parseInt(currentPageNo, 10) - 1;

		// dont go to invalid pages
		if (newPageNo > getPageCount())
			newPageNo = getPageCount();
		else if (newPageNo < 1)
			newPageNo = 1;

		var newSlide = Storyboard.LayoutDesigner.getSlideByIndex(newPageNo);
		if (!newSlide || excludedSlides.includes(newSlide.slideId))
			return;

		$('.DUI-ST-NAVIGATOR-SLIDEHANDLER', '#DUI_ST_NAVIGATOR').DUIslideNavigator('select', [newPageNo]);
		$('.DUI-ST-NAVIGATOR-LASTSLIDE', '#DUI_ST_NAVIGATOR').text(getPageCount() - excludedSlides.length);

		$("#slideNum").val(newPageNo);
		currentPageNo = newPageNo;
		var currentSlide = Storyboard.LayoutDesigner.getCurrentSlide();

		if (currentSlide) {
			if (Storyboard.LayoutDesigner.slideShowMode) {
				$(".layoutSlide:not(.bgSlide)", "#layoutArea").addClass("hidden");
				$("#StorytellerPagesizeViewport").css('height', currentSlide.height);
				Storyboard.LayoutDesigner.setLayoutAreaSize();
			}

			if ($("#layoutArea .bgSlideActive").length < 1) {
				$("#layoutArea .bgSlide").width(currentSlide.width);
				$("#" + currentSlide.guid).removeClass("hidden");
			}

			Storyboard.LayoutDesigner.setCurrentBackgroundSlide();
			Storyboard.GuiEvents.updateTemplatesMenu();

			if ($(".layoutSlide:not(.hidden)", "#layoutArea").length > 0 && !window.IsMyStories) {
				Tokens.replaceTokensOnSlide(currentSlide, currentTokens);
				Tokens.replaceTokensOnSlide(Storyboard.LayoutDesigner.getBackgroundSlide(), currentTokens);
			}

			if (window.IsMyStories) {
				$("#lnkMyStoriesSourceSlide").attr("href", window.location.href.replace("RpId=" + Helpers.getReportID(),
					"RpId=" + currentSlide.sourceReportId).replace("MyStories", "RHViewStoryBoard") + "&slide=" + currentSlide.sourceSlideIndex +
					"&mssId=" + $("#ddlMyStories").val() + "-" + currentSlide.slideId);
			}
		}

		if (Storyboard.SlidesPanel && Storyboard.SlidesPanel.isOpen()) {
			Storyboard.SlidesPanel.deselectSlides();
			Storyboard.SlidesPanel.selectSlides([currentSlide]);
			Storyboard.SlidesPanel.scrollIntoSelectedSlide();
		}

		if (window.ContentType === Storyboard.Constants.itemTypes.CHART) {
			if (ChartCreatorSetup.isContentEditable()) {
				$('#layoutArea .layoutElementAdminFocused').removeClass('layoutElementAdminFocused');
				ChartCreatorDataCom.StoreDataGroup().then(function() {
					ChartCreatorSetup.unloadDataGoup();
					ChartCreatorSetup.disableContentEditing();
				});
				ChartCreatorUI.hideCalculatePanel();
			}

			$('#slideXofN').text(locale.get('Slide %SlideNo% of %NoOfSlides%').replace('%SlideNo%', currentPageNo).replace('%NoOfSlides%', getPageCount()));
		}

		if (doNotTriggerContentLoadOnPageSet != true)
			$(document).trigger('DAPI.setPageNo', currentPageNo);
		if (window.IsMyStories && $('#ddlMyStories option').length > 0)
			setMyStoriesSlideInfo();

		if ((!Storyboard.LayoutDesigner.isAdmin || Helpers.isPreview()) && typeof (adjacentSlideChartsOnly) != 'undefined' && adjacentSlideChartsOnly) {
			var chartElements = getLayoutElementsByType(Storyboard.Constants.itemTypes.CHART);

			for (var i = 0; i < chartElements.length; i++) {
				var chartElement = chartElements[i];
				var chartSlide = Storyboard.LayoutDesigner.getSlideByLayoutElement(chartElement);

				if (Math.abs(currentSlide.slideIndex - chartSlide.slideIndex) <= 1) {
					if ($(".layoutElement[guid='" + chartElement.guid + "'] .highcharts-container").length > 0)
						continue;

					var cachedItem = Storyboard.LayoutDesigner.getCachedContent(chartElement);
					if (cachedItem) {
						var detailTables = getDetailTablesForIDs(cachedItem.detailTables);
						Storyboard.LayoutDesigner.eventUpdateChart(chartElement, detailTables);
					}
				} else if ($(".layoutElement[guid='" + chartElement.guid + "'] .highcharts-container").length > 0) {
					var chartElementItem = Storyboard.LayoutDesigner.getElementItemByType(itemTypes.CHART, chartElement);
					Storyboard.HighchartsWrapper.destroyCharts(chartElementItem.guid);
				}
			}
		}

		Storyboard.EventBus.emit(Storyboard.Constants.Events.SLIDE_OPENED, currentPageNo);

		return currentPageNo;
	}

	function setPageNoByLayoutElementId(layoutElementId) {
		var pageNo = -1, layoutElement, slide;

		layoutElement = Storyboard.LayoutDesigner.getLayoutElementById(layoutElementId);

		if (layoutElement)
			slide = Storyboard.LayoutDesigner.getSlideByLayoutElement(layoutElement);

		if (layoutElement && slide) {
			Storyboard.LayoutDesigner.setCurrentPageNo(slide.slideIndex);
			return false;
		}
		
		return pageNo;
	}

	function getSlideNoByLayoutElementId(layoutElementId) {
		var pageNo = -1, layoutElement, slide;

		layoutElement = Storyboard.LayoutDesigner.getLayoutElementById(layoutElementId);
		if (layoutElement)
			slide = Storyboard.LayoutDesigner.getSlideByLayoutElement(layoutElement);

		if (layoutElement && slide) {
			return slide.slideIndex;
		}
		return pageNo;
	}

	function setCurrentBackgroundSlide() {
		if ((Storyboard.LayoutDesigner.showBgInExportOnly && $("#layoutArea .bgSlideActive").length < 1) ||
			(Storyboard.LayoutDesigner.getPageCount() <= excludedSlides.length)) {
				$(".bgSlide").addClass("hidden");
		} else {
			var bgSlide = Storyboard.LayoutDesigner.getBackgroundSlide();
			if (bgSlide != null)
				$("#" + bgSlide.guid).removeClass("hidden").css("z-index", "-1");

            // when "Show all slides", we need to duplicate bg and place dummies for each slide
			if (!Storyboard.LayoutDesigner.slideShowMode && bgSlide != null) {
				$(".bgSlideDummy").remove();

				var printPreview = !window.IsFormReport && self != top && window.name == 'print-frame';
				var orderedSlides = Storyboard.LayoutDesigner.getLayoutSlides(true);
				var currentOffset = 0;
				
				orderedSlides = orderedSlides.filter(function(slide) {
					return !excludedSlides.includes(slide.slideId);
				});

				if (printPreview && $("#layoutArea > .bgSlide").length > 0) {
					$("#" + bgSlide.guid).detach().appendTo("#slideWrapper_1");
				}

                for (var i = 0; i < orderedSlides.length; i++) {
                    if (!orderedSlides[i].isBackground) {
                        if (i > 0) { // Real one is at 1st slide position, so skip it
                            var dummy = $("#" + bgSlide.guid).clone().removeClass("bgSlide").removeAttr("id").removeAttr("guid");
                            dummy.addClass("bgSlideDummy").height(orderedSlides[i].height).width(orderedSlides[i].width);
                            if (!printPreview) {
                                dummy.css("top", currentOffset + "px");
                                $("div", dummy).removeAttr("layoutElementid").removeAttr("guid").removeAttr("id");
                                dummy.appendTo("#layoutArea");
                            } else {
                                dummy.appendTo("#slideWrapper_" + orderedSlides[i].slideIndex);
                            }

                            Tokens.replaceSlideTokensInDummyBg(dummy, currentTokens, orderedSlides[i].slideIndex, orderedSlides[i].slideName);
                        }

                        currentOffset += orderedSlides[i].height;
                    }
                }
            }
		}
    }

	function setMyStoriesSlideInfo() {
		$("#storySlideSettingsInfo").empty();
		$("#lnkDeleteMyStoriesSlide, #lnkMyStoriesSourceSlide").removeAttr('disabled');

		var currentSlide = Storyboard.LayoutDesigner.getCurrentSlide();
		if (currentSlide && currentSlide.noSourceReportAccess) {
			$("#" + currentSlide.guid).html("<p class='Message Message-error m-1'>You don't have access to the source report of this slide</p>");
			$("#lnkMyStoriesSourceSlide").attr('disabled', true).removeAttr('href');
		}
		else if (currentSlide && currentSlide.settingsText && currentSlide.settingsText.indexOf("filter selections are not available") > -1) {
			$("#" + currentSlide.guid).html("<p class='Message Message-warning m-1'>"+ currentSlide.settingsText +"</p>")
		}
		else if (currentSlide && currentSlide.settingsText) {
			$("#storySlideSettingsInfo").html("Filters:<br>" + currentSlide.settingsText);
		}
	}


	function scrollPageIntoLayoutElement(layoutElementId) {
		var el = $('#layoutArea .layoutElement[layoutelementid="'+ layoutElementId +'"] .layoutElementItem');
		if (el.length === 0) return;
		var windowTop = $(window).scrollTop();
		var windowBottom = windowTop + $(window).height();
		var elTop = $(el).offset().top;
		var elBottom = elTop + $(el).height();
		var scrollParent = $(el).scrollParent();

		function isScrolled(el) {
			return ((elBottom <= windowBottom) && (elTop >= windowTop));
		}

		if (el.is(':visible') && !isScrolled(el) && scrollParent) {
			if ($(el).height() >= $(window).height()) {
				scrollParent.scrollTop(elTop);
			} else {
				scrollParent.scrollTop(elTop - ($(window).height() / 2) + ($(el).height() / 2));
			}
		}
	}

	var enabledScreenTypes = [];
	function setEnabledScreenTypes(value) {
		enabledScreenTypes = value || [];
	}
	function getEnabledScreenTypes() {
		return enabledScreenTypes;
	}

	var exportOptions = {};
	function setExportOptions(value) {
		exportOptions = value;
		var isChartCreator = window.ContentType > 0 && window.ContentType === Storyboard.Constants.itemTypes.CHART;

		var formats = Storyboard.Constants.documentFormats;
		var showPptExport = exportOptions.pptExport &&
			(Storyboard.LayoutDesigner.getLayoutGrid().layoutType == formats.PPTONLINE.hash || Storyboard.LayoutDesigner.getLayoutGrid().layoutType == formats.PPT_16_9.hash || Storyboard.LayoutDesigner.getLayoutGrid().layoutType == formats.CUSTOM.hash);

        var showNativePptExport = exportOptions.pptNativeExport &&
			(Storyboard.LayoutDesigner.getLayoutGrid().layoutType == formats.PPTONLINE.hash || Storyboard.LayoutDesigner.getLayoutGrid().layoutType == formats.PPT_16_9.hash || Storyboard.LayoutDesigner.getLayoutGrid().layoutType == formats.CUSTOM.hash);

		// support custom coding that hides buttons until clients switch to built-in function
		if (!exportOptions.print || isChartCreator)
			$("#btnPrintStory").css("display", "none");
		else if (Storyboard.LayoutDesigner.isAdmin && !Helpers.isPreview())
			$("#btnPrintStory").css("display", "");

		if (!showPptExport && !showNativePptExport && !exportOptions.excelExport && !exportOptions.pdfExport)
			$("#btnOpenExportPanel, #btnExportSTLayout, #btnOpenExportPanel_cc").css("display", "none");
		else if (Storyboard.LayoutDesigner.isAdmin && !Helpers.isPreview())
			$("#btnOpenExportPanel, #btnExportSTLayout, #btnOpenExportPanel_cc").css("display", "");

		if (exportOptions.hideOneReportPerFilter)
			$('#chkSplitFilter').css('display', 'none');
		//else
			//updateCompactText
		// remove export panel to recreate later with correct options
		Storyboard.LayoutDesigner.destroyExportPanel();
	}
	function getExportOptions() {
		return exportOptions;
	}

	function getImageQualityDisplay() {
		return this.imageQualityDisplay;
	}

	function setImageQualityDisplay(value) {
		this.imageQualityDisplay = value;
	}

	var detailTables = [];
	function getDetailTables() {
		return detailTables;
	}

	var layoutGrid = {};
	var storytellerLoadType = Storyboard.Constants.ContentLoadType.All;
	function getLayoutGrid() {
		return layoutGrid;
    }
    function setLayoutGrid(layoutToSet) {
        layoutGrid = layoutToSet;
        Storyboard.LayoutControls.hideLoadingBar();
        $(document).trigger('DAPI.hashedLayoutGridLoaded');
    }

	var layoutSlides = [];
	function getPageCount() {
		var count = 0;
		for (var i in layoutSlides)
			if (layoutSlides.hasOwnProperty(i) && !layoutSlides[i].isBackground)
				count++;
		return count;
	}

	function getLayoutSlides(ordered) {
		if (ordered) {
			layoutSlides.sort(function (s1, s2) { return (s1.slideIndex > s2.slideIndex) ? 1 : -1 });
		}
		return layoutSlides;
	}
	function setDefaultMasterTemplateIDAllLayoutSlides(defaultTemplateID) {
		layoutSlides.forEach(function (slide) {
			slide.layoutTemplateId = defaultTemplateID
		});
	}
	function loadTokensInSlideSS(slide) {
		Tokens.replaceTokensOnSlide(slide, currentTokens);
		return null;
	}
	var layoutElements = [];
	function getLayoutElements() {
		return layoutElements;
	}

	var pageSize = {};
	function getPageSize() {
		return pageSize;
	}

	function setPageSize(pSize) {
		if (typeof pSize.layoutType != 'undefined' && !isNaN(pSize.layoutType)) {
			pageSize = pSize;
			layoutGrid.height = pSize.height;
			layoutGrid.width = pSize.width;
			layoutGrid.layoutType = pSize.layoutType;

			Storyboard.LayoutDesigner.eventRedrawLayoutGrid(layoutGrid);
		}
	}

	function getBackgroundImage(callback) {
		Helpers.perfJSonCall({
			method: "GetBackgroundImageUrl",
			successCallback: callback,
			message: locale.get('Loading background image')
		});
	}

	// number of slides of report
	function getNumberOfSlides(reportId, slideNo, previousReportId, element) {
		if (reportId && slideNo) {
			if (typeof numberOfSlides[reportId] !== 'undefined') {
				if (typeof numberOfSlides[reportId].result !== 'undefined' && !numberOfSlides[reportId].isLoading) {
					processResult(reportId, slideNo, previousReportId, element, numberOfSlides[reportId].result);
				} else {
					numberOfSlides[reportId].toProcess.push([reportId, slideNo, previousReportId, element]);
				}
			} else {
				numberOfSlides[reportId] = {
					isLoading: true,
					toProcess: [[reportId, slideNo, previousReportId, element]]
				}
				Helpers.perfJSonCall({
					method: 'GetNumberOfSlides',
					data: { reportId: reportId },
					successCallback: function(result) {
						numberOfSlides[reportId].isLoading = false;
						numberOfSlides[reportId].result = result;
						numberOfSlides[reportId].toProcess.forEach(function(args) {
							processResult(args[0], args[1], args[2], args[3], result);
						});
						numberOfSlides[reportId].toProcess = [];
					}
				});
			}
		}

		function processResult(reportId, slideNo, previousReportId, element, numberOfSlidesResult) {
			if (numberOfSlidesResult < slideNo) {
				if (element != -1)
					Storyboard.LayoutDesigner.UserEvents.removeEventsFromElement(element);
			} else if (element == -1)
				redirectReport(previousReportId.toString(), reportId, slideNo);
		}
	}

	function redirectReport(reportId, targetReportId, targetSlide) {
		var newLocation = window.location.href.replace("RpId=" + reportId, "RpId=" + encodeURIComponent(targetReportId));
		if (targetSlide) {
			if (newLocation.indexOf('slide=') > -1)
				newLocation = newLocation.replace('slide=' + Helpers.getURLParameter('slide'), 'slide=' + encodeURIComponent(targetSlide));
			else
				newLocation += '&slide=' + encodeURIComponent(targetSlide);
		}
		if (window.IsMyStories)
			newLocation = newLocation.replace("MyStories.aspx", "RHViewStoryBoard.aspx");
		window.location.assign(newLocation);
	}

	// content cache - I think it's only used in charts right now
	var contentCache = {};
	function getCachedContent(layoutElement) {
		return contentCache[layoutElement.guid];
    }

	// hold current optional filter selections
	var selectedGeneralSettings;

	function resetCachedContentForElement(layoutElement) {
		delete contentCache[layoutElement.guid];
		Helpers.ThrottleQueue.clearThrottleQueue(layoutElement.guid);
	}

	var hFilterLayout;
	function getHFilterLayout() {
		return hFilterLayout;
	}

	var hFilterSelectionMode;
	function getHFilterSelectionMode() {
		return hFilterSelectionMode;
	}

	function setHFilterLayout(hfLayout, hfSelectionMode) {
		hFilterLayout = hfLayout;
		hFilterSelectionMode = hfSelectionMode;
	}

	// store optional filter selections in cookies (used mostly when useStickyFilters is set in custom HTML)
	function storeSelections(controlPattern) {
		if ($(controlPattern).length !== 0) {
			$(controlPattern).each(function () {
				var selections = $(this).multiselect('getChecked').map(function () {
					return this.value;
				}).get();
				if (selections.length > 1) selections = selections.join(',');
				Helpers.createCookie($(this).attr('id'), selections);
			});
		}
	}

	function storeFiltersSelections() {
		if (typeof (useStickyFilters) != 'undefined' && useStickyFilters)
			Storyboard.LayoutDesigner.storeSelections("[id^='lbSetting_5']");
	}

	function storeSelectedDates() {
		if ($("#lbSetting_3").length > 0) {
			var settingControl = $('#lbSetting_3').closest('.SettingsControl');
			var startDate = settingControl.find(".optCustomPeriodStart").datepicker('getDate');
			var endDate = settingControl.find(".optCustomPeriodEnd").datepicker('getDate');
			if (startDate)
				Helpers.createCookie("selectedStartDate", startDate.format('yyyy/MM/dd'));
			if (endDate)
				Helpers.createCookie("selectedEndDate", endDate.format('yyyy/MM/dd'));
		}
	}

	function storeSelectedRespondent() {
		if ($("#ddlFormRespondents").length > 0) {
			var respondentId = $('#ddlFormRespondents option:selected').val();
			Helpers.createCookie("selectedRespondentId", respondentId);
		}
    }

    function storeRespTablesVariables() {
        var selectedVars = Storyboard.LayoutDesigner.getRespTablesSelectedVariablesInfo();
        Helpers.createCookie("respTablesInfo", JSON.stringify(selectedVars));
    }

	function getNewZIndex() {
		var newIndex = layoutElements.reduce(function(acc, curr) {
			return Math.max(acc, curr.zIndex);
		}, Storyboard.GuiEvents.zIndexBase);

		return ++newIndex;
	}

	function getNewGroupId() {
		var newGroupId = layoutElements.reduce(function(acc, curr) {
			if (curr.groupId) return Math.max(acc, curr.groupId);
			else return acc;
		}, 0);

		return ++newGroupId;
	}

	function getNewYCoord() {
		var windowTop = $(window).scrollTop();
		var viewportTop = $('#StorytellerPagesizeViewport').offset().top;
		var stickyElementsHeight;

		if (windowTop > viewportTop) {
			stickyElementsHeight = $('.sticky')
				.map(function() { return $(this).height(); }).toArray()
				.reduce(function(a, b) { return a + b; }, 20);

			return windowTop - viewportTop + stickyElementsHeight + 1;
		}

		return 0;
	}

	// if elementItem has ID it means it's saved in the database
	function elementItemHasId(layoutElementItem) {
		return layoutElementItem.hasOwnProperty('elementItemId') &&
            parseInt(layoutElementItem.elementItemId) > 0;
	}

	function addLayoutGrid(layoutInfo) {
		layoutGrid = layoutInfo.layoutGrid;
		storytellerLoadType = layoutInfo.storytellerLoadType;
		layoutElements = layoutGrid.layoutElements;
		layoutSlides = layoutGrid.layoutSlides;
		layoutGrid.background = layoutInfo.background;
		layoutGrid.showBackground = layoutInfo.settings.showBackgroundImage;
		layoutGrid.imageQualityDisplay = layoutInfo.imageQualityDisplay;
		layoutGrid.layoutType = layoutInfo.settings.layoutType;
		//setImageQualityDisplay(layoutInfo.imageQualityDisplay);
        exportReportAsScreenshot = layoutInfo.settings.exportAsScreenshot;
		imageQuality = layoutInfo.settings.imageQualityDisplay;
		setExportOptions({
			excelExport: layoutInfo.excelExportOption,
            pptExport: layoutInfo.settings.pptExport,
            pptNativeExport: layoutInfo.settings.pptNativeExport,
			pdfExport: layoutInfo.settings.pdfExport,
			print: layoutInfo.settings.print,
			//allowCustomExportTemplates: layoutInfo.settings.allowCustomExportTemplates,
			defaultExportTemplateId: layoutInfo.settings.defaultExportTemplateId,
			hideOneReportPerFilter: layoutInfo.settings.hideOneReportPerFilter
		});

		createPageSizeObject(layoutGrid);
	}

	function addLayoutSlide(layoutSlide, dontRegister) {
		layoutSlide.guid = layoutSlide.guid || Helpers.generateGuid();

		if (!dontRegister) {
			layoutSlides.push(layoutSlide);
		}

		sb.LayoutDesigner.eventRedrawLayoutSlide(layoutSlide);
	}

	function addChartCreatorElement(layoutElement, itemType) {
		var currentSlide = Storyboard.LayoutDesigner.getCurrentSlide();
		itemType = itemType || (layoutElement.isSlideTitle || layoutElement.isSlideSubtitle || layoutElement.isSlideFooter ?
			itemTypes.STATICTEXT :
			itemTypes.EMPTYCHARTCREATOR);

		layoutElement.layoutElementId = 0;
		layoutElement.zIndex = layoutElement.zIndex || getNewZIndex();
		layoutElement.slideId = currentSlide.slideId;
		layoutElement.slideGuid = currentSlide.guid;
		layoutElement.layoutElementItems = [];
		addOrReplaceElementItem(new LayoutElementItem(itemType), layoutElement);
		layoutElement.guid = Helpers.generateGuid();

		layoutElements.push(layoutElement);

		// special case for new image - proccess uploaded file first
		var imgElementItem = Storyboard.LayoutDesigner.getElementItemByType(itemTypes.IMAGE, layoutElement);
		if (imgElementItem && !elementItemHasId(imgElementItem) && !layoutElement.layoutTemplateId) {
			processUploadedImageFile(layoutElement, imgElementItem);
			ChartCreatorSetup.setUnsaved(true);
		} else {
			sb.LayoutDesigner.eventRedrawLayoutElement(layoutElement);
		}

		sb.LayoutDesigner.history.empty();

		return layoutElement;
	}

	function addLayoutElement(layoutElement, itemType, dontRegisterElement) {
        if (!layoutElement) {
            var currentSlide = $(".bgSlideActive").length > 0 ?
                Storyboard.LayoutDesigner.getBackgroundSlide() :
                Storyboard.LayoutDesigner.getCurrentSlide();

            layoutElement = {
                width: 400,
                height: 300,
                xCoord: 0,
                yCoord: getNewYCoord(),
                layoutElementId: 0,
                zIndex: getNewZIndex(),
                isSelected: !dontRegisterElement,
                isValid: false,
                animate: true,
                slideId: currentSlide.slideId,
				slideGuid: currentSlide.guid,
				elementItemName: null
            };

            if (!itemType)
                itemType = itemTypes.CHART;

            if (itemType == itemTypes.STATICTEXT) {
                layoutElement.width = 400;
                layoutElement.height = 25;
            }
            else if (itemType == itemTypes.IMAGE) {
                layoutElement.resize = true;
            }
            else if (itemType == itemTypes.EVENTCREATOR) {
                layoutElement.width = 190;
                layoutElement.height = 60;
            }
            else if (itemType == itemTypes.ICONSHAPE || itemType == itemTypes.DYNAMICICONSHAPE) {
                layoutElement.width = 200;
                layoutElement.height = 200;
            }
            if (layoutElement.width >= currentSlide.width) {
                // Slide size - 10% rounded to nearest multiple of 5
                layoutElement.width = Math.round((currentSlide.width - (currentSlide.width * .1)) / 5) * 5;
            }

            Storyboard.LayoutDesigner.updateUsageStats(layoutElements.length + 1);
            Storyboard.LayoutDesigner.setState(true);
        } else {
            if (itemType == itemTypes.TAGS) {
                var tag = HTMLHelpers.htmlEncode($('#txtNewTag').val());
                layoutElement.tags = tag;
            }
            else
				delete layoutElement.__type;
        }

		if (!layoutElement.layoutElementItems)
			layoutElement.layoutElementItems = [];

		// keep guid if exists, since cloned elements are assigned one elsewhere
		for (var i in layoutElement.layoutElementItems)
			if (layoutElement.layoutElementItems.hasOwnProperty(i)) {
				layoutElement.layoutElementItems[i].guid = layoutElement.layoutElementItems[i].guid || Helpers.generateGuid();
				delete layoutElement.layoutElementItems[i].__type;
			}

		// temp hack to make sure every element can serve a chart
		if (layoutElement.layoutElementItems.length == 0)
			addOrReplaceElementItem(new LayoutElementItem(itemType), layoutElement);

		layoutElement.guid = layoutElement.guid || Helpers.generateGuid();

		// if dontRegisterElement is set element is already in the collection
		// and was sent here just to be populated with guid and redrawn
		if (!dontRegisterElement)
			layoutElements.push(layoutElement);

		// special case for new image - proccess uploaded file first
		var imgElementItem = Storyboard.LayoutDesigner.getElementItemByType(itemTypes.IMAGE, layoutElement);
		if (imgElementItem && !elementItemHasId(imgElementItem)) {
			processUploadedImageFile(layoutElement, imgElementItem);
		} else {
			sb.LayoutDesigner.eventRedrawLayoutElement(layoutElement);
		}

		if (Storyboard.LayoutDesigner.isAdmin)
			Storyboard.LayoutDesigner.history.empty();
	}

	function processUploadedImageFile(layoutElement, imgElementItem) {
		Helpers.perfJSonCall({
			method: 'ProcessUploadedFiles',
			data: { guid: imgElementItem.guid },
			successCallback: function () {
				layoutElement.isValid = true;
				sb.LayoutDesigner.eventRedrawLayoutElement(layoutElement);
			},
			message: locale.get('Adding Image')
		});
	}

	// (re)load Form elements
	// both global (first load, respondent changed) and element specific (data field settings saved)
	function loadFormContent(elementsToLoad) {
		var fullReload = !elementsToLoad;
		elementsToLoad = elementsToLoad || layoutElements;

		// ensure that we only load data fields
        var toLoad = $.grep(elementsToLoad, function (le) {
            var leType = getLayoutElementType(le);
            return leType == itemTypes.DATAFIELD || leType == itemTypes.RESPONDENTTABLE;
		});
		var respondentId = $('#ddlFormRespondents').val();
		if (respondentId > 0 || (respondentId < -100 && respondentId > -1000000000))
			Helpers.perfJSonCall({
				method: 'loadFormContent',
                data: { layoutElements: toLoad, respondentId: respondentId },
				successCallback: function (result) {
					if (fullReload)
						$(".layoutElementItem.layoutElementDataField").empty();

                    getFormContentCompleted(result.elementsData);
					loadTokensCompleted(result.tokens);
				},
                fixCasing: true
			});
    }

    function getFormContentCompleted(elementsContent) {
        $(elementsContent).each(function () {
            switch (this.elementType) {
                case itemTypes.DATAFIELD:
                    getDataFieldForLayoutElementCompleted(this.result);
                    break;
                case itemTypes.RESPONDENTTABLE:
                    getRespondentTableForLayoutElementCompleted(this.result);
                    break;
            }
        });
    }

	function getDataFieldForLayoutElementCompleted(args) {
		if (args) {
			var dataFieldLayoutElement = getLayoutElementByIdOrGuid(args.layoutElementId || args.layoutElementGuid);
			var dataFieldElementItem = getElementItemByType(itemTypes.DATAFIELD, dataFieldLayoutElement);

			if (dataFieldLayoutElement) {
				if (dataFieldElementItem)
					dataFieldElementItem.content = "";
				DataFieldSetup.eventUpdateDataField(dataFieldLayoutElement, args);
			}
		}
	}

	function getLayoutElementLoadPriority(layoutElement, bgSlideId) {
		var currentSlideNo = Storyboard.LayoutDesigner.getCurrentPageNo();
		var leSlide = Helpers.getLayoutElementSlideIndex(layoutElement);

        if (layoutElement && layoutElement.slideId == bgSlideId)
            return -3;
		if (leSlide == currentSlideNo)
			return -2;
		if (leSlide == currentSlideNo - 1 || leSlide == currentSlideNo + 1)
			return -1;

		return leSlide;
    }

    function loadMyStoryContent(callback) {
		var hfTokens = [];
		var questionTokens = [];

        $(layoutSlides).each(function () {
            var slideIndex = this.slideIndex;
            var slideElements = getLayoutElementsBySlide(this);
			var slideTokens = { slideIndex: slideIndex, tokens: [] };
			var slideQuestionTokens = { slideIndex: slideIndex, tokens: [] };

            $(slideElements).each(function () {
                var layoutElement = this;
                var itemType = getLayoutElementType(layoutElement);

                // for text elements: check for used tokens and populate parameter
                if (itemType == itemTypes.STATICTEXT) {
                    var htmlElem = Storyboard.LayoutDesigner.getElementItemByType(itemTypes.STATICTEXT, this);
                    if (htmlElem && htmlElem.content) {
						var tokensPattern = new RegExp("([\\[](Q[0-9]+|INT|TP|MA|VS|RD|HFILTER)[:][LO][:\\d:]*[\\]])");
                        if (tokensPattern.test(htmlElem.content) || Tokens.getMatchingSpecialToken(htmlElem.content) != null) {
                            $(Tokens.getUsedHFilterTokens(htmlElem)).each(function () {
                                slideTokens.tokens.push(this);
                            });
						}

						var questionTokenPattern = new RegExp("\\[.+?:[CT]\\]");
						if (questionTokenPattern.test(htmlElem.content)) {
							$(Tokens.getUsedQuestionTokens(htmlElem)).each(function () {
								slideQuestionTokens.tokens.push(this);
							});
						}
                    }
                }
            });

			hfTokens.push(slideTokens);
			questionTokens.push(slideQuestionTokens);
        });

        Helpers.perfJSonCall({
            method: "LoadMyStoryContent",
			data: { storyId: $("#ddlMyStories").val(), hfTokens: hfTokens, questionTokens: questionTokens, layout: Storyboard.LayoutDesigner.getLayoutGrid() },
            successCallback: function (result) {
                loadTokensCompleted(result.tokens);

                if (result.slideSettingsTexts) {
                    $(result.slideSettingsTexts).each(function () {
                        var slide = getSlideByIndex(this.Item1);
                        if (slide)
                            slide.settingsText = this.Item2;
                    });
                    setMyStoriesSlideInfo();
                }

                var iOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
                if (iOS) {
                    if (callback) {
                        callback();
                        if (result.initGetData)
                            getProcessedData();
                    } else {
                        if (result.initGetData)
                            setTimeout(getProcessedData, 200);
                    }
                } else {
                    if (callback) callback();
                    if (result.initGetData)
                        getProcessedData();
                }
            }
        });
	}

	function loadDrilldownContent(drilldownSettingsGuid, slideIndex, elementId) {
		Storyboard.GeneralSettings.drilldownSettingsGuid = drilldownSettingsGuid;

		function navigateToElement(elementId) {
			if (Storyboard.LayoutDesigner.setPageNoByLayoutElementId(elementId) > -1 && $('div.DUIslideNavigator').length > 0) {
				Storyboard.LayoutDesigner.scrollPageIntoLayoutElement(elementId);
			}
		}

		if (drilldownElementsLoaded) {
			if (elementId) navigateToElement(elementId);
			else if (slideIndex) Storyboard.LayoutDesigner.setCurrentPageNo(parseInt(slideIndex, 10));
			loadStorytellerContent(null, null, drilldownSettingsGuid);
		} else {
			$(document).bind('DAPI.drilldownElementsLoaded', function () {
				if (elementId) navigateToElement(elementId);
				else if (slideIndex) Storyboard.LayoutDesigner.setCurrentPageNo(parseInt(slideIndex, 10));
				loadStorytellerContent(null, null, drilldownSettingsGuid);
			});
		}
	}

	// (re)load Storyteller elements slide by slide
	// global (first load, Update, etc)
	function loadStorytellerContent(continuosSlides, loadType, drilldownSettingsGuid) {
		continuosSlides = continuosSlides || !Storyboard.LayoutDesigner.slideShowMode;

		selectedGeneralSettings = GeneralSettings.getSelectedSettings();
		Helpers.ThrottleQueue.clearThrottleQueue();

		loadType = loadType || Storyboard.Constants.ContentLoadType.All;
		if (!(window.IsDrilldown && self != top) && !continuosSlides && (!Storyboard.LayoutDesigner.isAdmin || Helpers.isPreview()))
			loadType = storytellerLoadType;

		var prioritizedElements = [];
		var doNotReload = $(".layoutElementItem.doNotReload", "#layoutArea").map(function(i, el) { return el.parentElement.id; }).toArray();
		var bgSlide = Storyboard.LayoutDesigner.getBackgroundSlide();

		layoutElements
			.filter(function(layoutElement) {
				return !doNotReload.includes(layoutElement.guid);
			})
			.forEach(function(layoutElement) {
				layoutElement.loadPriority = getLayoutElementLoadPriority(layoutElement, bgSlide != null ? bgSlide.slideId : null);

				var currentMyStorySlideId = "";
				var currentMyStorySlidePos = Helpers.getLayoutElementSlideIndex(layoutElement);
				var selectedMyStorySlideIds = $("#ddlMyStories").val();
				if (selectedMyStorySlideIds) {
					currentMyStorySlideId = selectedMyStorySlideIds.split("|")[currentMyStorySlidePos - 1];
					layoutElement.myStorySlideId = currentMyStorySlideId;
				}
				else {
					layoutElement.myStorySlideId = -1;
				}

				if (loadType == Storyboard.Constants.ContentLoadType.All ||
					(loadType == Storyboard.Constants.ContentLoadType.CurrentAndAdjacent && layoutElement.loadPriority < 0 && !layoutElement.hasOwnProperty("GUILoaded")) ||
					(loadType == Storyboard.Constants.ContentLoadType.CurrentSlide && (layoutElement.loadPriority === -2 || layoutElement.loadPriority === -3) && !layoutElement.hasOwnProperty("GUILoaded")) ||
					(loadType == Storyboard.Constants.ContentLoadType.Translated && $.inArray(layoutElement.layoutElementId, Storyboard.LayoutDesigner.translatedLayoutElements) != -1)) {
					prioritizedElements.push(layoutElement);
				}
			});

		loadStorytellerContentForElements(prioritizedElements, true, false, null, true, loadType, drilldownSettingsGuid);
	}

	function loadStorytellerContentForElements(layoutElementsToLoad, avoidCache, initiatedByForm, key, isFullReload, loadType, drilldownSettingsGuid, skipSummaryCache) {

		if (!initiatedByForm && !sb.LayoutDesigner.checkFilterSelection({ checkMinMaxSelectionsOnly: true}))
			return;

		if (!layoutElementsToLoad || layoutElementsToLoad.length < 1) {

			sb.LayoutDesigner.allLayoutElementsLoaded = true;
			$(document).trigger('DAPI.allLayoutElementsLoaded');
			return;
		}

		// TODO - not used anymore?
		if (key)
			Helpers.ThrottleQueue.clearThrottleQueue(key);

        var currentMyStorySlideId = "";
        var layoutElementCount = 0;
		var currentMyStorySlidePos = "";

		// TFS 18617 - null layout element at index 0 breaks the update process
		// skip null elements at the beginning of the array and return slide index from the first valid element
		for (var i = 0; i < layoutElementsToLoad.length; i++) {
			if (layoutElementsToLoad[i] != null) {
				currentMyStorySlidePos = Helpers.getLayoutElementSlideIndex(layoutElementsToLoad[i]);
				break;
			}
			else {
				continue;
			}
        }

		var selectedMyStorySlideIds = Helpers.getURLParameter("selectedMyStorySlideIDs");

		if (selectedMyStorySlideIds) {
			currentMyStorySlideId = selectedMyStorySlideIds.split("|")[currentMyStorySlidePos - 1];
		}

		selectedGeneralSettings = selectedGeneralSettings || GeneralSettings.getSelectedSettings();

		var elements = [];

		var commonParams = {
			layoutElements: [],
			settings: selectedGeneralSettings,
			ignoreChartsCache: initiatedByForm || false,
			hFilterIds: window.ContentType > 0 && window.ContentType == Storyboard.Constants.itemTypes.CHART ?
				Storyboard.HFilterLayout.getSelectedIds("#deckHFilterTree") : Storyboard.HFilterLayout.getSelectedIds("#hfilterTree"),
			includeTokens: false,
			hFilterTokens: [],
			questionTokens: [],
			respTablesFilterInfo: [],
			fullReload: isFullReload || false,
			currentMyStorySlidePos: currentMyStorySlidePos,
			currentMyStorySlideId: currentMyStorySlideId,
			includeTextBox: false,
			drilldownSettingsGuid: drilldownSettingsGuid || "",
			skipSummaryCache: skipSummaryCache || false
		};

		$(layoutElementsToLoad).each(function (index, elem) {
			if (!elem) return true;

			var layoutElement = this;
			var itemType = getLayoutElementType(layoutElement);

			// for text elements: check for used tokens and populate parameter
			if (itemType == itemTypes.STATICTEXT) {
				var htmlElem = Storyboard.LayoutDesigner.getElementItemByType(itemTypes.STATICTEXT, this);
				if (htmlElem && htmlElem.content) {
					var tokensPattern = new RegExp("([\\[](Q[0-9]+|INT|TP|MA|VS|RD|HFILTER)[:][LO][:\\d:]*[\\]])");
					if (tokensPattern.test(htmlElem.content) || Tokens.getMatchingSpecialToken(htmlElem.content) != null) {
						commonParams.includeTokens = true;
						$(Tokens.getUsedHFilterTokens(htmlElem)).each(function () {
							commonParams.hFilterTokens.push(this);
						});
						
					}

					var questionTokenPattern = new RegExp("\\[.+?:[CT]\\]");
					if (questionTokenPattern.test(htmlElem.content)) {
						commonParams.includeTokens = true;
						$(Tokens.getUsedQuestionTokens(htmlElem)).each(function () {
							commonParams.questionTokens.push(this);
						});
					}
				}
				if (loadType == Storyboard.Constants.ContentLoadType.Translated) {
					commonParams.includeTextBox = true;
					elements.push(this);
				}
			}
				// for respondent tables: pass current pageNo and column filters
            else if (itemType == itemTypes.RESPONDENTTABLE && !(self != top && window.name == "print-frame")) {
				var sortFilter = { PageNrToReturn: 1, ColFilterSortList: [], LayoutElementId: layoutElement.layoutElementId };
				var pageNo = $(".layoutElement[guid='" + layoutElement.guid + "']").find(".paginate_active").attr("value");
				if (pageNo != null) {
                    pageNo = parseInt(pageNo, 10);
                    sortFilter.PageNrToReturn = isFullReload ? 1 : pageNo;
				}

				var elementItem = Storyboard.LayoutDesigner.getElementItemByType(itemTypes.RESPONDENTTABLE, this);
				var cachedSettings = Storyboard.RespondentTableCache.getSettingsFromCache(elementItem.guid);
				if (cachedSettings) {
					if (cachedSettings.CompleteTableFilter)
						sortFilter.CompleteTableFilter = cachedSettings.CompleteTableFilter;
                    sortFilter.ColFilterSortList = cachedSettings.ColFilterSortList;
                    sortFilter.VariablesToShow = cachedSettings.VariablesToShow;
                    if (isFullReload)
                        cachedSettings.PageNrToReturn = 1;
                }

                commonParams.respTablesFilterInfo.push(sortFilter);

				elements.push(this);
			}
				// leave out elements with static content
			else if (itemType != itemTypes.TEXT && itemType != itemTypes.IMAGE && itemType != itemTypes.ICONSHAPE)
				elements.push(this);
        });

        if (self != top && window.name == "print-frame") { // restore respondent tables selected variables in print preview
            commonParams.respTablesFilterInfo = JSON.parse(Helpers.readCookie('respTablesInfo'));
        }

		elementsProgress.total = elements.length;
		elementsProgress.inProgress = elements.length;

		if (avoidCache)
			$(layoutElementsToLoad).each(function () {
				resetCachedContentForElement(this, initiatedByForm);
            });

        commonParams.layoutElements = isFullReload
            ? $.grep(elements, function (element) { return element.loadPriority == -3; }) // background slide
            : elements;

        layoutElementCount = commonParams.layoutElements.length;

        if (layoutElementCount == 0)
            commonParams.layoutElements = isFullReload
                ? $.grep(elements, function (element) { return element.loadPriority == -2; }) // current slide
                : elements;

        var fullReloadCallback = function () {
            commonParams.fullReload = false; // to avoid Cancelling when loading elements from other slides
            commonParams.includeTokens = false; // already done that in background slide call
            // the rest of elements
            commonParams.layoutElements = $.grep(elements, function (element) {
                return element.loadPriority == -2;
			});
			commonParams.settings = GeneralSettings.getSelectedSettings();
            loadContent(commonParams, fullReloadCurrentSlideCallback);
        };

        var fullReloadCurrentSlideCallback = function () {
            commonParams.fullReload = false; // to avoid Cancelling when loading elements from other slides
            commonParams.includeTokens = false; // already done that in current slide call
            // the rest of elements
            commonParams.layoutElements = $.grep(elements, function (element) {
                return element.loadPriority != -2;
			});
			commonParams.settings = GeneralSettings.getSelectedSettings();
            loadContent(commonParams);
        };

        Helpers.reportLoadingProgress(elementsProgress.total, elementsProgress.inProgress);
        contentLoadErrors.length = 0;
        loadContent(commonParams, isFullReload ? ((layoutElementCount > 0) ? fullReloadCallback : fullReloadCurrentSlideCallback) : null);
	}

	function loadContent(commonParams, callback) {

		Helpers.perfJSonCall({
			method: "loadContentForElements",
			data: commonParams,
			successCallback: function (result) {
				if (commonParams.includeTextBox)
					loadTextBoxsCompleted(result.textBoxes);
				loadTokensCompleted(result.tokens);
				var iOS = /iPad|iPhone|iPod|Mac/.test(navigator.userAgent) && !window.MSStream;
				if (iOS) {
					if (callback) {
						callback();
						if (result.initGetData)
							getProcessedData();
					} else {
						if (result.initGetData)
							setTimeout(getProcessedData, 200);
					}
				} else {
					if (callback) callback();
					if (result.initGetData)
						getProcessedData();
				}
                if (!result.initGetData && typeof sb.LayoutDesigner.allLayoutElementsLoaded === 'undefined') {
                    sb.LayoutDesigner.allLayoutElementsLoaded = true;
                    $(document).trigger('DAPI.allLayoutElementsLoaded');
                }
			}
		});
	}

    function getProcessedData() {
		sb.LayoutDesigner.allLayoutElementsLoaded = false;

		Helpers.perfJSonCall({
			method: "GetProcessedData",
			successCallback: function (result) {
				elementsProgress.inProgress -= result.ObjectsTotal;
				Helpers.reportLoadingProgress(elementsProgress.total, elementsProgress.inProgress);
				loadStorytellerContentForElementsCompleted(result);

				if (result.TasksStillRunning)
					getProcessedData();
                else {
                    Helpers.reportLoadingProgress(elementsProgress.total, 0);
                    Storyboard.LayoutDesigner.setCurrentBackgroundSlide();
                    if (contentLoadErrors.length > 0) {
                        var errorMsg = contentLoadErrors.length == 1 ? "An error occurred while generating " : "Errors occured while generating following objects: ";
                        Storyboard.LayoutControls.showError(errorMsg + contentLoadErrors.join(", "));
					}

					sb.LayoutDesigner.allLayoutElementsLoaded = true;
					$(document).trigger('DAPI.allLayoutElementsLoaded');
				}
			}
		});
	}

	function loadTextBox(elementsToLoad) {
		elementsToLoad = elementsToLoad || layoutElements;

		// ensure that we only load text objects
		var textObjectsToLoad = $.grep(elementsToLoad, function(le) {
			return getLayoutElementType(le) == itemTypes.STATICTEXT;
		});

		Helpers.perfJSonCall({
			method: 'loadTextBox',
			data: { layoutElements: textObjectsToLoad },
			successCallback: function (textBoxes) {
				loadTextBoxsCompleted(textBoxes);
			}
		});
	}

	function loadTextBoxsCompleted(textBoxes) {
		if (textBoxes && textBoxes.length > 0) {
			$(textBoxes).each(function () {
				Helpers.fixDotnetCasing(this);
				var htmlElem = Storyboard.LayoutDesigner.getElementItemByType(itemTypes.STATICTEXT, this);
				var layoutElement = Storyboard.LayoutDesigner.getLayoutElementById(this.layoutElementId);
				var layoutElementItem = Storyboard.LayoutDesigner.getLayoutElementItem(layoutElement);
				layoutElementItem.content = htmlElem.content;

				Storyboard.GuiEvents.redrawLayoutElement(layoutElement);
			});
		}
	}

	function loadTokensCompleted(tokens) {
		// Tokens.js methods expects upper casing for object properties
		Helpers.objPropertiesToUpperCase(tokens);

		if (tokens) {
			currentTokens = tokens;

			if (window.IsMyStories) {
				layoutSlides.forEach(function (slide, index) {
					Tokens.replaceTokensOnSlide(slide, currentTokens.filter(function (token) {
						return token.StorySlideIndex == slide.slideIndex;
					}));
				});
			} else {
				var currentLayoutElements = [];
				var backgroundSlide = Storyboard.LayoutDesigner.getBackgroundSlide();

				if (Storyboard.LayoutDesigner.slideShowMode) {
					currentLayoutElements = Storyboard.LayoutDesigner.getLayoutElementsBySlide(Storyboard.LayoutDesigner.getCurrentSlide());
					if (backgroundSlide) {
						var backgroundSlideElements = Storyboard.LayoutDesigner.getLayoutElementsBySlide(backgroundSlide);
						if (backgroundSlideElements.length) currentLayoutElements = currentLayoutElements.concat(backgroundSlideElements);
					}
				} else {
					currentLayoutElements = layoutElements;
				}

				currentLayoutElements.forEach(function (layoutElement, index) {
					var htmlElem = Storyboard.LayoutDesigner.getElementItemByType(itemTypes.STATICTEXT, layoutElement);
					if (htmlElem && htmlElem.content) {
						var tokensPattern = new RegExp("([\\[](Q[0-9]+|INT|TP|MA|VS|RD|HFILTER)[:][LO][:\\d:]*[\\]])");
						if (tokensPattern.test(htmlElem.content) || Tokens.getMatchingSpecialToken(htmlElem.content) != null) {
							Tokens.replaceTokensInLayoutElementItem(htmlElem, currentTokens);
						}

						var questionTokenPattern = new RegExp("\\[.+?:[CT]\\]");
						if (questionTokenPattern.test(htmlElem.content)) {
							Tokens.replaceTokensInLayoutElementItem(htmlElem, currentTokens);
						}
					}
				});

				if (backgroundSlide)
					Storyboard.LayoutDesigner.setCurrentBackgroundSlide();
			}
		}
	}

	function loadStorytellerContentForElementsCompleted(elementsContent) {
		// pass all loaded content to element-specific hanlers
		$(elementsContent.ElementsData).each(function () {
			switch (this.ElementType) {
				case itemTypes.CHART:
				case itemTypes.SIMPLETABLE:
				case itemTypes.HEATMAP:
				case itemTypes.LINKEDCHART:
					getChartForLayoutElementCompleted(this.Result);
					break;
				case itemTypes.EVENTCREATOR:
					getEventCreatorForLayoutElementCompleted(this.Result);
					break;
				case itemTypes.TABLE:
					getTableForLayoutElementCompleted(this.Result);
					break;
				case itemTypes.DYNAMICIMAGE:
					getDynamicImageForLayoutElementCompleted(this.Result);
					break;
				case itemTypes.WORDCLOUD:
					getWordCloudForLayoutElementCompleted(this.Result);
					break;
				case itemTypes.RESPONDENTTABLE:
					getRespondentTableForLayoutElementCompleted(this.Result);
					break;
				case itemTypes.DYNAMICICONSHAPE:
					getDynamicIconShapeForLayoutElementCompleted(this.Result);
					break;
				case itemTypes.SUMMARY:
					getSummaryForLayoutElementCompleted(this.Result);
					break;
				case itemTypes.ADVANCEDANALYTICS:
					getAdvancedAnalyticsForLayoutElementCompleted(this.Result);
					break;
			}
		});
		// we can only show one message popup, so use first
        if (elementsContent.Errors && elementsContent.Errors.length > 0)
            contentLoadErrors.push(elementsContent.Errors[0]);
	}

	function getDynamicIconShapeForLayoutElementCompleted(args) {
		if (args) {
			// eventCreatorId is the same as layoutElementId
			var layoutElement = getLayoutElementByIdOrGuid(args.layoutElementGuid);
			var elementItem = getElementItemByType(itemTypes.DYNAMICICONSHAPE, layoutElement);

			if (layoutElement) {
				layoutElement.GUILoaded = true;
				layoutElement.UsesInputVariable = args.content && args.content.UsesInputVariable;
				if (elementItem) {
					DynamicIconShapeSetup.redrawDynamicIconShape(elementItem, args.content);
					if (Storyboard.SlidesPanel && Storyboard.SlidesPanel.isOpen()) {
						var slide = Storyboard.LayoutDesigner.getSlideByLayoutElement(layoutElement);
						Storyboard.SlidesPanel.renderThumbnailFromSVGs([slide]);
					}
				}
			}
		}
	}

	// cross table
	function getTableForLayoutElementCompleted(args) {
		if (args) {
			var tableLayoutElement = getLayoutElementByIdOrGuid(args.layoutElementId);
			var tableElementItem = getElementItemByType(itemTypes.TABLE, tableLayoutElement);

			if (tableLayoutElement) {
				tableLayoutElement.GUILoaded = true;
				$('.layoutElement[guid="' + tableLayoutElement.guid + '"] .designTable').css("display", "inline-block");
				if (tableElementItem)
					tableElementItem.content = args.text;
				Storyboard.GuiEvents.redrawLayoutElement(tableLayoutElement);
			}
		}
	}

	function getRespondentTableForLayoutElementCompleted(args) {
        if (args) {
            Helpers.fixDotnetCasing(args);

            var respTableLayoutElement = getLayoutElementByIdOrGuid(args.layoutElementGuid);
            var respTableElementItem = getElementItemByType(itemTypes.RESPONDENTTABLE, respTableLayoutElement);
			if (respTableLayoutElement) {
				respTableLayoutElement.GUILoaded = true;
				respTableLayoutElement.UsesInputVariable = args.settings.usesInputVariable;
				if (args.settings && (args.settings.allowExcelExport || args.settings.allowFullScreenMode))
					$('.layoutElement[guid="' + respTableLayoutElement.guid + '"] .tableOptions').css("display", "inline-block");
				if (respTableElementItem)
					respTableElementItem.content = "";
				RespondentTableSetup.eventUpdateRespondentTable(respTableLayoutElement, args);
			}
		}
	}

	function getDynamicImageForLayoutElementCompleted(args) {
		if (args) {
			var dynImageLayoutElement;
			if (args.IsMyStoryCall) {
				dynImageLayoutElement = getLayoutElementByIdOrGuid(args.layoutElementGuid);
			} else {
				dynImageLayoutElement = getLayoutElementByIdOrGuid(args.layoutElementId);
			}
			var dynImageElementItem = getElementItemByType(itemTypes.DYNAMICIMAGE, dynImageLayoutElement);

			if (dynImageLayoutElement) {
				dynImageLayoutElement.GUILoaded = true;
				$('.layoutElement[guid="' + dynImageLayoutElement.guid + '"] .tableOptions').css("display", "inline-block");
				if (dynImageElementItem)
					dynImageElementItem.content = "";
				DynamicImageSetup.eventUpdateDynamicImage(dynImageLayoutElement, args);
			}
		}
	}

	function getWordCloudForLayoutElementCompleted(args) {
		if (args) {
			var wordCloudLayoutElement = getLayoutElementByIdOrGuid(args.layoutElementGuid);
			var wordCloudElementItem = getElementItemByType(itemTypes.WORDCLOUD, wordCloudLayoutElement);

			if (wordCloudLayoutElement) {
				wordCloudLayoutElement.GUILoaded = true;
				wordCloudLayoutElement.UsesInputVariable = args.UsesInputVariable;
				if (wordCloudElementItem)
					wordCloudElementItem.content = "";
				WordCloudSetup.eventUpdateWordCloud(wordCloudLayoutElement, args);
			}
		}
	}

	function getSummaryForLayoutElementCompleted(args) {
		if (args) {
			var summaryLayoutElement = getLayoutElementByIdOrGuid(args.LayoutElementGuid);
			var summaryElementItem = getElementItemByType(itemTypes.SUMMARY, summaryLayoutElement);

			if (summaryLayoutElement) {
				summaryLayoutElement.GUILoaded = true;
				summaryLayoutElement.UsesInputVariable = args.UsesInputVariable;
				if (summaryElementItem)
					summaryElementItem.content = "";
				SummarySetup.eventUpdateSummary(summaryLayoutElement, args);
			}
		}
	}

	function getAdvancedAnalyticsForLayoutElementCompleted(args) {
		if (args) {
			var layoutElement = getLayoutElementByIdOrGuid(args.layoutElement.Guid);

			if (layoutElement) {
				layoutElement.GUILoaded = true;
				AdvancedAnalyticsSetup.eventUpdateAdvancedAnalytics(layoutElement, args);
			}
		}
	}

	function getEventCreatorForLayoutElementCompleted(args) {
		if (args) {
			// eventCreatorId is the same as layoutElementId
			var eventCreatorLayoutElement = getLayoutElementByIdOrGuid(args.EventCreatorID);
			var eventCreatorElementItem = getElementItemByType(itemTypes.EVENTCREATOR, eventCreatorLayoutElement);

			if (eventCreatorLayoutElement) {
				eventCreatorLayoutElement.GUILoaded = true;
				if (eventCreatorElementItem)
					eventCreatorElementItem.content = "";
				EventCreatorSetup.eventUpdateEventCreator(eventCreatorLayoutElement, args);
			}
		}
	}

    function getChartForLayoutElementCompleted(args) {
        contentCache[args.layoutElement.Guid] = args;

		var layoutElement = getLayoutElementByIdOrGuid(args.layoutElement.Guid);
        var connectedDetailTables = getDetailTablesForIDs(args.detailTables);

		if (layoutElement) {
			layoutElement.GUILoaded = true;
			layoutElement.UsesInputVariable = args.usesInputVariable;
		}

		if (getLayoutElementType(layoutElement) == Storyboard.Constants.itemTypes.SIMPLETABLE) {
			Storyboard.LayoutDesigner.eventUpdateSimpleTable(layoutElement);
		}
		else if (getLayoutElementType(layoutElement) == Storyboard.Constants.itemTypes.HEATMAP) {
			HeatMapRenderer.eventUpdateHeatMap(layoutElement, args);
		}
		else {
			if (layoutElement && !window.IsMyStories)
                layoutElement.hiddenChartSeries = [];

            if ((!Storyboard.LayoutDesigner.isAdmin || Helpers.isPreview()) && typeof (adjacentSlideChartsOnly) != 'undefined' && adjacentSlideChartsOnly) {
                var currentSlide = getCurrentSlide();
                var chartSlide = Storyboard.LayoutDesigner.getSlideByLayoutElement(layoutElement);
                if (Math.abs(chartSlide.slideIndex - currentSlide.slideIndex) <= 1)
                    Storyboard.LayoutDesigner.eventUpdateChart(layoutElement, connectedDetailTables);
            } else
				Storyboard.LayoutDesigner.eventUpdateChart(layoutElement, connectedDetailTables);
		}
	}

	function getDetailTablesForIDs(detailTableIds) {
		var dts = [], i = 0, j = 0;
		for (; detailTables && i < detailTables.length; i++) {
			for (j = 0; detailTableIds && j < detailTableIds.length; j++) {
				if (detailTables[i].tableId === detailTableIds[j].TableID)
					dts.push(detailTables[i]);
			}
		}
		return dts;
	}

	function getDetailTable(tableId, guid, callback, generalSettings) {
		//got a guid, need to find the layoutElemeent parent
		var i = 0, chartElem, layoutElement;
		for (; i < layoutElements.length; i++) {
			chartElem = getElementItemByType(itemTypes.CHART, layoutElements[i]);
			if (chartElem && chartElem.guid === guid) {
				layoutElement = layoutElements[i];
				break;
			}
		}

		var currentMyStorySlidePos = Helpers.getLayoutElementSlideIndex(layoutElement);
		var selectedMyStorySlideIDs = Helpers.getURLParameter('selectedMyStorySlideIDs');
		var currentMyStorySlideID = selectedMyStorySlideIDs ? selectedMyStorySlideIDs.split('|')[currentMyStorySlidePos - 1] : '';

		var data = {
			tableID: tableId,
			layoutElement: layoutElement,
			settings: generalSettings,
			currentMyStorySlidePos: currentMyStorySlidePos.toString(),
			currentMyStorySlideID: currentMyStorySlideID
		};
		Helpers.perfJSonCall({
			method: 'GetDetailTable',
			data: data,
			successCallback: callback,
			message: locale.get('Loading drilldown')
		});
	}

	function getDetailTableData(options, callback) {
		var selectedSettings = GeneralSettings.getSelectedSettings();
		Helpers.perfJSonCall({
			method: 'GetDetailTableData',
			data: {
				options: options,
				settings: selectedSettings
			},
			successCallback: callback
		});
	}

	function saveDUITableDesign(tableElementItem, duiData) {
		var layoutElement = Storyboard.LayoutDesigner.getLayoutElementByElementItem(tableElementItem);
		var layoutElementId = (!tableElementItem.layoutElementId || tableElementItem.layoutElementId == 0) ? layoutElement.guid : tableElementItem.layoutElementId;

		duiData = '{ "layoutElementId" : "' + layoutElementId + '", ' + duiData.substring(1);
		Helpers.perfJSonCall({
			method: 'SaveCrosstableFormatting',
			data: jQuery.parseJSON(duiData),
			message: locale.get('Saving table styles'),
			successCallback: SaveCrosstableFormattingCompleted
		});
	}

	function SaveCrosstableFormattingCompleted(args) {
		if (args) {
			$('#DUI-TD-BTN-SYS-CANCEL').click();
		}
	}

	function loadLayout(hasCallback) {
		layoutGrid = null;
		var showCharts = ($('.layoutElementAdmin', $('#layoutArea')).find('.highcharts-container').length > 0);
		Storyboard.LayoutDesigner.eventRedrawLayoutGrid(null); // Removes all layoutElements only

		var selectedMyStorySlideIDs = Helpers.getURLParameter('selectedMyStorySlideIDs');

		var params = {
			method: "LoadLayoutCoordinates",
			data: {
				showCharts: showCharts,
				selectedMyStorySlideIDs: selectedMyStorySlideIDs,
				showContinuousSlidesToFalse:false,
				defaultStoryTellerLoadingToAllSlides: false,
				continuousSlidesForExport: false
			},
			message: locale.get('Loading layout')
		};

        if (window.IsFormReport)
            params.data.respondentId = $('#ddlFormRespondents').val() || 0;
        else if (window.IsMyStories)
            params.data.storyId = $("#ddlMyStories").val() || 0;

        if (!hasCallback) {
            if (window.IsStoryboard) {
                params.successCallback = function (layoutInfo) {
                    function insertHashDataScript(id, hash, callback) {
                        var script = document.createElement("script");
                        script.id = id;
                        script.type = "text/javascript";
                        script.src = 'HashedDataHandler.ashx?hash=' + hash + "&callback=" + callback;
                        document.getElementsByTagName("head")[0].appendChild(script);
                    }

                    $(document).bind("DAPI.hashedLayoutGridLoaded", function () {
                        $(document).unbind("DAPI.hashedLayoutGridLoaded");
                        Storyboard.LayoutControls.hideLoadingBar();
                        layoutInfo.layoutGrid = Storyboard.LayoutDesigner.getLayoutGrid();
                        if (layoutInfo.hfilterVsVarSubsetsActive || Storyboard.GeneralSettings.hfilterVsFiltersActive) {
                            $.when(
                                GeneralSettings.fillVariableSubsetList(),
                                GeneralSettings.getFiltersConnectedToHFilters()
                            )
                            .then(function() {
                                layoutInfo.hFilterConnectionsLoaded = true;
                                Storyboard.LayoutDesigner.loadCoordinatesComplete(layoutInfo);
                            });
                        } else
                            loadCoordinatesComplete(layoutInfo);
                    });

                    $("#layoutGridCacheScript").remove();
                    Storyboard.LayoutControls.showLoadingBar(locale.get('Loading layout'));
                    insertHashDataScript("layoutGridCacheScript", layoutInfo.layoutHash, "Storyboard.LayoutDesigner.setLayoutGrid");
                }
            } else
                params.successCallback = loadCoordinatesComplete;
		}

		if (window.ContentType === Storyboard.Constants.itemTypes.CROSSTABLE) {
			Storyboard.Dependency.start(['CROSSTABLEREPORT', 'CROSSTABLESHEET'], 'LoadLayoutCoordinates');
		}

		return Helpers.perfJSonCall(params);
	}

	function createPageSizeObject(layoutGrid) {
		// this might be written by gui events in admin mode, but for rh view we never display the
		// layout type dropdown has therefore builds this as a default.
		pageSize = {
			width: layoutGrid.width,
			height: layoutGrid.height,
			pageCount: getPageCount(),
			layoutType: layoutGrid.layoutType
		};
	}

	function loadChartCreatorFavoriteComplete(favoriteLayout) {
		try {
			layoutGrid = favoriteLayout;
			layoutElements = favoriteLayout.layoutElements;
			layoutSlides = favoriteLayout.layoutSlides;
			createPageSizeObject(favoriteLayout);

			Storyboard.LayoutDesigner.eventRedrawLayoutGrid(layoutGrid);

			layoutGrid.layoutElements.sort(Helpers.sortZIndex);

			var i = 0, layoutElement, itemType;
			for (; i < layoutGrid.layoutSlides.length; i++) {
				addLayoutSlide(layoutGrid.layoutSlides[i], true);
			}

			for (i = 0; i < layoutGrid.layoutElements.length; i++) {
				layoutElement = layoutGrid.layoutElements[i];
				itemType = getLayoutElementType(layoutElement);
				addLayoutElement(layoutElement, itemType, true);
			}

			Storyboard.SlidesPanel.renderSlides();
			Storyboard.LayoutDesigner.setCurrentPageNo(1);
			getSlidesForReportComplete(layoutGrid.layoutSlides, false);

			if (layoutGrid.layoutElements.length > 0) {
				loadStorytellerContent();
			}
		} catch (e) {
			Helpers.logErr(e);
			alert(e);
			throw e;
		}
	}

	function toggleSharingOptions() {
		Storyboard.MyStories.toggleSharingOptions(ProjectHasUserGroups);
	}

	function loadCoordinatesComplete(layoutInfo) {
		Helpers.fixDotnetCasing(layoutInfo, ["hfilters", "storyboardAccess"]);
		if (layoutInfo.projectLanguages) {
			if (layoutInfo.useNewLanguageSelectionLayout) {
				GeneralSettings.bindProjectLanguagesNew(layoutInfo.projectLanguages);
			}
			else {
				GeneralSettings.bindProjectLanguages(layoutInfo.projectLanguages);
			}
		}
		Storyboard.LayoutDesigner.myStoriesSharingType = layoutInfo.settings.myStoriesSharingType;
		Storyboard.LayoutDesigner.enableMyStoriesSharing = layoutInfo.settings.enableMyStoriesSharing;

		Storyboard.LayoutDesigner.hfilterSlideExclusionEnabled = layoutInfo.hfilterSlideExclusionEnabled;
		Storyboard.LayoutDesigner.deviceLimitEnabled = layoutInfo.deviceLimitEnabled;
		Storyboard.LayoutDesigner.exportReportAsScreenshot = layoutInfo.settings.exportAsScreenshot;
		Storyboard.LayoutDesigner.hideSlideNavigationCurrentSlide = layoutInfo.settings.hideSlideNavigation;
		Storyboard.LayoutDesigner.hideSlideNavigation = layoutInfo.settings.hideSlideNavigation;
		Storyboard.LayoutDesigner.imageQuality = layoutInfo.settings.imageQuality;		
		
		Storyboard.LayoutDesigner.enableMasterSlideLayout = layoutInfo.settings.enableMasterSlideLayout;
		if (Storyboard.LayoutDesigner.isAdmin && !Helpers.isPreview() && window.ContentType !== itemTypes.CROSSTABLE) {
			Storyboard.LayoutDesigner.loadMasterLayoutThumbnailsInfo(false,true)
		}
		if (Storyboard.LayoutDesigner.isAdmin && layoutInfo.settings.defaultMasterLayoutId && window.ContentType !== itemTypes.CROSSTABLE){
			Storyboard.LayoutDesigner.defaultMasterLayoutId = layoutInfo.settings.defaultMasterLayoutId;
			Storyboard.LayoutDesigner.selectedMasterLayoutId = layoutInfo.settings.defaultMasterLayoutId;
			Storyboard.LayoutDesigner.masterLayoutFileName = layoutInfo.settings.masterLayoutFileName;
			Storyboard.LayoutDesigner.initMasterLayoutFileName = layoutInfo.settings.masterLayoutFileName;
			$('#divSTMasterLayoutSettingsWrapper #hidDefaultMasterLayoutId').val(layoutInfo.settings.defaultMasterLayoutId);
		}
		if (Storyboard.LayoutDesigner.isAdmin && !Helpers.isPreview()) {
			Storyboard.LayoutDesigner.initEnableMasterSlideLayout = Storyboard.LayoutDesigner.enableMasterSlideLayout
			Storyboard.LayoutDesigner.handleMasterLayoutSettingsVisibility(Storyboard.LayoutDesigner.enableMasterSlideLayout)
		}

		Storyboard.LayoutDesigner.setEnabledScreenTypes(layoutInfo.enabledScreenTypes);
		if (Storyboard.LayoutDesigner.isAdmin) {
			Storyboard.LayoutDesigner.setSupportedInPPT(layoutInfo.supportedPptTemplates);
			Storyboard.LayoutDesigner.setExportTemplates(layoutInfo.exportTemplates, layoutInfo.defaultExportTemplateId);
		}

		if (window.ContentType == itemTypes.CROSSTABLE && layoutInfo.useWideScreenMode) {
			document.getElementById("contentWrapper").style.width = '1280px';
			document.getElementById("contentWrapper").style.minHeight = '720px';
		}

		// CT2: no layout is this one
		if (window.ContentType == itemTypes.CROSSTABLE) {
			Storyboard.Dependency.complete(['CROSSTABLEREPORT', 'CROSSTABLESHEET'], 'LoadLayoutCoordinates');
			return;
		}

		Storyboard.LayoutDesigner.showBgInExportOnly = layoutInfo.settings.showBgInExportOnly;
		if (window.IsStoryboard) {
			Tokens.hideNoSelectionTokens = layoutInfo.hideNoSelectionTokens;
			Storyboard.LayoutDesigner.useNewNoDataLayout = layoutInfo.useNewNoDataLayout;
		}
		if (window.IsMyStories) Storyboard.LayoutDesigner.useNewNoDataLayout = layoutInfo.useNewNoDataLayout;
		Storyboard.ChartLab.Setup.settings = layoutInfo.chartlabSettings;
		if (layoutInfo.maxConcurrencyLevel)
			Helpers.ThrottleQueue.setStorytellerMaxConcurrencyLevel(layoutInfo.maxConcurrencyLevel);
		if (window.IsMyStories) {
			/*			BindStorySharingSettings();*/
			Storyboard.MyStories.bindSharingOptions(ProjectHasUserGroups);
			$('#chbSharedStories').unbind('change').bind('change', toggleSharingOptions);
		}

		try {
			// custom layout and print peview override showContinuousSlides
			if (!layoutInfo.settings.layoutType || (self != top && window.name == "print-frame"))
				layoutInfo.settings.showContinuousSlides = true;
			Storyboard.LayoutDesigner.slideShowMode = !layoutInfo.settings.showContinuousSlides;

			if (window.ContentType === Storyboard.Constants.itemTypes.CHART) {
				layoutInfo.settings.showSmartGuidelines = true;
				Storyboard.LayoutDesigner.showSmartGuideLines = layoutInfo.settings.showSmartGuidelines;
			}

			addLayoutGrid(layoutInfo);
			Storyboard.LayoutDesigner.eventRedrawLayoutGrid(layoutGrid);
			defaultExportFileName = layoutInfo.defaultExportFileName;
			canUserEditExportFileName = layoutInfo.editableExportFileName;
			exportEmailsEnabled = layoutInfo.exportEmailsEnabled;

			if (Storyboard.LayoutDesigner.isAdmin) {
				Storyboard.LayoutDesigner.updateUsageStats(layoutGrid.layoutElements.length);
				Storyboard.LayoutDesigner.maxLayoutElementsMessage();
				if (layoutInfo.settings.showBackgroundImage && (layoutInfo.settings.layoutType == 1 || layoutInfo.settings.layoutType == 4)) {
					$('#ddlShowPPTTemplate').attr("checked", "checked");
				} else {
					$('#ddlShowPPTTemplate').removeAttr("checked");
				}
				Storyboard.LayoutDesigner.gridSize = layoutInfo.settings.gridSize;
				switch (layoutInfo.settings.gridSize) {
					case 0:
						Storyboard.GuiEvents.toggleGridlines(0);
						$("#DUI_ST_R_SHOWGRIDLINES").removeClass('ribbonItemChecked');
						$("#DUI_ST_NOGRID").addClass('ribbonItemChecked');
						break;
					case 5:
						Storyboard.GuiEvents.toggleGridlines(5);
						$("#DUI_ST_R_SHOWGRIDLINES").addClass('ribbonItemChecked');
						$("#DUI_ST_5PX_GRID").addClass('ribbonItemChecked');
						break;
					case 10:
						Storyboard.GuiEvents.toggleGridlines(10);
						$("#DUI_ST_R_SHOWGRIDLINES").addClass('ribbonItemChecked');
						$("#DUI_ST_10PX_GRID").addClass('ribbonItemChecked');
						break;
					case 15:
						Storyboard.GuiEvents.toggleGridlines(15);
						$("#DUI_ST_R_SHOWGRIDLINES").addClass('ribbonItemChecked');
						$("#DUI_ST_15PX_GRID").addClass('ribbonItemChecked');
						break;
					default:
						Storyboard.GuiEvents.toggleGridlines(10);
						$("#DUI_ST_R_SHOWGRIDLINES").addClass('ribbonItemChecked');
						$("#DUI_ST_10PX_GRID").addClass('ribbonItemChecked');
				}

				if (layoutInfo.settings.snapToGrid) {
					$('#DUI-ST-SNAPTOGRID').addClass("ribbonItemChecked");
					Storyboard.LayoutDesigner.snapToGrid = layoutInfo.settings.snapToGrid;
				}

				if (layoutInfo.settings.activateEventServer) {
					$('#DUI-ST-R-ACTIVATE_EVENTSERVER').addClass("ribbonItemChecked");
					Storyboard.LayoutDesigner.activateEventServer = layoutInfo.settings.activateEventServer;
				}

				$('#ddlDefaultImageQuality').val(layoutInfo.settings.imageQuality);
				$('#cbHideOneReportPerFilter').attr('checked', layoutInfo.settings.hideOneReportPerFilter);

                //export type screenshot or regular
				$('#ddlExportType').val(layoutInfo.settings.exportAsScreenshot !== true ? 1 : 2);

				// native ppt only available on story creator and storyteller
				if (window.ContentType !== Storyboard.Constants.itemTypes.CHART && !window.IsMyStories && !window.IsStoryboard) {
                    $('#cbExportFormatPPTNative').closest(".settingItem").remove();
                }

				$('#hidApplyExportTypeToAllReports').val(layoutInfo.settings.exportAsScreenshot!==true?1:2);
				if (layoutInfo.settings.exportAsScreenshot === true) {
					$("#imgQualityDiv").hide();
				}
				else{
						$("#imgQualityDiv").show();
				}
				if (Storyboard.LayoutDesigner.getLayoutGrid().imageQualityDisplay) {
					$('#ddlImageQualityDisplay').attr("checked", "checked");
				} else {
					$('#ddlImageQualityDisplay').removeAttr("checked");
				}

				if (layoutInfo.settings.showFavoriteSettings) {
					$('#DUI_ST_R_FAVORITESETTINGS_ON').addClass('ribbonItemChecked');
				} else {
					$('#DUI_ST_R_FAVORITESETTINGS_OFF').addClass('ribbonItemChecked');
				}

				if (layoutInfo.settings.useAutoUpdate) {
					$('#DUI_ST_R_AUTOUPDATESETTINGS_ON').addClass('ribbonItemChecked');
				} else {
					$('#DUI_ST_R_AUTOUPDATESETTINGS_OFF').addClass('ribbonItemChecked');
				}

				$('#DUI-ST-SHOWBORDERS').toggleClass('ribbonItemChecked', layoutInfo.settings.showBorders);
				Storyboard.GuiEvents.toggleBorders(layoutInfo.settings.showBorders);

				$('#DUI-ST-SHOWSMARTGUIDELINES').toggleClass('ribbonItemChecked', layoutInfo.settings.showSmartGuidelines);
				Storyboard.LayoutDesigner.showSmartGuideLines = layoutInfo.settings.showSmartGuidelines;

				$('#btnSaveLayout, #btnSaveSTLayout').removeAttr('disabled');
				
				if (Storyboard.Elements && Storyboard.Elements.ReportEditorSidebar)
					Storyboard.Elements.ReportEditorSidebar.getElementById('save-layout').disabled = false;

				Storyboard.LayoutDesigner.initMasterLayoutTemplate();

			} else if (layoutInfo.settings.useAutoUpdate){
				$('#btnUpdateCharts').hide();
			}

			Storyboard.GuiEvents.toggleResultsTooltips(true);

			if (layoutInfo.enableResetFilterOption) {
				$(document).bind('DAPI.hFilterLoaded', Storyboard.GeneralSettings.initializeResetFiltersButton);
			}

            if (layoutInfo.settings.showFavoriteSettings)
                Storyboard.GeneralSettings.initializeFavoriteSettings();

			Storyboard.LayoutDesigner.useAutoUpdate = layoutInfo.settings.useAutoUpdate;
			Storyboard.LayoutDesigner.showFavoriteSettings = layoutInfo.settings.showFavoriteSettings;

			Storyboard.GuiEvents.toggleBackground((layoutInfo.settings.showBackgroundImage && (layoutInfo.settings.layoutType == 1 || layoutInfo.settings.layoutType == 4)));

			var tempCurrentPage = Helpers.getPageNoFromUrl() || Storyboard.LayoutDesigner.getCurrentPageNo();
			Storyboard.LayoutDesigner.setPageSize(Storyboard.GuiEvents.getLayoutSizeSelection(layoutInfo));
			var pageSize;
			// Form report window
			if (self !== top && (window.IsFormReport || window.IsDrilldown)) {
				var formIframe;
				if (window.IsFormReport)
					formIframe = $('.formReport', parent.document).last();
				else if (window.IsDrilldown)
					formIframe = $('#' + window.frameElement.id, parent.document);

				var formWindowBody = formIframe.parent();
				var formWindow = formWindowBody.parent();
				var formWindowOuter = formWindow.parent();

				pageSize = Storyboard.LayoutDesigner.getPageSize();

				parent.Storyboard.LayoutControls.hideLoadingBar();

				formWindow.css({ '-webkit-transition': 'none', 'transition': 'none' });
				if (window.IsFormReport)
					formWindowOuter.css('visibility', '');

				$('#layoutArea').parentsUntil('#form1').each(function() { $(this).css('width', pageSize.width); });
				$('html.loading').removeClass('loading');

				formWindow.css('width', pageSize.width + $(formWindowBody).outerWidth() - $(formWindowBody).width());
				formWindowBody.css('height', $('#storyboardContents').height());

				if (formWindow.height() >= $('body', parent.document).height() ||
					formWindow.width() >= $('body', parent.document).width()) {
					formWindowOuter.removeClass('DUI-WINDOW-CENTER');
				}

				formWindowOuter.css({'-webkit-overflow-scrolling': 'touch',	'overflow': 'auto'});
			}

			if (layoutInfo.settings.treeAsTabs)
				$('#DUI_ST_R_REPORTS_AS_TABS').addClass("ribbonItemChecked");

			if (layoutInfo.settings.hideSlideNavigation)
				$('#chbHideSlideNavigation').attr("checked", "checked");
			else
				$('#chbHideSlideNavigation').removeAttr("checked");

			layoutGrid.layoutElements.sort(Helpers.sortZIndex);

			var hfilterDef = $.Deferred();
			if (layoutInfo.settings.hFilterLayout && layoutInfo.settings.hFilterSelectionMode) {
				hFilterLayout = layoutInfo.settings.hFilterLayout;
				if (Storyboard.LayoutDesigner.isAdmin){
					Storyboard.LayoutDesigner.setHFilterLayoutAndReload(hFilterLayout, layoutInfo.settings.hFilterSelectionMode,
						layoutInfo.hFilterConnectionsLoaded, layoutInfo.hfilters ? layoutInfo.hfilters.HFilterNodes : null, layoutInfo.hfilters ? layoutInfo.hfilters.useCheckAllTree : null);
					hfilterDef.resolve();
				}
				else if (GeneralSettings)
					hfilterDef = GeneralSettings.reloadHFilter(hFilterLayout, layoutInfo.settings.hFilterSelectionMode, layoutInfo.hFilterConnectionsLoaded);

				$(document).trigger('DAPI.hFilterLoaded');
			}
			else hfilterDef.resolve();

			if (!Storyboard.LayoutDesigner.isAdmin ||
				Helpers.isPreview() ||
				(self != top && window.name == 'print-frame')) {
					$('#layoutArea').addClass('loading-excluded-slides');
					Storyboard.LayoutDesigner.loadExcludedSlides();
			}

			var i = 0, layoutElement, itemType;
			for (; i < layoutGrid.layoutSlides.length; i++) {
				addLayoutSlide(layoutGrid.layoutSlides[i], true);
			}
			Storyboard.GuiEvents.disableDeleteSlide();

			for (i = 0; i < layoutGrid.layoutElements.length; i++) {
				layoutElement = layoutGrid.layoutElements[i];
				itemType = getLayoutElementType(layoutElement);
				addLayoutElement(layoutElement, itemType, true);
			}

			Storyboard.GuiEvents.updateTemplatesMenu();

			// Prevent loading elements positioned in slides specified in window.slideToHideInCC (#12526)
			var isHeadlessChrome = /HeadlessChrome/.test(window.navigator.userAgent);
			if (isHeadlessChrome && typeof window.slideToHideInCC === 'object') {
				for (i = 0; i < layoutGrid.layoutElements.length; i++) {
					if (window.slideToHideInCC.includes(layoutGrid.layoutElements[i].slideIndex)) {
						$('#layoutArea .layoutElement[layoutElementId='+ layoutGrid.layoutElements[i].layoutElementId +'] .layoutElementItem').addClass('doNotReload');
					}
				}
			}

			var doNotTriggerContentLoadOnPageSet = false;
			if (layoutGrid.layoutElements.length > 0) {
				detailTables = layoutInfo.detailTables;

				// load all charts if we're in rh mode or the admin has clicked the update button and then reloaded the layout
				if (!window.IsFormReport && !(window.IsDrilldown && self !== top) && window.ContentType !== itemTypes.CHART && ((layoutInfo.showCharts || !Storyboard.LayoutDesigner.isAdmin) || (self != top && window.name == "print-frame"))) {
					if (!layoutInfo.settings.showContinuousSlides && tempCurrentPage <= Storyboard.LayoutDesigner.getPageCount())
						Storyboard.LayoutDesigner.setCurrentPageNo(tempCurrentPage);
					doNotTriggerContentLoadOnPageSet = true;
					$.when(hfilterDef).then(function () {
						loadStorytellerContent(layoutInfo.settings.showContinuousSlides);
					});
				} else if (window.IsDrilldown) {
					if (self != top && window.name == 'print-frame')
						loadStorytellerContent(layoutInfo.settings.showContinuousSlides);
					drilldownElementsLoaded = true;
					$(document).trigger('DAPI.drilldownElementsLoaded');
				}
			} else {
				sb.LayoutDesigner.allLayoutElementsLoaded = true;
				$(document).trigger('DAPI.allLayoutElementsLoaded');
				Storyboard.LayoutControls.hideLoadingBar();
            }

			if (window.ContentType === itemTypes.CHART) {
				var ccFilters = $('#deckFiltersPanel').detach();
				$("#singleObjectSetupPanel").append(ccFilters);

				var ccSettings = $("#tabholder_cc").detach();
				$("#singleObjectSetupPanel").append(ccSettings);
				ChartCreatorSetup.setupChartCreatorPanel();
				// no default template or empty - set up default layout
				if (layoutGrid.layoutId === 0 || layoutGrid.layoutElements.length === 0) {
					var layoutTemplateEnabledType = ChartCreatorSetup.getLayoutTemplateEnabledType();
					if (layoutTemplateEnabledType === 'enableLayoutTemplates') {
						ChartCreatorSetup.setupNewSlideLayout();
					} 
					if (layoutTemplateEnabledType === 'enableMasterSlideLayout') {
						ChartCreatorSetup.setupNewSlideMasterLayout();
					}
				} else if (layoutGrid.layoutElements.length > 0) {
					loadStorytellerContent();
				}
				ChartCreatorUI.enableDisableExportButton();
				ChartCreatorUI.enableDisableShareButton();
			}

			sb.GuiEvents.hideSlideNavigation(layoutInfo.settings.hideSlideNavigation);
			var slideNo = tempCurrentPage;
			var linkInfo;
			var linkElementId;
			var linkReportId;
			// react to link to different storyteller
			if ($.cookie('SBLink') && $.cookie('SBLink').indexOf('elementId:') > -1 && $.cookie('SBLink').indexOf('reportId') > -1) {
				linkInfo = $.cookie('SBLink').split('|');
				linkElementId = linkInfo[0].split(':')[1];
				linkReportId = linkInfo[1].split(':')[1];
				var slideIndex = Storyboard.LayoutDesigner.getSlideNoByLayoutElementId(linkElementId);
				if (Storyboard.LayoutDesigner.getLayoutGrid().reportId == linkReportId) {
					if (slideIndex > -1)
						slideNo = slideIndex;
				}
			}

			if (!($('.DUI-ST-NAVIGATOR-SLIDEHANDLER').hasClass('DUIslideNavigator')))
				Storyboard.LayoutDesigner.initSlideNavigation(layoutInfo.settings.showContinuousSlides, layoutInfo.settings.hideSlideNavigation, slideNo);
			else
				Storyboard.LayoutDesigner.setSlideshowMode(layoutInfo.settings.showContinuousSlides, layoutInfo.settings.hideSlideNavigation);

			// reselect current slide
			if (!layoutInfo.settings.showContinuousSlides && slideNo <= Storyboard.LayoutDesigner.getPageCount())
				Storyboard.LayoutDesigner.setCurrentPageNo(slideNo, doNotTriggerContentLoadOnPageSet);

			if (window.IsFormReport) {
				loadTokensCompleted(layoutInfo.formContent.tokens);
				$(document).trigger('DAPI.queueEmpty');
				getFormContentCompleted(layoutInfo.formContent.elementsData);
			}

			if (Storyboard.LayoutDesigner.isAdmin && window.ContentType < 0 && Storyboard.SlidesPanel && 
				window.StorybordSlidesPanel !== false && !(self != top && window.name == 'print-frame')) {
				if (localStorage.getItem('sidePanel-expanded') === null) {
					localStorage.setItem('sidePanel-expanded', 'true');
				}
				if (localStorage.getItem('sidePanel-expanded') == 'true') {
					Storyboard.SlidesPanel.openPanel();
				} else {
					Storyboard.SlidesPanel.SlidePanel.css('display', 'block').addClass('open');
					Storyboard.SlidesPanel.collapsePanel();
					Storyboard.SlidesPanel.renderSlides();
				}
			}

			// react to link to different storyteller
			if ($.cookie('SBLink') && $.cookie('SBLink').indexOf('elementId:') > -1 && $.cookie('SBLink').indexOf('reportId') > -1) {
				linkInfo = $.cookie('SBLink').split('|');
				linkElementId = linkInfo[0].split(':')[1];
				linkReportId = linkInfo[1].split(':')[1];

				if (Storyboard.LayoutDesigner.getLayoutGrid().reportId == linkReportId) {
					var relayToSlide = window.setInterval(function () {
						if (Storyboard.LayoutDesigner.setPageNoByLayoutElementId(linkElementId) > -1 && $('div.DUIslideNavigator').length > 0) {
							Storyboard.LayoutDesigner.scrollPageIntoLayoutElement(linkElementId);
							window.clearInterval(relayToSlide);
							$.cookie('SBLink', null);
						}
					}, 750);
				}
			}
			
			if (!window.IsFormReport && 
				!window.IsMyStories && 
				!window.IsDrilldown && 
				window.ContentType !== itemTypes.CHART && 
				!Storyboard.LayoutDesigner.isAdmin && 
				!Helpers.isPreview() && 
				!(self != top && window.name == "print-frame") &&
				!isHeadlessChrome) {
					startTrackingSlideViews();
			}

			$(document).trigger('DAPI.queueEmpty');
			Storyboard.EventBus.emit(Storyboard.Constants.Events.LOAD_COORDINATES_COMPLETE, layoutInfo);

			// if we got here via event server link with 'open form' thing
			Storyboard.LayoutDesigner.openFormReportFromLink();

			if (self != top && window.name == 'print-frame') {
				var allSlides = Storyboard.LayoutDesigner.getLayoutSlides();
				var slides = allSlides.filter(function (slide) { return !slide.isBackground; });
				var totalHeight = slides.reduce(function (acc, curr) { return acc + curr.height; }, 0);
				pageSize = Storyboard.LayoutDesigner.getPageSize();
				$('html').removeClass('admin').addClass('print');
				$('#layoutArea').parentsUntil('#form1').each(function () { $(this).css('width', pageSize.width); });
				totalHeight += slides.length * 20;
				$('#layoutArea').css('height', totalHeight);
				var formHeight = $('#form1').height();
				parent.document.getElementById("print-modal-content").height = (formHeight > 0 ? formHeight : $('#pageWrapper').height()) + "px";
			}
		}
		catch (e) {
			Helpers.logErr(e);
			alert(e);
			throw e;
		}
	}

	function loadExcludedSlides() {
		var allSlides = Storyboard.LayoutDesigner.getLayoutSlides();
		var slides = allSlides.filter(function(slide) { return !slide.isBackground; });
		var slideIds = slides.map(function(slide) { return slide.slideId; })
		
		selectedGeneralSettings = selectedGeneralSettings || GeneralSettings.getSelectedSettings();
		var HFilterSettings = GeneralSettings.getSettingByType(selectedGeneralSettings, Storyboard.Constants.SettingTypes.HFilter)

		if (HFilterSettings && HFilterSettings.SelectedSettings) {
			var selectedHFilterIds = HFilterSettings.SelectedSettings.split(',').map(Number);

			Helpers.perfJSonCall({
				method: 'GetSlidesExcludedByHFilterID',
				data: {
					'slideIds': slideIds,
					'selectedHFilterIds': selectedHFilterIds,
				},
				message: locale.get("Loading slide exclusions"),
				successCallback: function (data) {
					var prevExcludedSlides = excludedSlides.join(',');

					excludedSlides = data || [];

					window.slideIdToHideInSSExport = excludedSlides;
					window.slideIndexToHideInSSExport = excludedSlides.map(function(slideId) {
						var slide = Storyboard.LayoutDesigner.getSlideById(slideId);
						if (slide) {
							return slide.slideIndex;
						}
					});

					if (prevExcludedSlides !== excludedSlides.join(',')) {
						hideExcludedSlides();
					}

					$('#layoutArea').removeClass('loading-excluded-slides');
				}
			});
		} else {
			$('#layoutArea').removeClass('loading-excluded-slides');
		}
	}

	function hideExcludedSlides() {
		var allSlides = Storyboard.LayoutDesigner.getLayoutSlides(true);
		var slides = allSlides.filter(function(slide) { return !slide.isBackground; });
		var slideShowMode =  Storyboard.LayoutDesigner.slideShowMode;

		if (slideShowMode) {
			var currentSlideNo = Storyboard.LayoutDesigner.getCurrentPageNo();
			var currentSlide = Storyboard.LayoutDesigner.getSlideByIndex(currentSlideNo);
			
			// Adjust slides navigation
			var select = $('.DUI-ST-NAVIGATOR-SLIDEHANDLER');

			select.empty();

			if (slides.length == 0) {
				select.append('<option data-selected="true" value="1"></option>');
			}

			slides.forEach(function(slide) { delete slide.slideIndexIncluded; });
			slides
				.filter(function(slide) { return !excludedSlides.includes(slide.slideId); })
				.forEach(function(slide, index) {
					if (excludedSlides.length > 0) {
						slide.slideIndexIncluded = index + 1;
					}

					var selectedAttr = (currentSlide && currentSlide.slideIndex == slide.slideIndex) ? 'data-selected="true"' : '';

					select.append('<option value="' + slide.slideIndex + '" '+ selectedAttr +'>' +
							HTMLHelpers.htmlEncode(slide.slideName) + 
						'</option>');
				});

			select.DUIslideNavigator('update');

			$('.DUI-ST-NAVHOLDER .DUIslideNavigator_SelectBox > div').each(function(index) {
				$(this).children('input:first').val(index + 1);
			});
			$('.DUI-ST-NAVIGATOR-SLIDEHANDLER').DUIslideNavigator('select', [currentSlideNo]);
			$('.DUI-ST-NAVIGATOR-LASTSLIDE').text(getPageCount() - excludedSlides.length);

			// If the current slide is excluded go to the first previous available
			if (!currentSlide || excludedSlides.includes(currentSlide.slideId)) {
				var firstIncludedSlide = getIncludedSlideByDirection('previous') ||
										getIncludedSlideByDirection('first');
				if (firstIncludedSlide) {
					Storyboard.LayoutDesigner.setCurrentPageNo(firstIncludedSlide.slideIndex);
				} else {
					currentPageNo = 0;
					$(".layoutSlide").addClass("hidden");
				}
			}
		} else {
			var y = 0, totalHeight = 0;

			if (self != top && window.name == 'print-frame') {
				$('#layoutArea .pageBreakAfter').addClass('hidden');
			} else {
				$('#layoutArea .layoutSlide').addClass('hidden');
			}

			slides = slides.filter(function(slide) { return !excludedSlides.includes(slide.slideId); });

			slides.forEach(function(slide, index) {
				if (!slide.isBackground) {
					if (self != top && window.name == 'print-frame') {
						$("#" + slide.guid)
							.parent('.pageBreakAfter').removeClass("hidden")
							.find('.pageLabel > span').text('Page ' + (index + 1));
					} else {
						$("#" + slide.guid).css("top", y + "px").removeClass("hidden");
						y += slide.height;
					}
				}
			});

			totalHeight = slides.reduce(function(acc, curr) { return acc + curr.height; }, 0);

			if (self != top && window.name == 'print-frame') {
				totalHeight += slides.length * 20;
				$('#layoutArea').css('height', totalHeight);
				var formHeight = $('#form1').height();
				parent.document.getElementById("print-modal-content").height = (formHeight > 0 ? formHeight : $('#pageWrapper').height()) + "px";
			} else {
				$('#layoutArea').css('height', totalHeight);
			}
		}
	}

	function getIncludedSlideByDirection(action) {
		var currentSlide = Storyboard.LayoutDesigner.getCurrentSlide();
		var allSlides = Storyboard.LayoutDesigner.getLayoutSlides();
		var slides = allSlides.filter(function(slide) { return !slide.isBackground; });
		var availableSlides = slides.filter(function(slide) {
			return !excludedSlides.includes(slide.slideId);
		});

		if (action === 'first') {
			return availableSlides[0];
		} else if (action === 'previous') {
			if (!currentSlide) return null;
			return slides
				.slice(0, slides.indexOf(currentSlide))
				.reverse()
				.find(function(slide) {
					return !excludedSlides.includes(slide.slideId);
				});
		} else if (action === 'next') {
			if (!currentSlide) return null;
			return slides
				.slice(slides.indexOf(currentSlide) + 1, slides.length)
				.find(function(slide) {
					return !excludedSlides.includes(slide.slideId);
				});
		} else if (action === 'last') {
			return availableSlides[availableSlides.length - 1];
		}
	}

	function openFormReportFromLink() {
		if (self == top && window.IsStoryboard && !window.respondentRead) {
			var respondentId = Helpers.getURLParameter('respondent');

			var formId = Helpers.getURLParameter('formId');
			if (formId != null)
				formId = parseInt(formId, 10);
			else if ($('.layoutElementRespondentTable #hidRId').length > 0) // grab report id from first found link
				formId = $('.layoutElementRespondentTable #hidRId').first().val();

			if (respondentId != null && formId != null) {
				window.respondentRead = true;
				Helpers.perfJSonCall({
					data: {
						reportId: formId,
						respondentId: encodeURIComponent(respondentId)
					},
                    successCallback: function (result) {
                        if (result.isFormEditable && result.failedToLockRespondent) {
							Storyboard.LayoutControls.showMessage(locale.get('The Form just got locked by another user, please try again later.'));
                        } else {
                            RespondentTableSetup.openFormReport(result.url, null, result.elementsIds, result.isFormEditable, respondentId);
                        }
					},
					message: locale.get('Loading respondent form'),
					method: 'GetFormReportUrlAndElements',
					fixCasing: true
				});
			}
		}
	}

	function setSlideshowMode(showContinuousSlides) {
		$('#StorytellerPagesizeViewport').css('overflow', 'visible').css('height', 'auto');

		Storyboard.LayoutDesigner.slideShowMode = !showContinuousSlides;

		if (showContinuousSlides) {
			$("#slideFirst").click();
			$(".layoutSlide").removeClass("hidden");

			Storyboard.LayoutDesigner.setLayoutAreaSize();

			var printPreview = !window.IsFormReport && self != top && window.name == 'print-frame';
			var orderedSlides = Storyboard.LayoutDesigner.getLayoutSlides(true);
			var y = 0;
			for (var i = 0; i < orderedSlides.length; i++) {
				if (!orderedSlides[i].isBackground && !printPreview) {
					$("#" + orderedSlides[i].guid).css("top", y + "px");
					y += orderedSlides[i].height;
				}
			}

			Storyboard.GuiEvents.hideSlideNavigation(true);

			$("#DUI_ST_R_SLIDECOMMANDS").children('.ribbonItem').attr('disabled', 'disabled');
			$("#DUI_ST_R_PPTTEMPLATECOMMANDS").children('.ribbonItem').attr('disabled', 'disabled');

		} else {
			$(".layoutSlide").css("top", "0");
			if (Storyboard.LayoutDesigner.isAdmin && !Helpers.isPreview())
				Storyboard.GuiEvents.hideSlideNavigation(false);

			$("#slideFirst").click();

			$("#DUI_ST_R_SLIDECOMMANDS").children('.ribbonItem').removeAttr('disabled');
			$("#DUI_ST_R_PPTTEMPLATECOMMANDS").children('.ribbonItem').removeAttr('disabled');

			setTimeout(function () {				
				var slides = Storyboard.LayoutDesigner.getLayoutSlides(true);
				var defaultMasterLayoutId = Number($("#divSTMasterLayoutSettingsWrapper #hidDefaultMasterLayoutId").val())
			
				if(slides && slides.length && (Storyboard.LayoutDesigner.enableMasterSlideLayout || window.IsMyStories)){
					slides.forEach(function (slide) {
						if(slide && slide.guid){
							var templateLayoutID = slide.layoutTemplateId;
							if(!templateLayoutID && defaultMasterLayoutId){
								templateLayoutID = defaultMasterLayoutId
							}

							var layoutSlideEl = $(document.getElementById(slide.guid));
							if (!window.IsMyStories || (window.IsMyStories && slide.isEnabledMasterInSource)) {
								if (templateLayoutID) {
									layoutSlideEl.css('background-image', 'url(FileHandler.ashx?masterSlideLayoutId=' + templateLayoutID + '&background=true&v=1)');
								}
								else{
									layoutSlideEl.css('background-image', 'url(FileHandler.ashx?masterSlideLayoutId=' + defaultMasterLayoutId + '&background=true&v=1)');
								}
							}
						}
					})
				}
			},0)

		}
	}

	function initSlideNavigation(showContinuousSlides, hideNavigation, pageNo) {
		hideNavigation = ((Storyboard.LayoutDesigner.isMyStoryMode() || window.IsMyStories) && layoutSlides.length > 1) ? false : (hideNavigation || false);
		var navControls = $('#slideFirst, #slideBack, #slideNext, #slideLast');

		$(navControls).unbind();
		$(navControls).click(function () {
			var action = $(this).data('action');

			$('.layoutElementAdminFocused').find('.cancelEdit').click();
			Storyboard.GuiEvents.deselectAllBoxes();

			if (excludedSlides.length > 0) {
				var includedSlide = getIncludedSlideByDirection(action);
				if (includedSlide) {
					setCurrentPageNo(includedSlide.slideIndex);
				}
			} else {
				setCurrentPageNo(action);
			}
		});

		$('#DUI_ST_NAVIGATOR').click(function (evt) {
			Storyboard.GuiEvents.hideAllMenusAndPanels(evt);
		}).hide();

		getSlidesForReportComplete(layoutSlides, hideNavigation);
		setSlideshowMode(showContinuousSlides);
		setCurrentPageNo(pageNo);
		$(document).trigger('DAPI.slidesLoaded');

		if ((!Storyboard.LayoutDesigner.isAdmin || Helpers.isPreview()) && typeof (storytellerLoadType) != "undefined" && storytellerLoadType != Storyboard.Constants.ContentLoadType.All)
			$(document).bind("DAPI.setPageNo", function () {
                if (window.IsMyStories)
                    loadMyStoryContent();
				else if (!(window.IsDrilldown && self != top))
                    loadStorytellerContent();
            });
	}

	function updateSlideNavigation() {
		var select = $('.DUI-ST-NAVIGATOR-SLIDEHANDLER');
		select.children('option:selected').removeAttr('selected');
		select.DUIslideNavigator('destroy');
		var smartSelectOptions = {
			filter: true,
			numbering: true,
			width: 'auto',
			maxHeight: 408,
			editable: window.IsMyStories || (Storyboard.LayoutDesigner.isAdmin && !Helpers.isPreview()),
			sortable: window.IsMyStories || (Storyboard.LayoutDesigner.isAdmin && !Helpers.isPreview()),
			tooltip: locale.get('Select a slide to navigate to'),
			filterTooltip: locale.get('Filter slide names and numbers'),
			editTooltip: locale.get('Rename slide'),
			editableIcon: 'icons/018.png',
			editOriginalValue: '',
			dropdownclass: 'DUIslideNavigatorDropDown',
			filterclass: 'DUIslideNavigatorFilter'
		};

		select.DUIslideNavigator(smartSelectOptions);

		if (window.IsStoryboard) {
			select.bind('edited', function() {
				Storyboard.LayoutDesigner.setState(true);
			});
			select.bind('sorted', function(customEvent, event, ui) {
				var currentIndex = parseInt(ui.item.attr('data-value'), 10);
				var moveTo = ui.item.index() + 1;

				var movedToSlideNo = Storyboard.LayoutDesigner.moveSlide(currentIndex, moveTo);

				if (movedToSlideNo) {
					$('.DUI-ST-NAVHOLDER .DUIslideNavigator_SelectBox > div').each(function (index) {
						$(this).attr('data-value', index + 1);
						$(this).children('input:first').val($(this).attr('data-value'));
					});

					if (window.ContentType === Storyboard.Constants.itemTypes.CHART) {
						Storyboard.SlidesPanel.renderSlides();
					}

					Storyboard.LayoutDesigner.setCurrentPageNo(movedToSlideNo);
					Storyboard.LayoutDesigner.setState(true);
				}
			});
		} else if (window.IsMyStories) {
			select.unbind('edited').bind('edited', function(event, id, newValue, originalValue) {
				var slide = Storyboard.LayoutDesigner.getSlideByIndex(id)

				if (slide && newValue) {
					MyStoriesProxy.renameSlide(slide, newValue, function () {
						slide.slideName = newValue;
					});
				}
			});
			select.unbind('sorted').bind('sorted', function(customEvent, event, ui) {
				var currentIndex = parseInt(ui.item.attr('data-value'), 10);
				var moveTo = ui.item.index() + 1;

				var movedToSlideNo = Storyboard.LayoutDesigner.moveSlide(currentIndex, moveTo);

				if (movedToSlideNo) {
					var layoutSlides = Storyboard.LayoutDesigner.getLayoutSlides();
					var order = layoutSlides
						.sort(function(a, b) { return a.slideIndex - b.slideIndex; })
						.map(function(slide) { return slide.slideId; })

					MyStoriesProxy.saveSlidesOrder(order, function () {
						$('.DUI-ST-NAVHOLDER .DUIslideNavigator_SelectBox > div').each(function (index) {
							$(this).attr('data-value', index + 1);
							$(this).children('input:first').val($(this).attr('data-value'));
						});

						Storyboard.LayoutDesigner.setCurrentPageNo(movedToSlideNo);
					});
				}
			});
		}
	}

	function moveSlide(currentSlideNo, moveToSlideNo) {
		var maxSlides = Storyboard.LayoutDesigner.getPageCount();

		if (maxSlides === 1 || currentSlideNo === moveToSlideNo) {
			return false;
		}

		// Arrange unless certain conditions
		if (moveToSlideNo !== undefined || !isNaN(moveToSlideNo) || currentSlideNo !== moveToSlideNo || moveToSlideNo !== 0) {
			moveToSlideNo = (moveToSlideNo > maxSlides) ? maxSlides : moveToSlideNo; //Set the ceiling
			moveToSlideNo = (moveToSlideNo < 1) ? 1 : moveToSlideNo; //Set the floor

			var slides = Storyboard.LayoutDesigner.getLayoutSlides();
			var moveUp = moveToSlideNo > currentSlideNo;

			for (var i = 0; i < slides.length; i++) {
				if (slides[i].slideIndex == currentSlideNo)
					slides[i].slideIndex = moveToSlideNo;
				else if (moveUp && slides[i].slideIndex > currentSlideNo && slides[i].slideIndex <= moveToSlideNo)
					slides[i].slideIndex--;
				else if (!moveUp && slides[i].slideIndex >= moveToSlideNo && slides[i].slideIndex < currentSlideNo)
					slides[i].slideIndex++;
			}

			return moveToSlideNo;
		}
	}

	function getSlidesForReportComplete(slides, hideNavigation) {
		var curSelectedSlideIndex = Storyboard.LayoutDesigner.getCurrentPageNo();
		var select = $('.DUI-ST-NAVIGATOR-SLIDEHANDLER');

		select.DUIslideNavigator('destroy');
		select.html('');

		if (slides.length == 0) {
			select.append('<option data-selected="true" value="1"></option>');
		} else {
			slides.sort(function (s1, s2) { return (s1.slideIndex > s2.slideIndex) ? 1 : -1 });
		}

		for (var slide in slides)
			if (slides.hasOwnProperty(slide) && !slides[slide].isBackground) {
				var selectedOption = (slides[slide].slideIndex != curSelectedSlideIndex) ? '' : 'data-selected="true"';
				select.append('<option ' + selectedOption + ' value="' + slides[slide].slideIndex + '">' + HTMLHelpers.htmlEncode(slides[slide].slideName) + '</option>');
			}

		Storyboard.LayoutDesigner.updateSlideNavigation();

		Storyboard.LayoutDesigner.setCurrentPageNo(currentPageNo);
		$('#DUI_ST_NAVIGATOR').show();
		if (!hideNavigation || !Helpers.isPreview())
			$('div.DUI-ST-NAVHOLDER').show();
		Storyboard.GuiEvents.hideSlideNavigation(hideNavigation);
	}
	function addFilters(data) {

		let exportType = data.exporttype;
		let regularFiltersId = "#regularFilters" + exportType;

		if ($(regularFiltersId).length === 0) {
			$("#exportRegularFiltersPlaceholder")
				.replaceWith(`
            <fieldset id="exportRegularFilters" style="display: none">
                <legend>Create multiple exports based on selected filters</legend>
                <div id="regularFilters${exportType}"></div>
            </fieldset>
        `);
		}

		let selector = `#downloadableNodes${exportType}:visible`;

		if (!Storyboard.GeneralSettings.hasFilter() || $(selector).length === 0)
			return;

		var filters = document.querySelectorAll('select[id ^= "lbSetting_5"][separateExport="separateExport"]');
		var exportPanel = document.getElementById('regularFiltersPowerpoint');

		if (exportPanel)
			exportPanel.innerHTML = '';

		filters.forEach(filter => {
			var cloneParent = filter.parentElement.cloneNode(true);
			cloneParent.querySelectorAll('button').forEach(button => button.remove());
			$(cloneParent).find('[id^="spanCompare"]').remove();

			var selectFromSettingControl = cloneParent.querySelector('select');

			// Change the ID of the select element
			if (selectFromSettingControl) {
				selectFromSettingControl.id = selectFromSettingControl.id.replace(/^lbSetting_5/, 'exportlbSetting_5');
				selectFromSettingControl.setAttribute('multiple', 'multiple');
				//preserve selections
				selectFromSettingControl.querySelectorAll('option').forEach((option, index) => {
					option.selected = filter.options[index].selected;
				});
			}

			exportPanel.appendChild(cloneParent);
		})

		// Create and insert the checkbox
		const inputCheckbox = document.createElement('div');
		inputCheckbox.innerHTML = '<input id="chkSelectFilterForIterate" type="checkbox">';
		$(inputCheckbox).insertAfter('#regularFiltersPowerpoint .SettingsControl span[id^="lblName"]');

		// Display the parent element if it has children
		const regularFilters = $(`#regularFilters${data.exporttype}`);
		if (regularFilters.children().length > 0) {
			regularFilters.parent().css("display", "block");
		}

		// Add multiselection and disable buttons
		GeneralSettings.addMultiselection(true);
		$('#regularFiltersPowerpoint .SettingsControl button').addClass('ui-state-disabled');

		// code for disabling enabling the filter in export panel if the checkbox isn't checked for that filter
		$("#regularFiltersPowerpoint #chkSelectFilterForIterate").bind("click", function (evt) {

			const settingControl = $(evt.currentTarget).closest('.SettingsControl');
			const input = $(evt.currentTarget);
			const isChecked = input.is(':checked');

			const selectId = settingControl.find('select').attr('id').replace(/^export/, '');

			const desiredSelect = $('#' + selectId);
			const parentSettingsControl = desiredSelect.closest('#pnlSettingsPanel .SettingsControl');
			const settingType = parseInt(parentSettingsControl.find(".hidSettingType").val(), 10);

			if (isChecked) {
				if (settingType == 5)
					parentSettingsControl.find("button").addClass('ui-state-disabled').attr('disabled', 'disabled');

				settingControl.first().find('button').removeClass('ui-state-disabled');
				$("#regularFiltersPowerpoint #chkSelectFilterForIterate:not(:checked)").attr({ 'disabled': 'disabled', 'checked': false });
				$('#divSplitInBatches').show();
				$('#divBatchSize').toggle($('#chkSplitInBatches').is(':visible') && $('#chkSplitInBatches').attr("checked"));
				$('#chkSplitFilter').parent().hide();
			}
			else {
				if (settingType == 5)
					parentSettingsControl.find("button").removeClass('ui-state-disabled').removeAttr('disabled');
				
				$("#regularFiltersPowerpoint #chkSelectFilterForIterate").removeAttr('disabled');
				settingControl.first().find('button').addClass('ui-state-disabled');
				$('#chkSplitInBatches').removeAttr('checked', false);
				$('#divSplitInBatches, #divBatchSize').hide();
			}
		});
	}

	function addHFilters(data) {
		var selector = "#downloadableNodes" + data.exporttype + ":visible";

		if (!Storyboard.GeneralSettings.hasHFilter() || $(selector).length === 0)
			return;

		if ($("#downloadTree" + data.exporttype).length == 0) {
			$("#exportHFilterPlaceholder").replaceWith("<fieldset id=\"exportHFilter\" style=\"display: none\"><legend style =\"font-size:14px\">"
				+ locale.get("Filters") + "</legend><legend style=\"display:block; width:100%; padding:1% 0% 0% 2%\">Select hierarchy filter node</legend><div id='downloadTree"
				+ data.exporttype + "'></div></fieldset>");
		}

		var treeLayout = false;
		if ($("#downloadTree" + data.exporttype).children().length <= 0) {
			for (LID in Storyboard.Constants.HFilterLayouts) {
				if (Storyboard.Constants.HFilterLayouts.hasOwnProperty(LID)) {
					if (Storyboard.Constants.HFilterLayouts[LID] == Storyboard.LayoutDesigner.getHFilterLayout()) {
						switch (Storyboard.Constants.HFilterLayouts[LID]) {
							case 3:
							case 4:
								$("#downloadTree" + data.exporttype).hFilterControl("tree");
								treeLayout = true;
								break;
							case 1:
							case 2:
							default:
								$("#downloadTree" + data.exporttype).hFilterControl("listBox");
								break;
						}

						if ($("#downloadTree" + data.exporttype).children().length > 0)
							$("#downloadTree" + data.exporttype).parent().css("display", "block");
					}
				}
			}

			if (!isBulkHFilterExportEnabled()) {
				var $downloadtreeSelect = $("#downloadTree" + data.exporttype + " select");
				if ($downloadtreeSelect.attr('multiple') === 'multiple')
					$downloadtreeSelect.height(300);
				else
					$downloadtreeSelect.css('width', '100%')
			} else {
				$("#downloadTree" + data.exporttype + " select").height(300);
            }
			
			if ($("#downloadtree" + data.exporttype).children().length > 0 && treeLayout) {
					$("#downloadTree" + data.exporttype).before('<div><label for="chkSelectAllExportHF"><span>' + locale.get("Check all") + '</span></label><input id="chkSelectAllExportHF" type="checkbox"/></div>');
					$("#chkSelectAllExportHF").bind("click", function () {
						Storyboard.HFilterLayout.selectAllNodes($(this).is(":checked"), "#downloadTree" + data.exporttype);
					});
			}
		}

		if (Storyboard.HFilterLayout.hasHFilterNodes()) {
			Storyboard.HFilterLayout.setSelected(Storyboard.HFilterLayout.getSelectedIds("#hfilterTree"), "#downloadTree" + data.exporttype);
			if ($("#downloadTree" + data.exporttype).find('input:checked').length > 1) {
				$("#downloadTree" + data.exporttype).next().find('#chkSplitFilter').attr("checked", false);
			}

			if (Storyboard.HFilterLayout.getSelectedIds("#downloadTree" + data.exporttype, true).length < 1)
				$("#downloadSelectedPowerpoint, #downloadSelectedPPTExcel, #downloadSelectedPDF, #downloadSelectedNativePPT").attr("disabled", "disabled").attr("title", "Please select at least one hierarchical filter");
			else
				$("#downloadSelectedPowerpoint, #downloadSelectedPPTExcel, #downloadSelectedPDF, #downloadSelectedNativePPT").removeAttr("disabled").removeAttr("title");
		}
	}

	function isChartCreator() {
		return window.ContentType > 0 && window.ContentType === Storyboard.Constants.itemTypes.CHART;
	}

	function createDownloadPanel(data, storySettings) {
		DownloadArea.clearExportProgress();
		$("#chkSelectAllExportHF").removeAttr("checked");

		selectedGeneralSettings = selectedGeneralSettings || GeneralSettings.getSelectedSettings();
		var pageSize = Storyboard.LayoutDesigner.getPageSize();
		var containerId = "downloadableNodes" + data.exporttype;
		var downloadButtonId = "btnOpenExportPanel";
		//excelExport options
		var formats = Storyboard.Constants.documentFormats;
		var isStoryCreator = isChartCreator();

		var showExcelExport;
		var showPdfExport;
		var showPptExport;
        var showNativePptExport;

		if (storySettings) {
			showExcelExport = storySettings.excelOption > 0;
			showPdfExport = storySettings.pdfExport > 0;
			showPptExport = storySettings.pptExport > 0 &&
				(storySettings.layoutType == formats.PPTONLINE.hash || storySettings.layoutType == formats.PPT_16_9.hash || storySettings.layoutType == formats.CUSTOM.hash);
            showNativePptExport = storySettings.pptNativeExport > 0 &&
				(storySettings.layoutType == formats.PPTONLINE.hash || storySettings.layoutType == formats.PPT_16_9.hash || storySettings.layoutType == formats.CUSTOM.hash);
			exportReportAsScreenshot = storySettings.exportAsScreenshot;
		} else {
			showExcelExport = !window.IsFormReport && Storyboard.LayoutDesigner.getExportOptions().excelExport > 0;
			showPdfExport = Storyboard.LayoutDesigner.getExportOptions().pdfExport > 0;
			showPptExport = Storyboard.LayoutDesigner.getExportOptions().pptExport > 0 &&
				(Storyboard.LayoutDesigner.getLayoutGrid().layoutType == formats.PPTONLINE.hash || Storyboard.LayoutDesigner.getLayoutGrid().layoutType == formats.PPT_16_9.hash || Storyboard.LayoutDesigner.getLayoutGrid().layoutType == formats.CUSTOM.hash);
            showNativePptExport = Storyboard.LayoutDesigner.getExportOptions().pptNativeExport > 0 &&
				(Storyboard.LayoutDesigner.getLayoutGrid().layoutType == formats.PPTONLINE.hash || Storyboard.LayoutDesigner.getLayoutGrid().layoutType == formats.PPT_16_9.hash || Storyboard.LayoutDesigner.getLayoutGrid().layoutType == formats.CUSTOM.hash);
			exportReportAsScreenshot = Storyboard.LayoutDesigner.exportReportAsScreenshot;
		}

		var elements = 'div, input, select, button';

		var downloadInputID = "downloadSelected" + data.exporttype;
		var hft;
		if ($("#" + containerId).length == 0) {
			if ($(".downloadcontainer:visible").length != 0)
				$(".downloadcontainer").css("display", "none");
			else {
				//Disable hfilter controls in main filter list
				hft = $('#hfilterTree');
				if (hft.children('.DUITreeView').length > 0) {
					if (hft.children('.DUITreeView').hasClass('DUITreeCompact-expanded')) {
						hft.children('.DUITreeView').removeClass('DUITreeCompact-expanded');
					}

					hft.find(elements).each(function () {
						if ($(this).is('button') && $(this).hasClass('DUITreeCompactButton')) {
							$(this).addClass('ui-state-disabled');
							$(this).attr('disabled', 'disabled');
						}
					});
				}
				else if (hft.children('.hfilter_multibox').length > 0)
				{
					hft.find(elements).each(function () {
						if ($(this).is('input') && $(this).hasClass('DUIsmartSelectBoxFilter')) {
							$(this).attr('disabled', 'disabled');
						}
						else if ($(this).is('div') && $(this).hasClass('hfilter_multibox')) {
							$(this).css('pointer-events', 'none');
							$(this).addClass('ui-state-disabled');
                        }
					});

                }
				else
				{
					hft.find(elements).each(function () {
						$(this).attr('disabled', 'disabled');
						$(this).multiselect('disable');
					})
				}
			}
			$("#" + downloadButtonId).parent().append('<div id="' + containerId + '" class="downloadcontainer DUI-OptionsPopup"><h4 class="DUI-OptionsPopup-title downloadcontainertitle">' + locale.get("Export", 1) + '</h4></div>');

			if (pageSize.width < 400)
				$(".downloadcontainer").css('max-width', function() {
					return pageSize.width - ($(this).outerWidth() - $(this).width());
				});

			$("#" + containerId).append('<input type="hidden" id="hidStoryIdToExport"/>');

			$("#" + containerId).append('<fieldset id="downloadImageQualitySettings"><legend>' + locale.get("Chart image quality") + '</legend>' +
				'<select id="downloadPPTImageQuality" multiple="multiple"><option value="5">' + locale.get("High") + '</option><option value="3">' + locale.get("Medium") + '</option><option value="1">' + locale.get("Low") + '</option></select></fieldset>');
			$('#downloadPPTImageQuality').val(Storyboard.LayoutDesigner.getLayoutGrid().imageQuality);
			$('#downloadPPTImageQuality').multiselect({
				multiple: false,
				header: false,
				noneSelectedText: false,
				selectedList: 1
			});

			if ($("#txtExportFileName").length < 1)
				$(".downloadcontainer").append('<fieldset id="exportFileName"><legend>' + locale.get("Filename", 1) + '</legend><input type="text" id="txtExportFileName"/></fieldset>');
			$("#exportFileName").css("display", canUserEditExportFileName ? "" : "none");

			$(".downloadcontainer").append('<div id="exportHFilterPlaceholder"></div>');

			$(".downloadcontainer").append('<div id="exportRegularFiltersPlaceholder"></div>');

			if (!isStoryCreator) {
				$(".downloadcontainer").append(
					'<div style="display: none;"><label for="chkSplitFilter"><span>' + locale.get("One report per filter") + '</span></label><input id="chkSplitFilter" checked="checked" type="checkbox"/></div>' +
					'<div id="divSplitInBatches" style="display: none;"><label for="chkSplitInBatches"><span>' + locale.get("Split up in batches") + '</span></label><input id="chkSplitInBatches" type="checkbox"/></div>' +
					'<div id="divBatchSize" style="display: none;"><label for="txtBatchSize"><span>' + locale.get("Number of reports per batch") + '</span></label><input id="txtBatchSize" type="text" value="50" style="width:32px;"/></div>');

				Helpers.setupNumericTextbox($("#txtBatchSize"));

				$('#chkSplitFilter').bind('click', function () {
					if ($('#chkSplitFilter').is(':visible') && $('#chkSplitFilter').attr("checked")) {
						$('#divSplitInBatches').show();
						$('#divBatchSize').toggle($('#chkSplitInBatches').is(':visible') && $('#chkSplitInBatches').attr("checked"));
						$('#regularFiltersPowerpoint .SettingsControl').find('button').addClass('ui-state-disabled');
						$('#regularFiltersPowerpoint .SettingsControl #chkSelectFilterForIterate').attr({ 'disabled': 'disabled', 'checked': false });
					} else {
						$('#chkSplitInBatches').removeAttr('checked', false);
						$('#divSplitInBatches, #divBatchSize').hide();
						$('#regularFiltersPowerpoint .SettingsControl #chkSelectFilterForIterate').removeAttr('disabled');
					}
				});

				$('#chkSplitInBatches').bind('click', function () {
					$('#divBatchSize').toggle($('#chkSplitInBatches').is(':visible') && $('#chkSplitInBatches').attr("checked"));
				});
			}
			
			if ($("#cbSendEmailNotification").length < 1 )
				$(".downloadcontainer").append('<div id="exportEmailNotification"><label for="cbSendEmailNotification">' +
                    locale.get('Send email notification:', 1) + '</legend><input type="checkbox" id="cbSendEmailNotification"/></div>');
			$("#exportEmailNotification").css("display", exportEmailsEnabled ? "" : "none");

			if (!Storyboard.LayoutDesigner.getLayoutGrid().imageQualityDisplay)
				$('#downloadPPTImageQuality').parent().hide();

			if (!showPptExport && !showPdfExport)
				$('#downloadImageQualitySettings').hide();

			$("#" + containerId).append('<fieldset id="downloadButtons"></fieldset>');


			var pptImagesLanguageKey = isStoryCreator || showNativePptExport ? 'Generate PPT report as images' : 'Generate PPT report';

			$("#downloadButtons", "#" + containerId).append(
				'<input type="button" class="downloadButton DUIButtonGray" id="' + downloadInputID + '" value="' + locale.get(pptImagesLanguageKey) + '"/>');

			$('#downloadSelectedPowerpoint').val(locale.get(pptImagesLanguageKey));
			$('#downloadSelectedExcel').val(locale.get('Generate Excel report'));
			if (data.exporttype == 'Powerpoint') {
				$("#downloadButtons", "#" + containerId).append(
					'<input type="button" class="downloadButton DUIButtonGray" id="downloadSelectedNativePPT" value="' + locale.get('Generate PPT report as editable objects') + '"/>');
				$("#downloadButtons", "#" + containerId).append(
					'<input type="button" class="downloadButton DUIButtonGray" id="downloadSelectedPDF" value="' + locale.get('Generate PDF report') + '"/>');
				$("#downloadButtons", "#" + containerId).append(
					'<input type="button" class="downloadButton DUIButtonGray" id="downloadSelectedPPTExcel" value="' + locale.get('Generate Excel report') + '"/>');
			}

			$("#" + containerId).append('<div id="downloadReports' + data.exporttype + '" style="clear:both;"></div>');

			$("#" + containerId).prepend('<div id="close_' + downloadInputID + '" class="DUI-OptionsPopup-close" title="' + locale.get('Close this panel') + '"><i class="icon-close">&#215;</i></div>');
			$('#downloadPPTImageQuality').multiselect({
				multiple: false,
				header: false,
				noneSelectedText: false,
				selectedList: 1
			});

            $("#" + downloadInputID + ", #downloadSelectedPDF, #downloadSelectedNativePPT").bind("click", function () {
				if (!sb.LayoutDesigner.checkFilterSelection({isExportPanel:true}))
					return;

				var treeID = "#downloadTree" + data.exporttype;
				var DUITreeViewEl = $(treeID).find('.DUITreeView');
                var settings = DUITreeViewEl.length > 0 ? $(DUITreeViewEl).data('DUITreeView').settings : {};
				var selectedHFilters = Storyboard.HFilterLayout.getSelectedIds(treeID, true);
				var selectedRegularFilters = GeneralSettings.getSelectedIterateFilters();
				selectedRegularFilters = selectedRegularFilters !== "" ? selectedRegularFilters.split(',') : [""];
				var splitByRegularFilters = selectedRegularFilters.length > 0 && selectedRegularFilters != ""
				var allHFilters = $("#chkSelectAllExportHF").length > 0 && 
									$("#chkSelectAllExportHF").is(":checked") && 
									settings.search !== true;
				Storyboard.LayoutDesigner.clearElementContent(itemTypes.RESPONDENTTABLE);
				var selectedMyStorySlideIDs = Helpers.getURLParameter('selectedMyStorySlideIDs');

				if (!selectedMyStorySlideIDs)
					selectedMyStorySlideIDs = '';

				var isSplitFilter = false;
				if (isBulkHFilterExportEnabled() && selectedHFilters.length > 0 && $("#chkSplitFilter").length > 0 && !splitByRegularFilters)
					isSplitFilter = $("#chkSplitFilter").attr("checked");

				var exportInBatches = (isSplitFilter || splitByRegularFilters) && $("#chkSplitInBatches").attr("checked");
				var exportBatchSize = parseInt($('#txtBatchSize').val(), 10) || 0;

                var exportType = $(this).attr("id") == "downloadSelectedPDF" ? 3 : 1;// 3 - pdf, 1- ppt

                if ($(this).attr("id") == "downloadSelectedNativePPT") {
                    exportType = 8;
                }
				var calldata;
				var downloadParams;
				if (data.exporttype == 'Powerpoint') {

					var layoutGrid = Storyboard.LayoutDesigner.getLayoutGrid();
					//var exportOptions = Storyboard.LayoutDesigner.getExportOptions();
					var formats = Storyboard.Constants.documentFormats;
					var docFormat = formats.getDocFormat(layoutGrid.layoutType);

					var exportAsScreenshotQuality = 3;
					switch (parseInt(Storyboard.LayoutDesigner.imageQuality,10)) {
						case 5:
							exportAsScreenshotQuality = 3;
							break;
						case 3: exportAsScreenshotQuality = 2;
							break;
						case 1: exportAsScreenshotQuality = 1;
							break;
					}

					calldata = {
						selectedHFilterNodes: selectedHFilters,
						generalSettings: GeneralSettings.getSelectedSettings(),
						layout: getLayoutGrid(),
						splitFilters: isSplitFilter,
						imageQuality: $('#downloadPPTImageQuality').val() || 3,
						currentSlide: Storyboard.LayoutDesigner.getCurrentPageNo(),
						isAdmin: Storyboard.LayoutDesigner.isAdmin,
						selectedMyStorySlideIDs: selectedMyStorySlideIDs,
                        exportType: exportType,
                        exportAsScreenshot: exportReportAsScreenshot,
						respondentId: window.IsFormReport ? $('#ddlFormRespondents').val() : 0,
						fileName: $("#txtExportFileName").val() || "default",
						timeZoneOffset: new Date().getTimezoneOffset(),
						sendEmailNotification: exportEmailsEnabled && $("#cbSendEmailNotification").is(":checked"),
						allHFilters: allHFilters,
                        storyId: window.IsMyStories ? $("#ddlMyStories").val() : $("#hidStoryIdToExport").val(),
                        hiddenSeries: Storyboard.LayoutDesigner.getHiddenSeries(),
                        respTablesFilterInfo: Storyboard.LayoutDesigner.getRespTablesSelectedVariablesInfo(),
						settings: GeneralSettings.getSelectedSettings(),
						reportid: Helpers.getReportID(),
						qualityMultiplier:exportAsScreenshotQuality,
						docFormatWidth: docFormat.layoutWidth,
						docFormatHeight: docFormat.layoutHeight,
						customExportData: window.customExportData || {},
						exportInBatches: exportInBatches,
						exportBatchSize: exportBatchSize,
						selectedFilters: selectedRegularFilters,
						splitByRegularFilters: splitByRegularFilters
					};
					downloadParams = {
                        method: "QueuePPTPDFExport",
						data: calldata,
						successCallback: function (res) { downloadedSuccess(res, data.exporttype, exportType == 1 ? 'PPT' : 'PDF') },
						failCallback: downloadFailed
					};
					if (!window.IsMyStories && calldata.storyId > 0) {
						downloadParams.forceMyStoriesUrl = true;
						delete downloadParams.data.layout;
					}

					if (window.ContentType > 0 && window.ContentType === Storyboard.Constants.itemTypes.CHART) {
						ChartCreatorDataCom.StoreDataGroup()
							.then(function () {
								queueExport(downloadParams);
								showExportStartedMessage();
							});
					} else
						queueExport(downloadParams);

				}
				if (data.exporttype == 'Excel') {
					calldata = {
						layout: getLayoutGrid(),
						selectedHFilterNodes: selectedHFilters,
						settings: GeneralSettings.getSelectedSettings(),
						splitFilters: isSplitFilter,
						currentSlide: Storyboard.LayoutDesigner.getCurrentPageNo(),
						isAdmin: Storyboard.LayoutDesigner.isAdmin,
						selectedMyStorySlideIDs: selectedMyStorySlideIDs,
						fileName: $("#txtExportFileName").val() || "default",
						timeZoneOffset: new Date().getTimezoneOffset(),
						sendEmailNotification: exportEmailsEnabled && $("#cbSendEmailNotification").is(":checked"),
                        allHFilters: allHFilters,
						storyId: window.IsMyStories ? $("#ddlMyStories").val() : $("#hidStoryIdToExport").val(),
						customExportData: window.customExportData || {},
						exportInBatches: exportInBatches,
						exportBatchSize: exportBatchSize,
						selectedFilters: selectedRegularFilters,
						splitByRegularFilters: selectedRegularFilters.length > 0 && selectedRegularFilters != ""
					};
					downloadParams = {
						method: "QueueExcelExport",
						data: calldata, successCallback:
						function (res) { downloadedSuccess(res, data.exporttype, 'Excel') },
						failCallback: downloadFailed
					};
					if (!window.IsMyStories && calldata.storyId > 0) {
						downloadParams.forceMyStoriesUrl = true;
						delete downloadParams.data.layout;
					}

					if (window.ContentType === Storyboard.Constants.itemTypes.CHART) {
						ChartCreatorDataCom.StoreDataGroup()
							.then(function() {
								queueExport(downloadParams);
								showExportStartedMessage();
							});
					} else {
						queueExport(downloadParams);
					}
				}

				$(this).attr("disabled", true);
				if (typeof (customExportNotification) != 'undefined')
					$("body").append(customExportNotification);
				$("#btnOpenExportPanel").append('<img src="images/spinner.gif" style="width:12px;height:12px;padding-left:5px;" alt="' + locale.get('Loading') + '"/>');

				// restore respondent tables' content
				var respTableElements = getLayoutElementsByType(itemTypes.RESPONDENTTABLE);
				$(respTableElements).each(function () {
					var tableDiv = $(".layoutElement[guid='" + this.guid + "']").find(".layoutElementRespondentTable")[0];
					RespondentTableSetup.saveRespondentTableHtml(tableDiv, getElementItemByType(itemTypes.RESPONDENTTABLE, this));
				});
			});

			if (data.exporttype == 'Powerpoint' && showExcelExport) {
				$("#downloadSelectedPPTExcel").bind("click", function () {
					if (!sb.LayoutDesigner.checkFilterSelection({isExportPanel:true}))
						return;

					var treeID = "#downloadTree" + data.exporttype;
					var DUITreeViewEl = $(treeID).find('.DUITreeView');
                    var settings = DUITreeViewEl.length > 0 ? $(DUITreeViewEl).data('DUITreeView').settings : {};
					var selectedHFilters = Storyboard.HFilterLayout.getSelectedIds(treeID, true);
					var allHFilters = $("#chkSelectAllExportHF").length > 0 && 
									  $("#chkSelectAllExportHF").is(":checked") && 
									   settings.search !== true;
					var selectedRegularFilters = GeneralSettings.getSelectedIterateFilters();
					selectedRegularFilters = selectedRegularFilters !== "" ? selectedRegularFilters.split(',') : [""];
					var splitByRegularFilters = selectedRegularFilters.length > 0 && selectedRegularFilters != ""
					Storyboard.LayoutDesigner.clearElementContent(itemTypes.RESPONDENTTABLE);
					var selectedMyStorySlideIDs = Helpers.getURLParameter('selectedMyStorySlideIDs');

					if (!selectedMyStorySlideIDs)
						selectedMyStorySlideIDs = '';

					var isSplitFilter = false;
					if (selectedHFilters.length > 0 && $("#chkSplitFilter").length > 0 && !splitByRegularFilters)
						isSplitFilter = $("#chkSplitFilter").attr("checked");

					var exportInBatches = isSplitFilter && $("#chkSplitInBatches").attr("checked");
					var exportBatchSize = parseInt($('#txtBatchSize').val(), 10) || 0;

					var calldata = {
						layout: getLayoutGrid(),
						selectedHFilterNodes: selectedHFilters,
						settings: GeneralSettings.getSelectedSettings(),
						splitFilters: isSplitFilter,
						currentSlide: Storyboard.LayoutDesigner.getCurrentPageNo(),
						isAdmin: Storyboard.LayoutDesigner.isAdmin,
						selectedMyStorySlideIDs: selectedMyStorySlideIDs,
						fileName: $("#txtExportFileName").val() || "default",
						timeZoneOffset: new Date().getTimezoneOffset(),
						sendEmailNotification: exportEmailsEnabled && $("#cbSendEmailNotification").is(":checked"),
                        allHFilters: allHFilters,
						storyId: window.IsMyStories ? $("#ddlMyStories").val() : $("#hidStoryIdToExport").val(),
						customExportData: window.customExportData || {},
						exportInBatches: exportInBatches,
						exportBatchSize: exportBatchSize,
						selectedFilters: selectedRegularFilters,
						splitByRegularFilters: splitByRegularFilters
					};
					var downloadParams = {
                        method: "QueueExcelExport",
						data: calldata, successCallback:
						function (res) { downloadedSuccess(res, data.exporttype, 'Excel') },
						failCallback: downloadFailed
					};
					if (!window.IsMyStories && calldata.storyId > 0) {
						downloadParams.forceMyStoriesUrl = true;
						delete downloadParams.data.layout;
					}
					queueExport(downloadParams);
					if (window.ContentType === Storyboard.Constants.itemTypes.CHART)
						showExportStartedMessage();

					$(this).attr("disabled", true);
					if (typeof (customExportNotification) != 'undefined')
						$("body").append(customExportNotification);
					$("#btnOpenExportPanel").append('<img src="images/spinner.gif" style="width:12px;height:12px;padding-left:5px;" alt="' + locale.get('Loading') + '"/>');

					// restore respondent tables' content
					var respTableElements = getLayoutElementsByType(itemTypes.RESPONDENTTABLE);
					$(respTableElements).each(function () {
						var tableDiv = $(".layoutElement[guid='" + this.guid + "']").find(".layoutElementRespondentTable")[0];
						RespondentTableSetup.saveRespondentTableHtml(tableDiv, getElementItemByType(itemTypes.RESPONDENTTABLE, this));
					});
				});
			}

			$("#close_" + downloadInputID + "").bind("click", function () {
				Storyboard.HFilterLayout.MainTree.set('#hfilterTree');
				$("#" + containerId).css("display", "none");
				//Enable hfilter controls in main filter list
				var hft = $(Storyboard.HFilterLayout.MainTree.get());
				if (hft.children('.DUITreeView').length < 1 && hft.children('.hfilter_multibox').length < 1) {
					hft.find(elements).each(function () {
						$(this).removeAttr('disabled');
						$(this).multiselect('enable');
					})
				}
				else if (hft.children('.hfilter_multibox').length > 0) {
					hft.find(elements).each(function () {
						if ($(this).is('input') && $(this).hasClass('DUIsmartSelectBoxFilter')) {
							$(this).removeAttr('disabled');
						}
						else if ($(this).is('div') && $(this).hasClass('hfilter_multibox')) {
							$(this).css('pointer-events', 'auto');
							$(this).removeClass('ui-state-disabled');
						}
					});

				}
				else
				{
					hft.find(elements).each(function () {
						if ($(this).is('button') && $(this).hasClass('DUITreeCompactButton')) {
							$(this).removeClass('ui-state-disabled');
							$(this).removeAttr('disabled');
						}
					});
				}
				//enable filters in ST when closing export panel on X button
				$("#pnlSettingsPanel .SettingsControl").each(function () {
					var settingType = parseInt($(this).find(".hidSettingType").val(), 10);

					if (settingType == 5) {
						if ($(this).find("select").attr('separateExport') !== undefined) {
							$(this).find("button").removeClass('ui-state-disabled');
							$(this).find("button").removeAttr('disabled');
						}}});

				// make the panel go away
				$("#pageWrapper").trigger("click");
			});

			// put latest export at the bottom of export panel
			$("#divDownloadArea #close_downloadArea").hide();
			$("#divDownloadArea")
				.removeClass("DUI-OptionsPopup")
				.css({"display": "", "margin-top": "1em"})
				.appendTo($(".downloadcontainer"));

			$("#" + containerId).draggable({
				cancel: 'input,textarea,button,select,option,.DUITreeView,.DAExportsContainer'
			});
		}
		else {
			// when the export div is already present on web page
			if ($(".downloadcontainer:visible").length == 0) {
				//Disable hfilter controls in main filter list
				hft = $('#hfilterTree');
				if (hft.children('.DUITreeView').length > 0) {
					if (hft.children('.DUITreeView').hasClass('DUITreeCompact-expanded')) {
						hft.children('.DUITreeView').removeClass('DUITreeCompact-expanded');
					}

					hft.find(elements).each(function () {
						if ($(this).is('button') && $(this).hasClass('DUITreeCompactButton')) {
							$(this).addClass('ui-state-disabled');
							$(this).attr('disabled', 'disabled');
						}
					});
				}
				else if (hft.children('.hfilter_multibox').length > 0) {
					hft.find(elements).each(function () {
						if ($(this).is('input') && $(this).hasClass('DUIsmartSelectBoxFilter')) {
							$(this).attr('disabled', 'disabled');
						}
						else if ($(this).is('div') && $(this).hasClass('hfilter_multibox')) {
							$(this).css('pointer-events', 'none');
							$(this).addClass('ui-state-disabled');
						}
					});

				}
				else
				{
					hft.find(elements).each(function () {
						$(this).attr('disabled', 'disabled');
						$(this).multiselect('disable');
					})
				}
				
				$("#" + containerId).css("display", "");
			}
			else {
				//Enable hfilter in filter in main filter list
				Storyboard.HFilterLayout.MainTree.set('#hfilterTree');
				hft = $(Storyboard.HFilterLayout.MainTree.get());
				if (hft.children('.DUITreeView').length < 1 && hft.children('.hfilter_multibox').length < 1) {
					hft.find(elements).each(function () {
						$(this).removeAttr('disabled');
						$(this).multiselect('enable');
					})
				}
				else if (hft.children('.hfilter_multibox').length > 0) {
					hft.find(elements).each(function () {
						if ($(this).is('input') && $(this).hasClass('DUIsmartSelectBoxFilter')) {
							$(this).removeAttr('disabled');
						}
						else if ($(this).is('div') && $(this).hasClass('hfilter_multibox')) {
							$(this).css('pointer-events', 'auto');
							$(this).removeClass('ui-state-disabled');
						}
					});

				}
				else
				{
					hft.find(elements).each(function () {
						if ($(this).is('button') && $(this).hasClass('DUITreeCompactButton')) {
							$(this).removeClass('ui-state-disabled');
							$(this).removeAttr('disabled');
						}
					});
				}
				//enable filters in ST when closing export panel by clicking on export icon
				$("#pnlSettingsPanel .SettingsControl").each(function () {
					var settingType = parseInt($(this).find(".hidSettingType").val(), 10);

					if (settingType == 5 && $(this).find("select").attr('separateExport') !== undefined) {
							$(this).find("button").removeClass('ui-state-disabled');
							$(this).find("button").removeAttr('disabled');
					}
				});


				if ($("#" + containerId + ":visible").length == 0) {
					$(".downloadcontainer").css("display", "none");
					$("#" + containerId).css("display", "");
				}
				else {
					$("#" + containerId).css("display", "none");
				}
			}
	
			if (Storyboard.LayoutDesigner.getLayoutGrid().imageQualityDisplay) {
				$("#" + containerId + ' #downloadPPTImageQuality').parent().show();
				$("#" + containerId + ' #downloadPPTImageQuality').val(Storyboard.LayoutDesigner.getLayoutGrid().imageQuality);
				$("#" + containerId + ' #downloadPPTImageQuality').multiselect({
					multiple: false,
					header: false,
					noneSelectedText: false,
					selectedList: 1
				});
				$("#" + containerId + ' #downloadPPTImageQuality').multiselect('refresh');
			}
			else {
				$("#" + containerId + ' #downloadPPTImageQuality').parent().hide();
			}
        }

        $("#downloadSelectedPPTExcel, #downloadSelectedExcel").css("display", showExcelExport ? "" : "none");
        $("#downloadSelectedPDF").css("display", showPdfExport ? "" : "none");
        $("#downloadSelectedPowerpoint").css("display", showPptExport ? "" : "none");
		$("#downloadSelectedNativePPT").css("display", showNativePptExport ? "" : "none");

		$('#downloadButtons', '#' + containerId).find('.downloadButton').css('width', '');
		var maxWidth = Math.max.apply(null, $('#downloadButtons', '#' + containerId).find('.downloadButton:visible').map(function () {
			return $(this).outerWidth() + 1; // to fix floor thing
		}).get());

		$('#downloadButtons', '#' + containerId).find('.downloadButton:visible').css('width', maxWidth);

		if (window.IsStoryboard && !Storyboard.GeneralSettings.storyBoardAccess.ExportExcel) {
			$('#downloadSelectedPPTExcel').attr('disabled', 'disabled');
			$('#downloadSelectedExcel').attr('disabled', 'disabled');
		}

		if (window.IsStoryboard && !Storyboard.GeneralSettings.storyBoardAccess.ExportPPT) {
			$('#downloadSelectedPowerpoint').attr('disabled', 'disabled');
		}

		Storyboard.LayoutDesigner.resetExportFileName();
		$("#hidStoryIdToExport").val(storySettings ? storySettings.storyId : 0);
	}

	function resetExportFileName() {
		if (window.ContentType > 0 && window.ContentType === Storyboard.Constants.itemTypes.CHART) {
			var currentDeck = ChartCreatorSetup.getLoadedFavorite();
			var deckName = currentDeck ? currentDeck.name : '';
			$('#txtExportFileName').val(defaultExportFileName.replace('%DeckName%', deckName).trim());
		} else
			$("#txtExportFileName").val(defaultExportFileName);
	}

	function downloadFailed(msg) {
		removeLoadingBar();
		Storyboard.LayoutControls.showError(msg || locale.get('Unknown error occured'));
	}

	function downloadedSuccess(fileArr, exportType, fileType) {
		var containerid = exportType == 'Powerpoint' ? '#downloadReportsPowerpoint' : '#downloadableNodesExcel';

		if (typeof (fileArr) !== "string") {
			$(fileArr).each(function () {
				addDownloadLink(containerid, this, fileType);
			});
		}
		else
			addDownloadLink(containerid, fileArr, fileType);

		removeLoadingBar();

		$(containerid + " a").unbind("click").bind("click", function () {
			var fileName = $(this).attr("report").toString();
			downloadChartsCompleted(fileName);
		});
	}

	function addDownloadLink(container, file, fileType) {
		var currentTime = new Date();
		var downloadName;
		if (fileType == 'PPT')
			downloadName = locale.get('Report generated PPT:') + ' ' + Helpers.pad(currentTime.getHours(), 2, 0) + ':' + Helpers.pad(currentTime.getMinutes(), 2, 0) + ':' + Helpers.pad(currentTime.getSeconds(), 2, 0);
		else if (fileType == "PDF")
			downloadName = locale.get('Report generated PDF:') + ' ' + Helpers.pad(currentTime.getHours(), 2, 0) + ':' + Helpers.pad(currentTime.getMinutes(), 2, 0) + ':' + Helpers.pad(currentTime.getSeconds(), 2, 0);
		else
			downloadName = locale.get('Report generated Excel:') + ' ' + Helpers.pad(currentTime.getHours(), 2, 0) + ':' + Helpers.pad(currentTime.getMinutes(), 2, 0) + ':' + Helpers.pad(currentTime.getSeconds(), 2, 0);
		$(container).append("<a href='#' class='downloadReport' report='" + file + "'>" + downloadName + "</a><br/>");
	}

	//removes spinner for user feedback
	function removeLoadingBar() {
		$("#btnOpenExportPanel img, #btnPrintStory img").remove();
		$(".downloadcontainer .downloadButton").removeAttr("disabled");
		if (typeof (customExportNotification) != 'undefined')
			$(".customExportNotification").remove();
	}

	function downloadChartsCompleted(downloadKey) {
		var iframe = document.createElement("iframe");
		iframe.src = 'DownloadFile.aspx?downloadKey=' + encodeURIComponent(downloadKey);
		iframe.style.display = "none";
		document.body.appendChild(iframe);
	}

	function downloadSelected(storySettings) {
		var data = { exporttype: 'Powerpoint' };
		createDownloadPanel(data, storySettings);
		if (storySettings)
			$("#exportHFilter").replaceWith("<div id='exportHFilterPlaceholder'></div>");
		else if (window.ContentType !== Storyboard.Constants.itemTypes.CHART) {
			addHFilters(data);
			addFilters(data);
		}
	}

	function downloadSelectedFilters() {
		var data = { exporttype: 'Excel' };
		createDownloadPanel(data);
		addHFilters(data);
	}

	function exportExcel() {
		var data = { layout: getLayoutGrid(), hFilterIds: Storyboard.HFilterLayout.getSelectedNodes("#hfilterTree") };
		Helpers.perfJSonCall({
			method: "ExportCrosstabsToExcel",
			data: data,
			successCallback: function (res) {
				if (res) {
					var frame = document.getElementById('fileFrame');
					if (frame == null) {
						frame = document.createElement("iframe");
						frame.name = "fileFrame";
						frame.id = "fileFrame";

						document.body.appendChild(frame);
						frame.style.width = "0px";
						frame.style.height = "0px";
						frame.style.border = "0px";
					}
					frame.src = "DownloadFile.aspx?downloadKey=" + encodeURIComponent(res.fileName);
				}
			}
		});
	}

	function endRequestReportTreePanel() {
		$('#lMsg:visible').fadeOut('fast');
	}

	function getLayoutElementsByType(itemType) {
		var layoutElements = [];
		var allElements = Storyboard.LayoutDesigner.getLayoutElements();

		for (var elemIndex in allElements)
			if (allElements.hasOwnProperty(elemIndex)) {
				if (Storyboard.LayoutDesigner.getLayoutElementType(allElements[elemIndex]) == itemType) {
					layoutElements.push(allElements[elemIndex]);
				}
			}
		return layoutElements;
	}

	function getLayoutElementsAreaHeight(elementsToSize) {
		Helpers.fixDotnetCasing(elementsToSize);
		if (elementsToSize.length < 1)
			return { minTop: 0, height: 0 };

		var minTop = elementsToSize[0].yCoord, maxBottom = elementsToSize[0].yCoord + elementsToSize[0].height;

		for (var i = 1; i < elementsToSize.length; i++) {
			minTop = Math.min(minTop, elementsToSize[i].yCoord);
			maxBottom = Math.max(maxBottom, elementsToSize[i].yCoord + elementsToSize[i].height);
		}

		return { minTop: minTop, height: maxBottom - minTop };
	}

	function getLayoutElementsByPage(currentPageNo) {
		var slide = Storyboard.LayoutDesigner.getSlideByIndex(currentPageNo);
		return Storyboard.LayoutDesigner.getLayoutElementsBySlide(slide);
	}

	function getLayoutElementsBySlide(slide) {
		return Storyboard.LayoutDesigner.getLayoutElements().filter(function (layoutElement) {
			return slide && ((layoutElement.slideId > 0 && layoutElement.slideId == slide.slideId) ||
				layoutElement.slideGuid == slide.guid);
		});
	}

	function getLayoutElementsByGroup(groupId) {
		var layoutElements = [];
		var allElements = Storyboard.LayoutDesigner.getLayoutElements();

		for (var elemIndex in allElements)
			if (allElements.hasOwnProperty(elemIndex)) {
				if (allElements[elemIndex].groupId === groupId) {
					layoutElements.push(allElements[elemIndex]);
				}
			}
		return layoutElements;
	}

	function getLayoutElementsGroup(groupId) {
		var layoutElementGroups = layoutGrid.layoutElementGroups;
		var layoutElementsGroup;

		if (!layoutElementGroups || layoutElementGroups.length === 0) return null;

		for (var group in layoutElementGroups)
			if (layoutElementGroups.hasOwnProperty(group)) {
				if (layoutElementGroups[group].groupId === groupId) {
					layoutElementsGroup = layoutElementGroups[group];
					layoutElementsGroup.layoutElements = Storyboard.LayoutDesigner.getLayoutElementsByGroup(groupId);
					return layoutElementsGroup;
				}
			}

		return null;
	}

	function getLayoutElementsWithInputVars() {
		var inputEls = [];
		for (var i in layoutElements)
			if (layoutElements.hasOwnProperty(i)) {
				if (layoutElements[i].UsesInputVariable)
					inputEls.push(layoutElements[i]);
			}
		return inputEls;
	}

	function getLayoutElementByIdOrGuid(layoutElementIdOrGuid) {
		return isNaN(layoutElementIdOrGuid) ?
			Storyboard.LayoutDesigner.getLayoutElementByGuid(layoutElementIdOrGuid) :
			Storyboard.LayoutDesigner.getLayoutElementById(layoutElementIdOrGuid);
	}

	function getLayoutElementById(layoutElementId) {
		for (var i in layoutElements)
			if (layoutElements.hasOwnProperty(i)) {
				if (layoutElements[i].layoutElementId == layoutElementId)
					return layoutElements[i];
			}
		return null;
	}

	function getLayoutElementByGuid(guid) {
		for (var i in layoutElements)
			if (layoutElements.hasOwnProperty(i)) {
				if (layoutElements[i].guid === guid)
					return layoutElements[i];
			}
		return null;
	}

	function getLayoutElementByElementItem(layoutElementItem) {
		if (layoutElementItem.layoutElementId && layoutElementItem.layoutElementId > 0)
			return getLayoutElementById(layoutElementItem.layoutElementId);
		else {
			for (var le in layoutElements)
				if (layoutElements.hasOwnProperty(le)) {
					for (var li in layoutElements[le].layoutElementItems) {
						if (layoutElements[le].layoutElementItems[li].guid == layoutElementItem.guid)
							return layoutElements[le];
					}
				}
		}
		return null;
	}

	function getLayoutElementType(layoutElement) {
		var contentItem = null;
		for (var key in Storyboard.Constants.itemTypes)
			if (Storyboard.Constants.itemTypes.hasOwnProperty(key)) {
				if (Storyboard.Constants.itemTypes.hasOwnProperty(key) && Storyboard.Constants.itemTypes[key] > itemTypes.FOOTER) {
					contentItem = getElementItemByType(Storyboard.Constants.itemTypes[key], layoutElement);
					if (contentItem != null)
						return contentItem.itemType;
				}
			}
		return null;
	}

	function getElementItemsByType(itemType) {
		var elementItems = [];
		var layoutElements = Storyboard.LayoutDesigner.getLayoutElements();

		for (var elemIndex in layoutElements)
			if (layoutElements.hasOwnProperty(elemIndex)) {
				var elementItem = Storyboard.LayoutDesigner.getElementItemByType(itemType, layoutElements[elemIndex]);
				if (elementItem)
					elementItems.push(elementItem);
			}

		return elementItems;
	}

	function getElementItemByGuid(guid) {
		for (var le in layoutElements)
			if (layoutElements.hasOwnProperty(le)) {
				for (var li in layoutElements[le].layoutElementItems) {
					if (layoutElements[le].layoutElementItems[li].guid == guid)
						return layoutElements[le].layoutElementItems[li];
				}
			}

		return null;
	}

	function getElementItemByType() { // arguments = (itemTypes, layoutElement)
		var layoutElement = arguments[arguments.length - 1], i, itemIndex;
		if (!layoutElement)
			return null;

		for (i in layoutElement.layoutElementItems) {
			for (itemIndex = 0; itemIndex < arguments.length - 1; itemIndex++) {
				if (layoutElement.layoutElementItems[i].itemType === arguments[itemIndex])
					return layoutElement.layoutElementItems[i];
			}
		}

		return null;
	}

	function getLayoutElementItem(layoutElement) {
		var contentItem = null;
		for (var key in Storyboard.Constants.itemTypes)
			if (Storyboard.Constants.itemTypes.hasOwnProperty(key)) {
				if (Storyboard.Constants.itemTypes.hasOwnProperty(key) && Storyboard.Constants.itemTypes[key] > itemTypes.FOOTER) {
					contentItem = getElementItemByType(Storyboard.Constants.itemTypes[key], layoutElement);
					if (contentItem != null) return contentItem;
				}
			}
		return null;
	}

	function getElementItemByTypeOrDefault(type, layoutElement) {
		return getElementItemByType(type, layoutElement) || new sb.LayoutDesigner.LayoutElementItem(type);
	}

	function LayoutElementItem(itemType, props) {
		this.itemType = itemType;
		this.height = 0, this.width = 0, this.x = 0, this.y = 0, this.content = null;
		this.guid = Helpers.generateGuid();

		setElementItemProperties(this, props);
	}

	function createElementItem(itemType, props) {
		return new LayoutElementItem(itemType, props);
	}

	function setElementItemProperties(elementItem, props) {
		if (props) {
			for (var prop in props)
				if (props.hasOwnProperty(prop)) {
					if (prop !== 'guid')
						elementItem[prop] = props[prop];
				}
		}
	}

	function addOrReplaceElementItem(item, layoutElement) {
		for (var i = 0; i < layoutElement.layoutElementItems.length; i++) {
			if (layoutElement.layoutElementItems[i].itemType === item.itemType) {
				//never replace item, just apply new properties to it
				var curItem = layoutElement.layoutElementItems[i];
				setElementItemProperties(curItem, item);
				return;
			}
		}
		layoutElement.layoutElementItems.push(item);
	}

	function deleteElementItem(itemType, layoutElement) {
		for (var i = 0; i < layoutElement.layoutElementItems.length; i++) {
			if (layoutElement.layoutElementItems[i].itemType === itemType)
				return layoutElement.layoutElementItems.splice(i, 1);
		}
	}

	// clear content of all elements with given item type
	function clearElementContent(itemType) {
		var elementItems = getElementItemsByType(itemType);
		for (var elemIndex in elementItems)
			if (elementItems.hasOwnProperty(elemIndex))
				elementItems[elemIndex].content = '';
	}

	function clearAllLoadedContent() {
		var contentTypes = [
			Storyboard.Constants.itemTypes.CHART,
			Storyboard.Constants.itemTypes.SIMPLETABLE,
			Storyboard.Constants.itemTypes.RESPONDENTTABLE,
			Storyboard.Constants.itemTypes.DYNAMICICONSHAPE,
			Storyboard.Constants.itemTypes.WORDCLOUD,
			Storyboard.Constants.itemTypes.SUMMARY,
			Storyboard.Constants.itemTypes.ADVANCEDANALYTICS,
		];

		for (var le in layoutElements)
			if (layoutElements.hasOwnProperty(le)) {
				var layoutElement = layoutElements[le];
				var itemType = getLayoutElementType(layoutElement);

				if (contentTypes.indexOf(itemType) > -1) {
					var elementItem = Storyboard.LayoutDesigner.getElementItemByType(itemType, layoutElement);

					if (itemType == Storyboard.Constants.itemTypes.CHART)
						Storyboard.HighchartsWrapper.destroyCharts(elementItem.guid);

					$("#" + elementItem.guid).empty();
				}
			}
	}

	function isMyStoryMode() {
		return Helpers.getURLParameter('selectedMyStorySlideIDs') != null;
	}

	function getDocumentFormatAsString(documentFormat) {
		// Can take either int or document format object
		var checkValue = documentFormat;
		if (typeof documentFormat == Object)
			checkValue = documentFormat.hash;

		var formats = Storyboard.Constants.documentFormats;
		if (formats.A4LANDSCAPE.hash == checkValue)
			return "A4LANDSCAPE";
		if (formats.A4PORTRAIT.hash == checkValue)
			return "A4PORTRAIT";
		if (formats.PPTONLINE.hash == checkValue)
			return "PPTONLINE";
		if (formats.A4PORTRAIT_LEGACY.hash == checkValue)
			return "A4PORTRAIT_LEGACY";
		if (formats.A4LANDSCAPE_LEGACY.hash == checkValue)
			return "A4LANDSCAPE_LEGACY";
		if (formats.CUSTOM.hash == checkValue)
			return "CUSTOM";
		if (formats.PPT_16_9.hash == checkValue)
			return "PPT_16_9";
		if (formats.SMALLSCREEN.hash == checkValue)
			return "SMALLSCREEN";
	}

	function getDocumentFormatFromString(formatString) {
		var formats = Storyboard.Constants.documentFormats;
		formatString = formatString.toUpperCase();
		if (formatString == "A4LANDSCAPE")
			return formats.A4LANDSCAPE;
		if (formatString == "A4PORTRAIT")
			return formats.A4PORTRAIT;
		if (formatString == "A4LANDSCAPE_LEGACY")
			return formats.A4LANDSCAPE_LEGACY;
		if (formatString == "A4PORTRAIT_LEGACY")
			return formats.A4PORTRAIT_LEGACY;
		if (formatString == "PPTONLINE")
			return formats.PPTONLINE;
		if (formatString == "CUSTOM")
			return formats.CUSTOM;
		if (formatString == "PPT_16_9")
			return formats.PPT_16_9;
		if (formatString == "SMALLSCREEN")
			return formats.SMALLSCREEN;
	}

	function checkInMemoryDataModelUpdated() {
		var params = {
			method: "IsInMemoryDataModelUpdated"
		};
		return Helpers.perfJSonCall(params);
	}

	function updateInMemory() {
		var params = {
			method: "UpdateInMemoryModel",
			message: "Updating data model",
			successCallback: function (updated) {
				Storyboard.LayoutDesigner.isUnsaved = false;
				if (updated) location.reload();
			}
		};
		Helpers.perfJSonCall(params);
	}

	function saveLayoutElementState(layoutElement) {
		if (layoutElement.layoutElementId > 0)
			Helpers.perfJSonCall({
				data: { layoutElementId: layoutElement.layoutElementId, isValid: layoutElement.isValid },
                method: "SaveLayoutElementState",
                service: 'ReportService',
				fixCasing: true
			});
	}

	function saveLayoutElementName(layoutElement, elementItemName) {
		if (layoutElement.layoutElementId > 0)
			Helpers.perfJSonCall({
				data: { layoutElementId: layoutElement.layoutElementId, elementItemName: elementItemName },
				method: "UpdateElementItemName",
				service: 'ReportService',
				fixCasing: true
			});
	}


	function inMemoryUpdateConfirm(callback) {
		var unsavedMessage = Storyboard.LayoutDesigner.isUnsaved ?
			'<p class="Message Message-info">The report will be saved automatically when the data model is being updated</p>': '';

		$.when(checkInMemoryDataModelUpdated()).done(function(data, textStatus) {
			if (textStatus === "success" && data.d === true) {
				new DUIwindow2({
					closeButton: false,
					width: 340,
					height: 'auto',
					html: locale.get("The data model needs to be updated to reflect the changes, do you want to update it now or later?") + unsavedMessage,
					buttons: [
						{ text: locale.get("Later"), onClick: callback },
						{ text: locale.get("Now"), focused: true, onClick: function() {
							if (Storyboard.LayoutDesigner.isUnsaved) {
								Storyboard.LayoutDesigner.saveLayout(updateInMemory);
							} else {
								updateInMemory();
							}
						} }
					]
				});
			} else {
				callback();
			}
		});
	}

	function updateLayoutElements(loadType) {
		loadType = loadType || Storyboard.Constants.ContentLoadType.All;

		if (!sb.LayoutDesigner.checkFilterSelection())
			return;

		var updateCharts = function () {
			var elements = Storyboard.LayoutDesigner.getLayoutElements(), el;
			for (el in elements) {
				if (elements.hasOwnProperty(el)) {

					if (elements[el].hasOwnProperty('GUILoaded')) {
						delete elements[el].GUILoaded;
					}
				}
			}
			//Storyboard.LayoutDesigner.storeFiltersSelections();
			Storyboard.LayoutDesigner.loadStorytellerContent(null, loadType);

			if (!Storyboard.LayoutDesigner.isAdmin || Helpers.isPreview()) {
				Storyboard.LayoutDesigner.loadExcludedSlides();
			}

			if (!(document.implementation.hasFeature("http://www.w3.org/TR/SVG11/feature#BasicStructure", "1.1"))) {
				$('#reportProgress').hide();
			}
		};

		inMemoryUpdateConfirm(updateCharts);
	}

	function autoUpdateLayoutElements() {
		if (Storyboard.LayoutDesigner.useAutoUpdate && (!Storyboard.LayoutDesigner.isAdmin || Helpers.isPreview())) {
			if (!Storyboard.LayoutDesigner.checkFilterSelection())
				return;

			updateLayoutElements();
        }
	}

	function _invokeDynamicFiltering($lastSelectionElement){
		sb.DynamicFiltering.markLastSelectedSetting($lastSelectionElement);
		sb.DynamicFiltering.getNoDataSelections();
	}
    var _debounced = null;
	function invokeDynamicFiltering($lastSelectionElement) {
		if(!sb.DynamicFiltering.isEnabled())
			return;

		_debounced && _debounced.cancel();

		sb.DynamicFiltering.removeClickEventsFromBtnUpdateCharts();

		_debounced = _.debounce(_invokeDynamicFiltering, 700)
		_debounced($lastSelectionElement);
	}

	function updateStaticLayoutElements() {
		var layoutElementIDs = layoutElements
			.filter(function(layoutElement) {
				var itemType = getLayoutElementType(layoutElement);
				return  itemType === itemTypes.STATICTEXT ||
						itemType === itemTypes.TEXT ||
						itemType === itemTypes.ICONSHAPE;
			})
			.map(function(layoutElement) {
				return layoutElement.layoutElementId;
			});

		Helpers.perfJSonCall({
			method: 'GetStaticElementsContent',
			data: { layoutElementIDs: layoutElementIDs },
			successCallback: function (data) {
				Helpers.fixDotnetCasing(data);

				data.layoutElements.forEach(function(layoutElement) {
					var layoutElementItem = Storyboard.LayoutDesigner.getLayoutElementItem(layoutElement);
					var currentLayoutElement = Storyboard.LayoutDesigner.getLayoutElementById(layoutElement.layoutElementId);
					var currentLayoutElementItem = Storyboard.LayoutDesigner.getLayoutElementItem(currentLayoutElement);

					currentLayoutElementItem.content = layoutElementItem.content;

					Storyboard.GuiEvents.redrawLayoutElement(currentLayoutElement);
				});
			}
		});
	}

	function clearLanguageDependentCache() {
		return Helpers.perfJSonCall({
				method: "ClearLanguageDependentCache"
			});
	}

	sb.LayoutDesigner.checkFilterSelection = function (opts) {
		opts = opts || {};
		var returnValue = true;
		var selectionsValidation = [];
		var filterValidationMessages = [];
		var minMaxInfo, thisVal;

		var optionFilterEls = $("select[id^='lbSetting_5']");

		if (optionFilterEls.length){
			optionFilterEls
				.filter(function() { return !$(this).parent().hasClass('NoOptionsFilter'); })
				.each(function () {
					var $this = $(this);
					if ($this.closest('.SettingsControl').hasClass('hasOptionSelectionRange')) {
						minMaxInfo = $this.closest('.SettingsControl').data('optionSelectionRange');
						thisVal = $this.val() || [];
						if ((minMaxInfo.min != null && ($this.children('option').length < minMaxInfo.min || thisVal.length < minMaxInfo.min))
							|| (minMaxInfo.max != null && thisVal.length > minMaxInfo.max)) {
							selectionsValidation.push({
								id: this.id,
								name: $this.siblings('#lblName').text(),
								min: minMaxInfo.min,
								max: minMaxInfo.max,
								actualSelections: thisVal
								//noOfOptions: $this.children('option').length
							});
							$this.siblings('button').css('border-color', 'red')
                        }
					} else if (!opts.checkMinMaxSelectionsOnly && $this.multiselect('getChecked').length === 0) {
						returnValue = false;
                    }
				});
		}

		var $vsSetting = $('#lbSetting_1');
		if ($vsSetting.length && $vsSetting.closest('.SettingsControl').hasClass('hasOptionSelectionRange')) {
			minMaxInfo = $vsSetting.closest('.SettingsControl').data('optionSelectionRange');
			thisVal = $vsSetting.val() || [];

			if ((minMaxInfo.min != null && ($vsSetting.children('option').length < minMaxInfo.min || thisVal.length < minMaxInfo.min))
				|| (minMaxInfo.max != null && thisVal.length > minMaxInfo.max)) {
				selectionsValidation.push({
					id: this.id,
					name: $vsSetting.siblings('#lblName').text(),
					min: minMaxInfo.min,
					max: minMaxInfo.max,
					actualSelections: thisVal
					//noOfOptions: $vsSetting.children('option').length
				});

				$vsSetting.siblings('button').css('border-color', 'red')
			}
		}
		if (Storyboard.HFilterLayout.hasHFilterNodes()) {
			var $hFilterTree = $('#hfilterTree');
			if ($hFilterTree.length && $hFilterTree.hasClass('hasOptionSelectionRange')) {
				var $validateControl;
				if (opts.isExportPanel) {
					$validateControl = $('#downloadTreePowerpoint').children('button');
					if (!$validateControl.length)
						$validateControl = $('#downloadTreePowerpoint').children('select');
				} else
					$validateControl = $hFilterTree.children('button');

				$validateControl.css('border-color', '');

				minMaxInfo = $hFilterTree.data('optionSelectionRange');
				if (opts.isExportPanel)
					thisVal = Storyboard.HFilterLayout.getSelectedIds("#downloadTreePowerpoint", true) || [];
				else
					thisVal = Storyboard.HFilterLayout.getSelectedIds("#hfilterTree") || [];

				if ((minMaxInfo.min != null && thisVal.length < minMaxInfo.min)
					|| (minMaxInfo.max != null && thisVal.length > minMaxInfo.max)) {
					selectionsValidation.push({
						id: this.id,
						name: $hFilterTree.siblings('.hFilterName').text(),
						min: minMaxInfo.min,
						max: minMaxInfo.max,
						actualSelections: thisVal
						//noOfOptions: Object.keys(Storyboard.HFilterLayout.getHFilters()).length
					});

					$validateControl.css('border-color', 'red');
				}
			}
        }

		selectionsValidation.forEach(function (el) {
			if (el.min != null || el.max != null) {
				var message = '<span style="display:block"><span>' + el.name + ': </span><em>';

				if (el.noOfOptions != null && el.noOfOptions < el.min) {
					message += 'There aren’t enough options';
				} else {
					message += 'You must choose ';
					if (el.min === el.max) {
						message += el.min + ' option' + (el.min > 1 ? 's' : '');
					} else if (el.min != null && el.max != null) {
						message += 'a minimum of ' + el.min + ' option' + (el.min > 1 ? 's' : '') + ' and a maximum of ' + el.max;
					} else if (el.min != null) {
						message += 'a minimum of ' + el.min + ' option' + (el.min > 1 ? 's' : '');
					} else if (el.max != null) {
						message += 'a maximum of ' + el.max + ' option' + (el.max > 1 ? 's' : '');
					}
				}

				message += '.</em></span>';
				filterValidationMessages.push(message);
			}
		});

		if (filterValidationMessages.length) {
			returnValue = false;
			Storyboard.LayoutControls.showMessage(filterValidationMessages.join(''));
		} else if (!opts.checkMinMaxSelectionsOnly && !returnValue) {
			Storyboard.LayoutControls.showMessage(locale.get('At least one option needs to be selected in every filter box.'));
		}

		return returnValue;
	};

	sb.LayoutDesigner.bindUpdateEvent = function () {// Update button -------------
        $("#btnUpdateCharts").bind("click", function (evt) { updateLayoutElements(); });

		$("#ddlMyStories").bind("change", function() {
			Storyboard.MyStories.updateShareButtonContent();

			$.when(Storyboard.LayoutDesigner.loadLayout(true))
				.done(function(data) {
					var story = Storyboard.MyStories.getCurrentStory();

					$('#DUI_ST_NAVIGATOR').hide();
					$('#DUI_ST_NAVIGATOR .DUI-ST-NAVIGATOR-SLIDEHANDLER').DUIslideNavigator('destroy');
					$('#storySlideSettingsInfo').empty();
					$('#lnkDeleteMyStoriesSlide, #lnkMyStoriesSourceSlide').attr('disabled', true);
					$('#lnkDeleteMyStoriesSlide, #btnMyStoriesShare').toggle(!story.isShared);
					$('#lnkMyStoriesSourceSlide').removeAttr('href');

					if (data && data.d) {
						Storyboard.LayoutDesigner.loadCoordinatesComplete(data.d);
						setTimeout(Storyboard.LayoutDesigner.loadMyStoryContent, 200);
					}
				});
		});

		$("#ddlFormRespondents").bind("change", function (evt) {
			var elements = Storyboard.LayoutDesigner.getLayoutElements(), el;
			for (el in elements) {
				if (elements.hasOwnProperty(el)) {
					if (elements[el].hasOwnProperty('GUILoaded')) {
						delete elements[el].GUILoaded;
					}
				}
			}

			function reload() {
				Storyboard.LayoutDesigner.loadFormContent();
				//Storyboard.LayoutDesigner.loadChartsDel(null, 3);
				DataFieldSetup.previousRespondentId = $('#ddlFormRespondents').val();
				DataFieldSetup.hasUnsavedChanges = false;

				if (!(document.implementation.hasFeature("http://www.w3.org/TR/SVG11/feature#BasicStructure", "1.1"))) {
					$('#reportProgress').hide();
				}
			}

			if (DataFieldSetup.hasUnsavedChanges && confirm('You have unsaved changes. Save before changing respondent?')) {
				$.when(DataFieldSetup.saveDataFieldsForRespondent(true))
					.done(function () {
						// if datafields validation fails do nothing
						if (arguments[0] === false) return;
						reload();
					});
			} else {
				reload();
			}
		});

		$("#btnSaveDataFields").bind("click", function (evt) {
			DataFieldSetup.saveDataFieldsForRespondent();
		});

		$("#btnPreviewMode").bind("click", function (evt, inMemoryConfirmed) {
			if (inMemoryConfirmed !== true) {
				var previewMode = function() {
					$("#btnPreviewMode").trigger("click", [true]);
					setTimeout(function() {
						Storyboard.LayoutControls.showLoadingBar(locale.get('Please wait while Project Metadata and Report Settings are updated in the cache...'));
						$('#MessagePopup').css({'width': '630px', 'marginLeft': '-325px'});
					}, 5000);
				};
				evt.stopPropagation();
				evt.preventDefault();
				inMemoryUpdateConfirm(previewMode);
			}
		});
	};

	function groupElements(layoutElements) {
		if (!layoutElements || layoutElements.length < 2) return null;

		var newGroupId = Storyboard.LayoutDesigner.getNewGroupId();
		var newZIndex = Storyboard.LayoutDesigner.getNewZIndex();

		layoutElements.sort(Helpers.sortZIndex);

		if (!layoutGrid.layoutElementGroups)
			layoutGrid.layoutElementGroups = [];

		var newLayoutElementsGroup = {
			groupId: newGroupId,
			groupName: ''
		};

		for (var i in layoutElements)
			if (layoutElements.hasOwnProperty(i))
				if (!layoutElements[i].groupId) {
					layoutElements[i].groupId = newGroupId;
					layoutElements[i].zIndex = newZIndex++;
					$('#' + layoutElements[i].guid).draggable('disable').resizable('disable');
				}

		layoutGrid.layoutElementGroups.push(newLayoutElementsGroup);

		return newLayoutElementsGroup;
	}

	function ungroupElements(groupId) {
		var layoutElementGroups = layoutGrid.layoutElementGroups;

		for (var g = 0; g < layoutElementGroups.length; g++)
			if (layoutElementGroups[g].groupId === groupId) {
				layoutElementGroups.splice(g, 1);
				break;
			}

		for (var i in layoutElements)
			if (layoutElements.hasOwnProperty(i))
				if (layoutElements[i].groupId === groupId) {
					delete layoutElements[i].groupId;
					delete layoutElements[i].sizePositionUnlocked;
					$('#' + layoutElements[i].guid).draggable('enable').resizable('enable');
				}
	}

	function clearGroups() {
		var layoutGrid = Storyboard.LayoutDesigner.getLayoutGrid();
		var layoutElements = Storyboard.LayoutDesigner.getLayoutElements();
		var groups = layoutGrid.layoutElementGroups || [];
		var ids = {};

		checkGroups:
		for (var g = 0; g < groups.length; g++) {
			if (!ids.hasOwnProperty(groups[g].groupId)) {
				ids[groups[g].groupId] = true;
				for (var i = 0; i < layoutElements.length; i++)
					if (layoutElements[i].groupId === groups[g].groupId)
						continue checkGroups;
			}
			groups.splice(g, 1);
			g--;
		}
	}

	function getSelectedGroupId() {
		selectedGroupId = 0;

		if ($(".layoutElementsGroup").length > 0)
			selectedGroupId = parseInt($(".layoutElementsGroup").attr("layoutelementsgroupid"), 10);

		return selectedGroupId;
	}

	function getSlideByIndex(slideIndex) {
		return layoutSlides.find(function(slide) { return slide.slideIndex == slideIndex; });
	}

	function getSlideById(slideId) {
		return layoutSlides.find(function(slide) { return slide.slideId == slideId; });
	}

	function getCurrentSlide() {
		var currentSlideIndex = Storyboard.LayoutDesigner.getCurrentPageNo();
		return Storyboard.LayoutDesigner.getSlideByIndex(currentSlideIndex);
	}

	function getSlideByLayoutElement(layoutElement) {
		for (var i in layoutSlides)
			if (layoutSlides.hasOwnProperty(i)) {
				// real id has priority over guid
				if ((layoutSlides[i].slideId > 0 && layoutSlides[i].slideId == layoutElement.slideId) ||
					layoutSlides[i].guid == layoutElement.slideGuid)
					return layoutSlides[i];
			}
		return null;
	}

	function moveElementToSlide(layoutElement, slide, yOffset) {
		yOffset = yOffset || 0;
		var itemType = Storyboard.LayoutDesigner.getLayoutElementType(layoutElement);

		layoutElement.slideId = slide.slideId;
		layoutElement.slideGuid = slide.guid;
		layoutElement.yCoord += yOffset;

		Storyboard.GuiEvents.DeleteDOMElement(layoutElement);
		Storyboard.LayoutDesigner.addLayoutElement(layoutElement, itemType, true);
	}

	function setSlidesSize(newSize) {
		for (var i in layoutSlides)
			if (layoutSlides.hasOwnProperty(i)) {
				layoutSlides[i].height = newSize.height;
				layoutSlides[i].width = newSize.width;
				Storyboard.LayoutDesigner.eventRedrawLayoutSlide(layoutSlides[i]);
			}
	}

	function getCurrentSlideSize() {
		var currentSlide = Storyboard.LayoutDesigner.getCurrentSlide();
		return { width: currentSlide.width, height: currentSlide.height };
	}

	function getBackgroundSlide(createIfNotPresent) {
		var bgSlide = null;
		for (var i in layoutSlides)
			if (layoutSlides.hasOwnProperty(i) && layoutSlides[i].isBackground) {
				bgSlide = layoutSlides[i];
				break;
			}

		if (bgSlide == null && createIfNotPresent) {
			var pageSize = Storyboard.LayoutDesigner.getPageSize();

			bgSlide = {
				slideId: 0,
				slideIndex: 999,
				slideName: "",
				width: pageSize.width,
				height: pageSize.height,
				isBackground: true
			};
			Storyboard.LayoutDesigner.addLayoutSlide(bgSlide);
		}

		return bgSlide;
	}

	function getLoadedSlideIds() {
		var itemTypes = Storyboard.Constants.itemTypes;
		var backgroundSlide = Storyboard.LayoutDesigner.getBackgroundSlide();
		var slides = Storyboard.LayoutDesigner.getLayoutSlides();
	
		slides = slides.filter(function(slide) { return slide !== backgroundSlide; });
	
		var isBackgroundSlideLoaded = backgroundSlide ? isSlideLoaded(backgroundSlide) : true;
	
		function isSlideLoaded(slide) {
			var slideElements = Storyboard.LayoutDesigner.getLayoutElementsBySlide(slide);
			var elementsToLoad = slideElements
				.filter(function(layoutElement) {
					var itemType = Storyboard.LayoutDesigner.getLayoutElementType(layoutElement);
					return itemType !== itemTypes.STATICTEXT &&
							itemType != itemTypes.TEXT && 
							itemType != itemTypes.IMAGE && 
							itemType != itemTypes.ICONSHAPE;
				});
			
			if (elementsToLoad.length > 0) {
				return !elementsToLoad.some(function(layoutElement) {
					return !layoutElement.GUILoaded;
				});
			} else {
				return true;
			}
		}
	
		function mapSlideId(slide) {
			return slide.slideId;
		}
	
		if (isBackgroundSlideLoaded) {
			return slides.filter(isSlideLoaded).map(mapSlideId);
		} else {
			return [];
		}
	}

	function setLayoutAreaSize(size) {
        // no size passed? decide what to use
		if (!size) {
            // if report shows separate slides - use current page size
			if (Storyboard.LayoutDesigner.slideShowMode) {
				var currentSlide = Storyboard.LayoutDesigner.getCurrentSlide();
				if (currentSlide)
					size = { height: currentSlide.height, width: currentSlide.width };
				else
					size = pageSize;
			} else { // otherwise - total slides height (excluding background) and max width
				var height = 0;
				var width = 0;
				$(layoutSlides).each(function () {
					if (!this.isBackground) {
						height += this.height;
						width = width < this.width ? this.width : width;
					}
				});

				size = { height: height, width: width };
			}
		}

		$("#layoutArea").height(size.height).width(size.width);
	}

	function printStoryteller() {
		if (!Storyboard.LayoutDesigner.checkFilterSelection())
			return;

		var selectedHFilters = Storyboard.HFilterLayout.getSelectedIds("#hfilterTree");
		Storyboard.LayoutDesigner.clearElementContent(itemTypes.RESPONDENTTABLE);
		var selectedMyStorySlideIDs = Helpers.getURLParameter("selectedMyStorySlideIDs");
		if (!selectedMyStorySlideIDs)
			selectedMyStorySlideIDs = "";

		var calldata = {
			selectedHFilterNodes: selectedHFilters,
			generalSettings: GeneralSettings.getSelectedSettings(),
			layout: Storyboard.LayoutDesigner.getLayoutGrid(),
			splitFilters: false,
			imageQuality: $("#downloadPPTImageQuality").val() || 3,
			currentSlide: Storyboard.LayoutDesigner.getCurrentPageNo(),
			isAdmin: Storyboard.LayoutDesigner.isAdmin,
			selectedMyStorySlideIDs: selectedMyStorySlideIDs,
			exportType: 3,
			respondentId: window.IsFormReport ? $('#ddlFormRespondents').val() : 0
		};

		var downloadParams = {
			method: "DownloadChartsSelectedNodes",
			data: calldata,
			successCallback: function (res) {
				removeLoadingBar();

				if (Helpers.supportsPdf()) {
					$("#print-modal-content").attr("src", "Print.aspx?downloadKey=" + encodeURIComponent(res) + "&openOnPage=true");
				} else {
					var iframe = document.createElement("iframe");
					iframe.src = "Print.aspx?downloadKey=" + encodeURIComponent(res);
					iframe.style.display = "none";
					document.body.appendChild(iframe);
				}
			},
			failCallback: function (msg) {
				removeLoadingBar();
				Storyboard.LayoutControls.showError(msg || locale.get("Unknown error occured"));
			}
		};
		Helpers.perfJSonCall(downloadParams);

		if (typeof (customExportNotification) != 'undefined')
			$("body").append(customExportNotification);
		$("#btnPrintStory").append('<img src="images/spinner.gif" style="width:12px;height:12px;padding-left:5px;" alt="' + locale.get('Loading') + '"/>');

		// restore respondent tables' content
		var respTableElements = getLayoutElementsByType(itemTypes.RESPONDENTTABLE);
		$(respTableElements).each(function () {
			var tableDiv = $(".layoutElement[guid='" + this.guid + "']").find(".layoutElementRespondentTable")[0];
			RespondentTableSetup.saveRespondentTableHtml(tableDiv, getElementItemByType(itemTypes.RESPONDENTTABLE, this));
		});
	}

	function getFonts() {
		return fonts.map(function(font){ return fixFontProperites(font); });
	}

	function getDefaultFont() {
        return fixFontProperites(defaultFont);
	}

    function fixFontProperites(font) {
		return font ? { Name: (font.name || font.Name), Family: (font.family || font.Family), FallBackFont: (font.fallBackFont || font.FallBackFont) } : font;
    }

	function setFontSettings(settings) {
		fonts = settings.Fonts;
		defaultFont = settings.DefaultFont;

		// transform fonts to UserEvents format
		var userEventFonts = settings.Fonts.map(function (x) {
			return {
				fontFamily: x.Name || x.name,
				family: x.Family || x.family,
				fontStack: x.FallBackFont ? x.Family + "," + x.FallBackFont : (x.Family || x.family)
			}
		});
		var userEventSettings = {
			defaultFont: settings.DefaultFont,
			defaultFontStack: settings.DefaultFont.FallBackFont ? settings.DefaultFont.Family + "," + settings.DefaultFont.FallBackFont : settings.DefaultFont.Family,
			fonts: userEventFonts
		};
		Storyboard.LayoutDesigner.UserEvents.setDefaults(userEventSettings);
	}

    function loadFontSettings() {
        var params = {
            service: 'generalsettings',
            method: "GetFontSettings",
            successCallback: function (settings) {
                Storyboard.LayoutDesigner.setFontSettings(settings);
            }
        };
        return Helpers.perfJSonCall(params);
    }

    function queueExport(exportParameters) {
		exportParameters.successCallback = function (exportItems) {
			removeLoadingBar();
			if (Array.isArray(exportItems)) {
				for (var i = 0; i < exportItems.length; i++)
					DownloadArea.bindExportItem(exportItems[i]);
			} else {
				DownloadArea.bindExportItem(exportItems);
			}
		}
		exportParameters.fixCasing = true;

		$(".downloadcontainer .downloadButton").attr("disabled", "disabled");
		Helpers.perfJSonCall(exportParameters);
	}

	function showExportStartedMessage() {
		var message1 = locale.get('The generation of the report started.');
		var message2 = locale.get('You can now continue to work and download the files later when generation is completed.');

		if ($('#exportStartedMessage').length === 0) {
			$('#downloadButtons').after('<p id="exportStartedMessage" class="Message Message-info">'+ message1 + '<br>' + message2 +'</p>');

			setTimeout(function() {
				$('#exportStartedMessage').remove();
			}, 7500);
		}
	}

	function destroyExportPanel() {
		// put it back! :)
		if ($("#downloadableNodesPowerpoint #divDownloadArea, #downloadableNodesExcel #divDownloadArea").length > 0)
			$("#pnlDownloadArea").append($("#divDownloadArea").css("display", "none").detach());
		$("#chkSelectAllExportHF").removeAttr("checked");
		$("#downloadableNodesPowerpoint, #downloadableNodesExcel").remove();
    }

    function deleteSlide(currentSlideNo) {
		if (!window.IsMyStories &&
			!window.ContentType === Storyboard.Constants.itemTypes.CHART &&
			!Storyboard.LayoutDesigner.isAdmin) {
			return;
		}

        var skipConfirm = (arguments.length > 1) ? arguments[1] : false;
        if (!skipConfirm) {
            var r = confirm('Do you really want to delete this slide?');
            if (!r) return r;
        }

        var currentSlide = Storyboard.LayoutDesigner.getSlideByIndex(currentSlideNo);
        Storyboard.LayoutDesigner.deleteLayoutSlide(currentSlide);

        $('.DUI-ST-NAVHOLDER .DUIslideNavigator_SelectBox > div').each(function(index) {
            if (index >= currentSlideNo) {
                $(this).attr('data-value', parseInt($(this).attr('data-value'), 10) - 1);
                $(this).children('input:first').val($(this).attr('data-value'));
            }
        });
        $('.DUI-ST-NAVIGATOR-SLIDEHANDLER').DUIslideNavigator('remove', currentSlideNo - 1);

        Storyboard.GuiEvents.disableDeleteSlide();
        if (Storyboard.LayoutDesigner.getPageCount() === 1)
            Storyboard.GuiEvents.hideSlideNavigation(true);

        return r;
    }

	// FIXME: layoutElementsGuids is always empty array?
    function deleteLayoutSlide(layoutSlide) {
        var i, leiGuids = [];
        var elementsToDelete = Storyboard.LayoutDesigner.getLayoutElementsBySlide(layoutSlide);

        // delete slide elements
		for (i = 0; i < elementsToDelete.length; i++) {
			if (window.ContentType > 0 && window.ContentType === Storyboard.Constants.itemTypes.CHART) {
				var elementItem = Storyboard.LayoutDesigner.getLayoutElementItem(elementsToDelete[i]);
				leiGuids.push(elementItem.guid);
			}

			Storyboard.LayoutDesigner.deleteLayoutElement(elementsToDelete[i]);
        }

        var layoutSlides = Storyboard.LayoutDesigner.getLayoutSlides();
        var iToSplice = 0;
        for (i = 0; i < layoutSlides.length; i++) {
            if (layoutSlides[i].guid === layoutSlide.guid)
                iToSplice = i;
            else if (layoutSlides[i].slideIndex > layoutSlide.slideIndex && !layoutSlides[i].isBackground)
                layoutSlides[i].slideIndex--;
        }

        layoutSlides.splice(iToSplice, 1);
        Storyboard.GuiEvents.DeleteDOMElement(layoutSlide);
        if (!window.IsMyStories)
			Storyboard.LayoutDesigner.setState(true); //unsaved state

		if (window.ContentType > 0 && window.ContentType === Storyboard.Constants.itemTypes.CHART)
			ChartCreatorDataCom.ClearObjectSettings(leiGuids);
    }

	function deleteLayoutElement(layoutElement) {
		var layoutElements = sb.LayoutDesigner.getLayoutElements();
		for (var i = 0; i < layoutElements.length; i++) {
			if (layoutElements[i].guid === layoutElement.guid) {
				layoutElements.splice(i, 1);
                Storyboard.GuiEvents.DeleteDOMElement(layoutElement);

                // ungroup objects if only one object is left in group after deletion of current object
                if (layoutElement.groupId != null && layoutElements.filter(function (el) { return el.guid !== layoutElement.guid && el.groupId === layoutElement.groupId; }).length < 2)
                    ungroupElements(layoutElement.groupId);

				break;
			}
		}
		if (!window.IsMyStories) {
			Storyboard.LayoutDesigner.history.empty();
			if (Storyboard.LayoutDesigner.updateUsageStats)
				Storyboard.LayoutDesigner.updateUsageStats(layoutElements.length);
			if (Storyboard.LayoutDesigner.setState)
				Storyboard.LayoutDesigner.setState(true); //unsaved state
		}

		if (window.ContentType === Storyboard.Constants.itemTypes.CHART) {
			Storyboard.LayoutDesigner.history.empty();
		}
	}

    function getHiddenSeriesFromSlide(layoutSlide) {
        var hiddenSeries = [];
        var i;
        var elements = Storyboard.LayoutDesigner.getLayoutElementsBySlide(layoutSlide);

        for (i = 0; i < elements.length; i++) {
            $(elements[i].hiddenChartSeries).each(function () {
                hiddenSeries.push({ slideId: layoutSlide.slideId, layoutElementId: elements[i].layoutElementId, nodePath: this });
            });
        }

        return hiddenSeries;
    }

    function getHiddenSeries() {
        var hiddenSeries = [];
        var i;
        var elements = Storyboard.LayoutDesigner.getLayoutElements();

        for (i = 0; i < elements.length; i++) {
            $(elements[i].hiddenChartSeries).each(function () {
                hiddenSeries.push({ slideId: elements[i].slideId, layoutElementId: elements[i].layoutElementId, nodePath: this });
            });
        }

        return hiddenSeries;
    }

    function getRespTablesSelectedVariablesInfo() {
        var info = [];
        $(layoutElements).each(function (index, elem) {
            if (!elem) return true;

            var layoutElement = this;
            var itemType = getLayoutElementType(layoutElement);

            if (itemType == itemTypes.RESPONDENTTABLE) {
                var sortFilter = { PageNrToReturn: 1, ColFilterSortList: [], LayoutElementId: layoutElement.layoutElementId };

                var elementItem = Storyboard.LayoutDesigner.getElementItemByType(itemTypes.RESPONDENTTABLE, this);
                var cachedSettings = Storyboard.RespondentTableCache.getSettingsFromCache(elementItem.guid);
                if (cachedSettings)
                    sortFilter.VariablesToShow = cachedSettings.VariablesToShow;

                info.push(sortFilter);
            }
        });
        return info;
	}

	function deleteAction(respondentId) {
		return Helpers.perfJSonCall({
			method: "../services/ReportService.aspx/DeleteAction",
			data: { respondentId: respondentId},
			message: locale.get("Deleting action..."),
			successCallback: function () {
				Storyboard.LayoutControls.showMessage(locale.get('Action has been deleted.'));
			},
			failCallback: function (message) {
				if (message.indexOf('Update data model operation failed') > -1)
					Storyboard.LayoutControls.showMessage(locale.get(message));
				else
					Storyboard.LayoutControls.showMessage(locale.get('Error deleting action.'));
			},
			fixCasing: true
		});
	}

	function isBulkHFilterExportEnabled() {
		var availableProjectFeatures = parseInt($('#hidAvailableProjectFeatures').val());
		return isNaN(availableProjectFeatures) || Helpers.hasFlag(availableProjectFeatures, Storyboard.Constants.ProjectFeaturesEnum.HierarchyBulkExport);
    }

	//Methods from chart creator used in the functionality for creating new objects

	function getEnabledObjectTypes () {
		var obj = {useChart: true, useTable: true, useRespondentTable:true, useImage: true, useDynamicImage: true, useText: true, useTextMedia: true, useIconShape: true, useDynamicIconShape:true, useWordCloud:true};

		if (reportSettings && reportSettings.objectTypes) {
			obj.useChart = reportSettings.objectTypes.includes(Storyboard.Constants.itemTypes.CHART);
			obj.useTable = reportSettings.objectTypes.includes(Storyboard.Constants.itemTypes.SIMPLETABLE);
			obj.useRespondentTable = reportSettings.objectTypes.includes(Storyboard.Constants.itemTypes.RESPONDENTTABLE);
			obj.useImage = reportSettings.objectTypes.includes(Storyboard.Constants.itemTypes.IMAGE);
			obj.useDynamicImage = reportSettings.objectTypes.includes(Storyboard.Constants.itemTypes.DYNAMICIMAGE);
			obj.useText = reportSettings.objectTypes.includes(Storyboard.Constants.itemTypes.STATICTEXT);
			obj.useTextMedia = reportSettings.objectTypes.includes(Storyboard.Constants.itemTypes.TEXT);
			obj.useWordCloud = reportSettings.objectTypes.includes(Storyboard.Constants.itemTypes.WORDCLOUD);
			obj.useIconShape = reportSettings.objectTypes.includes(Storyboard.Constants.itemTypes.ICONSHAPE);
			obj.useDynamicIconShape = reportSettings.objectTypes.includes(Storyboard.Constants.itemTypes.DYNAMICICONSHAPE);
		}

		return obj;
	}

	function getObjectTypesHTML() {
		var enabledTypes = getEnabledObjectTypes();
		var html = '';

		if (enabledTypes.useChart)
			html += '<li id="DUI-CC-CM-NEW-CHART" data-item-type="'+ itemTypes.CHART +'"><img src="icons/bar_chart.png" alt="Chart"><span>'+ locale.get('Chart') +'</span></li>';
		if (enabledTypes.useTable)
			html += '<li id="DUI-CC-CM-NEW-SIMPLETABLE" data-item-type="'+ itemTypes.SIMPLETABLE +'"><img src="icons/table.png" alt="Table"><span>'+ locale.get('Table') +'</span></li>';
		if (enabledTypes.useRespondentTable)
			html += '<li id="DUI-CC-CM-NEW-RESPONDENTTABLE" data-item-type="'+ itemTypes.RESPONDENTTABLE +'"><img src="icons/respondenttable.png" alt="Respondent Table"><span>'+ locale.get('Respondent Table') +'</span></li>';
		if (enabledTypes.useImage)
			html += '<li id="DUI-CC-CM-NEW-IMAGE" data-item-type="'+ itemTypes.IMAGE +'"><img src="icons/image.png" alt="Image"><span>'+ locale.get('Image') +'</span></li>';
		if (enabledTypes.useDynamicImage)
			html += '<li id="DUI-CC-CM-NEW-DYNAMICIMAGE" data-item-type="'+ itemTypes.DYNAMICIMAGE +'"><img src="icons/dynamicimage.png" alt="Dynamic Image"><span>'+ locale.get('Dynamic Image') +'</span></li>';
		if (enabledTypes.useIconShape)
			html += '<li id="DUI-CC-CM-NEW-ICONSHAPE" data-item-type="'+ itemTypes.ICONSHAPE +'"><img src="icons/iconshape.png" alt="Icon/Shape"><span>'+ locale.get('Icon/Shape') +'</span></li>';
		if (enabledTypes.useDynamicIconShape)
			html += '<li id="DUI-CC-CM-NEW-DYNAMICICONSHAPE" data-item-type="'+ itemTypes.DYNAMICICONSHAPE +'"><img src="icons/dynamic_iconshape.png" alt="Dynamic Icon/Shape"><span>'+ locale.get('Dynamic Icon/Shape') +'</span></li>';
		if (enabledTypes.useText)
			html += '<li id="DUI-CC-CM-NEW-TEXT" data-item-type="'+ itemTypes.STATICTEXT +'"><img src="icons/insert-text.png" alt="Text"><span>'+ locale.get('Text') +'</span></li>';
		if (enabledTypes.useTextMedia)
			html += '<li id="DUI-CC-CM-NEW-TEXTMEDIA" data-item-type="'+ itemTypes.TEXT +'"><img src="icons/object_richtext.png" alt="Text & Media"><span>'+ locale.get('Text & Media') +'</span></li>';
		if (enabledTypes.useWordCloud)
			html += '<li id="DUI-CC-CM-NEW-WORDCLOUD" data-item-type="'+ itemTypes.WORDCLOUD +'"><img src="icons/wordcloud.png" alt="Word Cloud"><span>'+ locale.get('Word Cloud') +'</span></li>';

		if (window.useNewStoryTellerLayout) {
			html = html.replace(/.png/g, '.svg');
		}

		return html;
	}

	function calculateNewObjectPositionFromEvent (event) {
		var currentSlide = Storyboard.LayoutDesigner.getCurrentSlide();
		var layoutElementProps = {
			width: 400,
			height: 300,
			xCoord: (currentSlide.width / 2) - 200,
			yCoord: (currentSlide.height / 2) - 150,
		};

		if (event && $(event.target).closest('#chartCreatorContextMenu').length) {
			var slideOffset = $(document.getElementById(currentSlide.guid)).offset();
			var mouseClickPosition = $('body > .DUIContextMenu').data('position');
			layoutElementProps.xCoord = Math.round(mouseClickPosition.pageX - slideOffset.left);
			layoutElementProps.yCoord = Math.round(mouseClickPosition.pageY - slideOffset.top);
		} else {
			layoutElementProps.animate = true;
		}

		return layoutElementProps;
	}
	function convertToItemType (layoutElementDiv, itemType) {
		var layoutElement = Storyboard.LayoutDesigner.getLayoutElementByGuid(layoutElementDiv.attr('guid'));

		var currentElementItem = Storyboard.LayoutDesigner.getLayoutElementItem(layoutElement);
		Storyboard.LayoutDesigner.deleteElementItem(currentElementItem.itemType, layoutElement);
		Storyboard.LayoutDesigner.resetCachedContentForElement(layoutElement);
		
		Storyboard.LayoutDesigner.addOrReplaceElementItem(Storyboard.LayoutDesigner.createElementItem(itemType), layoutElement);
		
		// special case for new image - proccess uploaded file first
		var imgElementItem = Storyboard.LayoutDesigner.getElementItemByType(Storyboard.Constants.itemTypes.IMAGE, layoutElement);
		if (imgElementItem && !Storyboard.LayoutDesigner.elementItemHasId(imgElementItem)) {
			Storyboard.LayoutDesigner.processUploadedImageFile(layoutElement, imgElementItem);
		} else {
			Storyboard.LayoutDesigner.eventRedrawLayoutElement(layoutElement);
		}
		
		Storyboard.LayoutDesigner.history.empty();
		//ChartCreatorSetup.setUnsaved(true);

		if (itemType === Storyboard.Constants.itemTypes.EMPTYCHARTCREATOR) {
			delete layoutElement.GUILoaded;
			$(layoutElementDiv).parent().find('.editContent').css('display', 'none');
		} else {
			$(layoutElementDiv).addClass('ui-selected');
			$(layoutElementDiv).parent().find('.editContent').css('display', '');
		}
	}
	
	function imageUploadChangeHandler (event, layoutElementGuid, position) {
		var reportID = Helpers.getReportID();
		var files = event.target.files;
		var file = files[0];
		var formData = new FormData();

		if (!file) return;

		formData.append('myFile', file);

		Helpers.uploadImage(formData, reportID,
			function() {
				var currentSlide = Storyboard.LayoutDesigner.getCurrentSlide();
				var slideOffset = $(document.getElementById(currentSlide.guid)).offset();
				var layoutElement, layoutElementDiv, layoutElementProps = {};

				if (layoutElementGuid) {
					layoutElementDiv = $('#' + layoutElementGuid);
					layoutElement = Storyboard.LayoutDesigner.getLayoutElementByGuid(layoutElementGuid);
					layoutElement.resize = true;
					convertToItemType(layoutElementDiv, Storyboard.Constants.itemTypes.IMAGE);
				} else {
					if (position) {
						// If event originating from Context menu item,
						// position image at the coordinates of a mouse click
						layoutElementProps.xCoord = Math.round(position.pageX - slideOffset.left);
						layoutElementProps.yCoord = Math.round(position.pageY - slideOffset.top);
						layoutElementProps.width = currentSlide.width - layoutElementProps.xCoord;
						layoutElementProps.height = currentSlide.height - layoutElementProps.yCoord;
						layoutElementProps.alignCenter = false;
					} else {
						// position an image to the center of slide
						layoutElementProps.xCoord = 0;
						layoutElementProps.yCoord = 0;
						layoutElementProps.width = currentSlide.width;
						layoutElementProps.height = currentSlide.height;
					}
					layoutElementProps.resize = true;
					layoutElementProps.animate = true;
					layoutElement = Storyboard.LayoutDesigner.addChartCreatorElement(layoutElementProps, Storyboard.Constants.itemTypes.IMAGE);
					layoutElementDiv = $(document.getElementById(layoutElement.guid));
				}

				layoutElement.isValid = true;
				Storyboard.GuiEvents.deselectAllBoxes();
				Storyboard.GuiEvents.selectBox(layoutElementDiv, layoutElement);

				$('#editImage').contents().find("#uploader").data({guid: null, event: null, position: null}).val('');
				resetUploadControlEvent()
			}, function() {
				$('#editImage').contents().find("#uploader").data({guid: null, event: null, position: null}).val('');
				resetUploadControlEvent()
			});
	}
	function resetUploadControlEvent() {
		$('#editImage').contents().find('#uploader').unbind().bind('change',function () {
			$('#editImage').contents().find('#uploadForm').submit()
		})
	}
	function handleObjectClick(evt, layoutElement) {
		var itemType = Storyboard.LayoutDesigner.getLayoutElementType(layoutElement);
		var position = calculateNewObjectPositionFromEvent(evt)	
		if (itemType === Storyboard.Constants.itemTypes.IMAGE && !layoutElement.isValid) {
			$('#editImage').contents().find('#uploader').unbind().removeAttr('onchange').bind('change', function (event) {
				imageUploadChangeHandler(event,layoutElement.guid,position)
			})
			$('#editImage').contents().find("#uploader").data({guid: layoutElement.guid, event: evt, position: position}).click();
		}
		
	}
	function createObjectTypeControls(element) {
		if (element) {
			var enabledTypes = getEnabledObjectTypes();
			var chartButton = enabledTypes.useChart ? '<button type="button" data-item-type="3" data-tooltip="New Chart" data-position="top" class="linkButton btnSetupAsChart"><img src="icons/bar_chart.png" alt="Chart"></button>' : '';
			var tableButton = enabledTypes.useTable ? '<button type="button" data-item-type="10" data-tooltip="New Table" data-position="top" class="linkButton btnSetupAsTable"><img src="icons/table.png" alt="Table"></button>' : '';
			var respondentTableButton = enabledTypes.useRespondentTable ? '<button type="button" data-item-type="9" data-tooltip="New Respondent Table" data-position="top" class="linkButton btnSetupAsRespondentTable"><img src="icons/respondenttable.png" alt="Respondent Table"></button>' : '';
			var imageButton = enabledTypes.useImage ? '<button type="button" data-item-type="5" data-tooltip="New Image" data-position="top" class="linkButton btnSetupAsImage"><img src="icons/image.png" alt="Image"></button>' : '';
			var dynamicImageButton = enabledTypes.useDynamicImage ? '<button type="button" data-item-type="11" data-tooltip="New Dynamic Image" data-position="top" class="linkButton btnSetupAsDynamicImage"><img src="icons/dynamicimage.png" alt="Dynamic Image"></button>' : '';
			var shapeButton = enabledTypes.useIconShape ? '<button type="button" data-item-type="16" data-tooltip="New Icon/Shape" data-position="top" class="linkButton btnSetupAsShape"><img src="icons/iconshape.png" alt="Icon/Shape"></button>' : '';
			var dynamicIconShapeButton = enabledTypes.useDynamicIconShape ? '<button type="button" data-item-type="17" data-tooltip="New Dynamic Icon/Shape" data-position="top" class="linkButton btnSetupAsDynamicIconShape"><img src="icons/dynamic_iconshape.png" alt="Dynamic Icon/Shape"></button>' : '';
			var textButton = enabledTypes.useText ? '<button type="button" data-item-type="8" data-tooltip="New Text" data-position="top" class="linkButton btnSetupAsText"><img src="icons/insert-text.png" alt="Text"></button>' : '';
			var textMediaButton = enabledTypes.useTextMedia ? '<button type="button" data-item-type="4" data-tooltip="New Text & Media" data-position="top" class="linkButton btnSetupAsTextMedia"><img src="icons/object_richtext.png" alt="Text & Media"></button>' : '';
			var textWordCloud = enabledTypes.useWordCloud ? '<button type="button" data-item-type="12" data-tooltip="New Word Cloud" data-position="top" class="linkButton btnSetupAsWordCloud"><img src="icons/wordcloud.png" alt="World Cloud"></button>' : '';

			var message = '';
			if (enabledTypes.useChart) message = 'chart';
			if (enabledTypes.useTable) message += (message.length > 0 ? (enabledTypes.useImage || enabledTypes.useText ? ', ' : ' or ') : '') + 'table';
			if (enabledTypes.useImage) message += (message.length > 0 ? (enabledTypes.useText ? ', ' : ' or ') : '') + 'image';
			if (enabledTypes.useIconShape) message += (message.length > 0 ? (enabledTypes.useIconShape ? ', ' : ' or ') : '') + 'shape';
			if (enabledTypes.useText) message += (message.length > 0 ? ' or ' : '') + 'text';

			var objectIcons = '';

			if (window.useNewStoryTellerLayout) {
				objectIcons = chartButton + tableButton + respondentTableButton + textWordCloud + dynamicIconShapeButton + textButton + textMediaButton + imageButton + dynamicImageButton + shapeButton;
				objectIcons = objectIcons.replace(/.png/g, '.svg');
			} else {
				objectIcons = chartButton + tableButton + respondentTableButton + imageButton + dynamicImageButton + shapeButton + dynamicIconShapeButton + textButton + textMediaButton + textWordCloud;
			}

			var newChartControls = '<div class="layoutElementEmptyObjectContainer"><div><p>Click the ' + message + ' to start setup</p>' + 
				'<div class="objectControlList">'+ objectIcons +'</div></div></div>';

			$(element).find('.editContent').css('display', 'none');
			$(element).find('.layoutElementEmptyChartCreator').html(newChartControls);

			Storyboard.LayoutDesigner.bindObjectTypeControlEvents(element, { isEmptyObjectMenu: true });
		}
	}

	function bindObjectTypeControlEvents(element, options) {
		const { isContextMenu, isEmptyObjectMenu } = options;
	
		function getLayoutElementFromEvent(event) {
			var guid = '';
	
			if (isContextMenu) guid = $(event.target).closest('.DUIContextMenu[id]').attr('id');
			if (isEmptyObjectMenu) guid = $(event.target).closest('.layoutElement').attr('guid');
	
			var layoutElementDiv = $('#' + guid, '#layoutArea');
			var layoutElement = Storyboard.LayoutDesigner.getLayoutElementByGuid(guid);
	
			return { layoutElement, layoutElementDiv };
		}
	
		function getItemTypeFromElement(element) {
			return Number($(element).attr('data-item-type'));
		}
	
		$(element)
			.find(
				[
					`[data-item-type="${itemTypes.CHART}"]`,
					`[data-item-type="${itemTypes.SIMPLETABLE}"]`,
					`[data-item-type="${itemTypes.RESPONDENTTABLE}"]`,
					`[data-item-type="${itemTypes.DYNAMICIMAGE}"]`,
					`[data-item-type="${itemTypes.DYNAMICICONSHAPE}"]`,
					`[data-item-type="${itemTypes.ICONSHAPE}"]`,
					`[data-item-type="${itemTypes.WORDCLOUD}"]`,
					`[data-item-type="${itemTypes.STATICTEXT}"]`,
					`[data-item-type="${itemTypes.TEXT}"]`,
				].join(', ')
			)
			.bind('click', function (event) {
				const { layoutElement, layoutElementDiv } = getLayoutElementFromEvent(event);
				const itemType = getItemTypeFromElement(event.currentTarget);
	
				convertToItemType(layoutElementDiv, itemType);
	
				if (isEmptyObjectMenu) {
					Storyboard.GuiEvents.deselectAllBoxes();
					Storyboard.GuiEvents.selectBox(layoutElementDiv, layoutElement);
				}
	
				if (isContextMenu || itemType === itemTypes.TEXT || itemType === itemTypes.STATICTEXT) {
					$('.editContent', layoutElementDiv).trigger('click');
				}
	
				Storyboard.GuiEvents.hideAllMenusAndPanels(event);
				event.stopPropagation();
			});
	
		$(element)
			.find(`[data-item-type="${itemTypes.IMAGE}"]`)
			.bind('click', function (evt) {
				const { layoutElementDiv } = getLayoutElementFromEvent(evt);
				var guid = layoutElementDiv.attr('guid');
				var position = calculateNewObjectPositionFromEvent(evt);
	
				$('#editImage').contents().find('#uploader').unbind().removeAttr('onchange')
					.bind('change', function (event) {
						imageUploadChangeHandler(event, guid, position);
					});
				$('#editImage').contents().find('#uploader').data({ guid: guid, event: evt, position: position }).click();
	
				Storyboard.GuiEvents.hideAllMenusAndPanels(evt);
				evt.stopPropagation();
			});
	}

	function insertNewEmptyObject(event) {
		var position = calculateNewObjectPositionFromEvent(event);
		var layoutElement = Storyboard.LayoutDesigner.addChartCreatorElement(position, Storyboard.Constants.itemTypes.EMPTYCHARTCREATOR);
		var layoutElementDiv = $(document.getElementById(layoutElement.guid));
		$(layoutElementDiv).addClass('layoutElementEmptyChartCreator');

		createObjectTypeControls(layoutElementDiv);

		Storyboard.GuiEvents.deselectAllBoxes();
		Storyboard.GuiEvents.selectBox(layoutElementDiv, layoutElement);
	}
	function insertNewChartObject(event) {
		var position = calculateNewObjectPositionFromEvent(event);
		var layoutElement = Storyboard.LayoutDesigner.addChartCreatorElement(position, Storyboard.Constants.itemTypes.CHART);
		var layoutElementDiv = $(document.getElementById(layoutElement.guid));

		Storyboard.GuiEvents.deselectAllBoxes();
		Storyboard.GuiEvents.selectBox(layoutElementDiv, layoutElement);		
	}
	function insertNewTableObject(event) {
		var position = calculateNewObjectPositionFromEvent(event);
		var layoutElement = Storyboard.LayoutDesigner.addChartCreatorElement(position, Storyboard.Constants.itemTypes.SIMPLETABLE);
		var layoutElementDiv = $(document.getElementById(layoutElement.guid));

		Storyboard.GuiEvents.deselectAllBoxes();
		Storyboard.GuiEvents.selectBox(layoutElementDiv, layoutElement);
	}
	function insertNewRespondentTableObject(event) {
		var position = calculateNewObjectPositionFromEvent(event);
		var layoutElement = Storyboard.LayoutDesigner.addChartCreatorElement(position, Storyboard.Constants.itemTypes.RESPONDENTTABLE);
		var layoutElementDiv = $(document.getElementById(layoutElement.guid));

		Storyboard.GuiEvents.deselectAllBoxes();
		Storyboard.GuiEvents.selectBox(layoutElementDiv, layoutElement);
	}
	
	function insertNewImageObject(event) {
		var position = $('body > .DUIContextMenu').data('position');
		$('#editImage').contents().find("#uploader").data({guid: null, event: event, position: position}).click();
	}
	function insertNewDynamicImageObject(event) {
		var position = calculateNewObjectPositionFromEvent(event);
		var layoutElement = Storyboard.LayoutDesigner.addChartCreatorElement(position, Storyboard.Constants.itemTypes.DYNAMICIMAGE);
		var layoutElementDiv = $(document.getElementById(layoutElement.guid));

		Storyboard.GuiEvents.deselectAllBoxes();
		Storyboard.GuiEvents.selectBox(layoutElementDiv, layoutElement);
	}
	function insertNewShapeObjectType(event) {
		var position = calculateNewObjectPositionFromEvent(event);
		var layoutElement = Storyboard.LayoutDesigner.addChartCreatorElement(position, Storyboard.Constants.itemTypes.ICONSHAPE);
		var layoutElementDiv = $(document.getElementById(layoutElement.guid));

		Storyboard.GuiEvents.deselectAllBoxes();
		Storyboard.GuiEvents.selectBox(layoutElementDiv, layoutElement);
	}
	function insertNewDynamicIconShapeObjectType(event) {
		var position = calculateNewObjectPositionFromEvent(event);
		var layoutElement = Storyboard.LayoutDesigner.addChartCreatorElement(position, Storyboard.Constants.itemTypes.DYNAMICICONSHAPE);
		var layoutElementDiv = $(document.getElementById(layoutElement.guid));

		Storyboard.GuiEvents.deselectAllBoxes();
		Storyboard.GuiEvents.selectBox(layoutElementDiv, layoutElement);
	}
	function insertNewTextObject(event) {
		var position = calculateNewObjectPositionFromEvent(event);
		var layoutElement = Storyboard.LayoutDesigner.addChartCreatorElement(position, Storyboard.Constants.itemTypes.STATICTEXT);
		var layoutElementDiv = $(document.getElementById(layoutElement.guid));
		var animationEnd = Helpers.animationEnd();

		Storyboard.GuiEvents.deselectAllBoxes();
		Storyboard.GuiEvents.selectBox(layoutElementDiv, layoutElement);

		if (layoutElement.animate && animationEnd) {
			layoutElementDiv.bind(animationEnd, function() {
				$('.editContent', layoutElementDiv).trigger('click');
				$(this).unbind(animationEnd);
			});
		} else {
			$('.editContent', layoutElementDiv).trigger('click');
		}
	}
	function insertNewTextMediaObject(event) {
		var position = calculateNewObjectPositionFromEvent(event);
		var layoutElement = Storyboard.LayoutDesigner.addChartCreatorElement(position, Storyboard.Constants.itemTypes.TEXT);
		var layoutElementDiv = $(document.getElementById(layoutElement.guid));

		Storyboard.GuiEvents.deselectAllBoxes();
		Storyboard.GuiEvents.selectBox(layoutElementDiv, layoutElement);
	}
	function insertNewWordCloudObject(event) {
		var position = calculateNewObjectPositionFromEvent(event);
		var layoutElement = Storyboard.LayoutDesigner.addChartCreatorElement(position, Storyboard.Constants.itemTypes.WORDCLOUD);
		var layoutElementDiv = $(document.getElementById(layoutElement.guid));

		Storyboard.GuiEvents.deselectAllBoxes();
		Storyboard.GuiEvents.selectBox(layoutElementDiv, layoutElement);
	}
	function closeObjectTypesMenu() {
		$('#objectTypesContextMenu').remove();
	}

    var TrackingSlideViews = function() {
        var slideObserver;
        var slideViews = {};
        var visibleSlides = new Set();
        var refreshIntervalID = 0;
        var testTrackingSlideViews = typeof window.testTrackingSlideViews !== 'undefined' && window.testTrackingSlideViews === true;
        var reportId = Helpers.getReportID();
        var reportNamesById = {};
        $('#nav a').toArray().forEach(function(a) {
            var params = new URLSearchParams(a.href);
            var rpId = params.get('RpId');
            if (rpId) reportNamesById[rpId] = a.innerText;
        });
        $('#reportTabStripWrapper a, #reportTree a').toArray().forEach(function(a) {
            var regex = /\\(\d+)(?=['\\)]*$)/;
            var match = a.href.match(regex);
            var number = match ? match[1] : null;
            var extractedNumber = number ? parseInt(number, 10) : null;
            if (extractedNumber) reportNamesById[extractedNumber] = a.innerText;
        });

        function startTracking() {
            var observerOptions = {
                root: null,
                rootMargin: "0px",
                threshold: [0.0, 0.75]
            };
    
            slideObserver = new IntersectionObserver(intersectionCallback, observerOptions);
    
            var slides = Storyboard.LayoutDesigner.getLayoutSlides();
    
            slides
                .filter(function(slide) { return !slide.isBackground; })
                .forEach(observeSlide);
    
            document.addEventListener('visibilitychange', handleVisibilityChange, false);
            
            refreshIntervalID = window.setInterval(handleRefreshInterval, 1000);
        }

        function stopTracking() {
            var slides = Storyboard.LayoutDesigner.getLayoutSlides();
    
            slides
                .filter(function(slide) { return !slide.isBackground; })
                .forEach(unobserveSlide);
            
            visibleSlides = new Set();

            document.removeEventListener('visibilitychange', handleVisibilityChange);
            window.clearInterval(refreshIntervalID);
        }

        function getSlideViews() {
            return Object.values(slideViews).filter(function(slideViewDetails) {
                        return slideViewDetails.totalViewTime > 0;
                    }).map(function(slideViewDetails) {
                        return {
                            slideId: slideViewDetails.slideId,
                            slideIndex: slideViewDetails.slideIndex,
                            slideName: slideViewDetails.slideName,
                            totalViewTime: Math.round(slideViewDetails.totalViewTime)
                        }
                    });
        }

        function getVisibleSlides() {
            return visibleSlides;
        }

        function sendSlideViewData() {
            var analyticsData = {
                reportId: reportId,
                reportName: reportNamesById[reportId] || '',
                data: {
                    slideViews: getSlideViews()
                }
            };

            if (!('fetch' in window) || analyticsData.data.slideViews.length === 0) return Promise.reject();

            var qry = window.document.URL.toString();
            var url = 'RHViewStoryboard.aspx/LogMsg';

            qry = (qry.indexOf('?') > 0) ? '?' + encodeURI(qry.split('?')[1]) : null;
            url += qry ? qry : '';

            return fetch(url, {
                method: 'POST', 
                body: JSON.stringify({ message: 'Analytics data: ' + JSON.stringify(analyticsData).replaceAll('{', '{{').replaceAll('}', '}}') }),
                headers: {
                    'Content-Type': 'application/json; charset=utf-8',
                    antiXsrfToken: $("[id$='AntiXsrfToken']").val()
                },
                // The keepalive option can be used to allow the request to outlive the page. 
                // Fetch with the keepalive flag is a replacement for the Navigator.sendBeacon() API.
                keepalive: true 
            });
        }

        function handleVisibilityChange() {
            if (document.hidden) {
                sendSlideViewData()
                    .then(function() {
                        Object.values(slideViews).forEach(function(slideView) {
                            slideView.totalViewTime = 0;
                            slideView.lastViewStarted = 0;
                        });
                    })
                    .catch(function() {});
                window.clearInterval(refreshIntervalID);
            } else {
                refreshIntervalID = window.setInterval(handleRefreshInterval, 1000);
            }
        }

        function intersectionCallback(entries) {
            entries.forEach(function (entry) {
                var slideEl = entry.target;
                var guid = slideEl.id;
    
                if (entry.isIntersecting) {
                    if (entry.intersectionRatio >= 0.75) {
                        slideViews[guid].lastViewStarted = entry.time;
                        visibleSlides.add(slideEl);
                    }
                } else {
                    visibleSlides.delete(slideEl);
                }
            });
        }
    
        function handleRefreshInterval() {
            var redrawList = [];
        
            visibleSlides.forEach(function(slideEl) {
                var guid = slideEl.id;
                var previousTime = slideViews[guid].totalViewTime;
                updateSlideTimer(slideEl);

                if (testTrackingSlideViews && previousTime != slideViews[guid].totalViewTime) {
                    redrawList.push(slideEl);
                }
            });

            if (redrawList.length > 0) {
            window.requestAnimationFrame(function() {
                redrawList.forEach(function(slideEl) {
                    drawSlideTimer(slideEl);
                });
            });
            }
        }
    
        function updateSlideTimer(slideEl) {
            var guid = slideEl.id;
            var lastStarted = slideViews[guid].lastViewStarted;
            var currentTime = performance.now();
    
            if (lastStarted) {
                var diff = currentTime - lastStarted;
    
                slideViews[guid].totalViewTime = parseFloat(slideViews[guid].totalViewTime) + diff;
            }
    
            slideViews[guid].lastViewStarted = currentTime;
        }
    
        function drawSlideTimer(slideEl) {
            var guid = slideEl.id;
            var timerEl = slideEl.querySelector('.timer');

            if (!timerEl) {
                timerEl = document.createElement("div");
                timerEl.className = 'timer';
                timerEl.innerText = '0:00';
                timerEl.style.position = 'absolute';
                timerEl.style.top = 0;
                timerEl.style.left = 0;
                timerEl.style.background = 'magenta';
                timerEl.style.color = 'white';
                timerEl.style.fontWeight = 'bold';
                timerEl.style.padding = '0 0.5em';
                timerEl.style.zIndex = 10000;

                slideEl.appendChild(timerEl);
            }

            var totalSeconds = slideViews[guid].totalViewTime / 1000;
            var sec = Math.floor(totalSeconds % 60);
            var min = Math.floor(totalSeconds / 60);
        
            timerEl.innerText = min + ":" + sec.toString().padStart(2, "0");
        }
    
        function observeSlide(slide) {
            var slideEl = document.getElementById(slide.guid);
    
            slideViews[slide.guid] = {
                slideId: slide.slideId,
                slideIndex: slide.slideIndex,
                slideName: slide.slideName,
                totalViewTime: 0,
                lastViewStarted: 0,
            };
    
            slideObserver.observe(slideEl);
        }

        function unobserveSlide(slide) {
            var slideEl = document.getElementById(slide.guid);
            slideObserver.unobserve(slideEl);
        }

        return {
            startTracking: startTracking,
            stopTracking: stopTracking,
            getVisibleSlides: getVisibleSlides,
            getSlideViews: getSlideViews,
            sendSlideViewData: sendSlideViewData
        }
    };

    function startTrackingSlideViews() {
        if ('IntersectionObserver' in window) {
            var trackingSlideViews = TrackingSlideViews();
            trackingSlideViews.startTracking();

            window.trackingSlideViews = trackingSlideViews;
        }
    }

	function validateCharts(chartsToAdd) {
		var limit = 200;

		var layoutElements = Storyboard.LayoutDesigner.getLayoutElements();
		var chartLayoutElements = layoutElements.filter(function (layoutElement) {
			var itemType = Storyboard.LayoutDesigner.getLayoutElementType(layoutElement);
			return itemType === Storyboard.Constants.itemTypes.CHART ||
				itemType === Storyboard.Constants.itemTypes.SIMPLETABLE ||
				itemType === Storyboard.Constants.itemTypes.EMPTYCHARTCREATOR;
		});
		var chartsCount = chartLayoutElements.length;
		var newChartsCount = chartsCount + chartsToAdd;

		var limitReachedMessage = locale.get('The current deck contains the maximum allowed of #LIMIT# charts/tables. No more objects can be added.');
		var closeToLimitMessage = locale.get('The current deck contains #N# charts/tables, a maximum of #LIMIT# charts/tables is allowed in one deck.');

		if (newChartsCount > limit) {
			limitReachedMessage = limitReachedMessage.replace('#LIMIT#', '<b>' + limit + '</b>');
			DUImessage.show(limitReachedMessage, 'Message-warning', 5000);
			return false;
		} else if (newChartsCount >= (limit - 10)) {
			closeToLimitMessage = closeToLimitMessage.replace('#N#', '<b>' + newChartsCount + '</b>').replace('#LIMIT#', '<b>' + limit + '</b>');
			DUImessage.show(closeToLimitMessage, 'Message-warning', 5000);
			return true;
		}

		return true;
	}

	sb.EventBus = (function() {
		var eventTarget = document.body && document.body.firstElementChild ?
			document.body.firstElementChild.appendChild(document.createComment('storyboard-events')) :
			document.head.appendChild(document.createComment('storyboard-events'));
		return {
			on: function(type, listener) { eventTarget.addEventListener(type, listener); },
			once: function(type, listener) { eventTarget.addEventListener(type, listener, { once: true }); },
			off: function(type, listener) { eventTarget.removeEventListener(type, listener); },
			emit: function(type, detail) { return eventTarget.dispatchEvent(new CustomEvent(type, { detail })); },
		}
	})();

    sb.LayoutDesigner.defaultExportFileName = defaultExportFileName;
	sb.LayoutDesigner.myStoriesSharingType = myStoriesSharingType;
	sb.LayoutDesigner.enableMyStoriesSharing = enableMyStoriesSharing;
	sb.LayoutDesigner.isAdmin = isAdmin;
	sb.LayoutDesigner.hideSlideNavigationCurrentSlide = hideSlideNavigationCurrentSlide;
    sb.LayoutDesigner.addLayoutElement = addLayoutElement;
    sb.LayoutDesigner.addChartCreatorElement = addChartCreatorElement;
	sb.LayoutDesigner.elementItemHasId = elementItemHasId;
	sb.LayoutDesigner.processUploadedImageFile = processUploadedImageFile;
	sb.LayoutDesigner.storeFiltersSelections = storeFiltersSelections;
	sb.LayoutDesigner.storeSelections = storeSelections;
	sb.LayoutDesigner.storeSelectedDates = storeSelectedDates;
    sb.LayoutDesigner.storeSelectedRespondent = storeSelectedRespondent;
    sb.LayoutDesigner.storeRespTablesVariables = storeRespTablesVariables;
	sb.LayoutDesigner.loadFormContent = loadFormContent;
	sb.LayoutDesigner.loadTextBox = loadTextBox;
	sb.LayoutDesigner.loadDrilldownContent = loadDrilldownContent;
	sb.LayoutDesigner.loadStorytellerContent = loadStorytellerContent;
	sb.LayoutDesigner.loadStorytellerContentForElements = loadStorytellerContentForElements;
	sb.LayoutDesigner.loadLayout = loadLayout;
	sb.LayoutDesigner.loadCoordinatesComplete = loadCoordinatesComplete;
	sb.LayoutDesigner.loadExcludedSlides = loadExcludedSlides;
    sb.LayoutDesigner.getChartForLayoutElementCompleted = getChartForLayoutElementCompleted;
    sb.LayoutDesigner.getLayoutGrid = getLayoutGrid;
    sb.LayoutDesigner.setLayoutGrid = setLayoutGrid;
	sb.LayoutDesigner.getLayoutElements = getLayoutElements;
	sb.LayoutDesigner.getLayoutElementType = getLayoutElementType;
	sb.LayoutDesigner.getNewZIndex = getNewZIndex;
	sb.LayoutDesigner.getNewGroupId = getNewGroupId;
	sb.LayoutDesigner.getPageSize = getPageSize;
	sb.LayoutDesigner.setPageSize = setPageSize;
	sb.LayoutDesigner.getDetailTables = getDetailTables;
	sb.LayoutDesigner.getBackgroundImage = getBackgroundImage;
	sb.LayoutDesigner.getNumberOfSlides = getNumberOfSlides;
	sb.LayoutDesigner.downloadSelected = downloadSelected;
	sb.LayoutDesigner.downloadSelectedFilters = downloadSelectedFilters;
	sb.LayoutDesigner.exportExcel = exportExcel;
	sb.LayoutDesigner.getPageCount = getPageCount;
	sb.LayoutDesigner.setElementItemProperties = setElementItemProperties;
	sb.LayoutDesigner.addOrReplaceElementItem = addOrReplaceElementItem;
	sb.LayoutDesigner.deleteElementItem = deleteElementItem;
	sb.LayoutDesigner.getLayoutElementsWithInputVars = getLayoutElementsWithInputVars;
	sb.LayoutDesigner.getLayoutElementByGuid = getLayoutElementByGuid;
	sb.LayoutDesigner.getLayoutElementByElementItem = getLayoutElementByElementItem;
	sb.LayoutDesigner.getLayoutElementsByType = getLayoutElementsByType;
	sb.LayoutDesigner.getElementItemByGuid = getElementItemByGuid;
	sb.LayoutDesigner.getElementItemByType = getElementItemByType;
	sb.LayoutDesigner.getElementItemByTypeOrDefault = getElementItemByTypeOrDefault;
	sb.LayoutDesigner.getLayoutElementItem = getLayoutElementItem;
	sb.LayoutDesigner.createElementItem = createElementItem;
	sb.LayoutDesigner.getDetailTable = getDetailTable;
	sb.LayoutDesigner.getDetailTableData = getDetailTableData;
	sb.LayoutDesigner.getLayoutElementsByPage = getLayoutElementsByPage;
	sb.LayoutDesigner.getLayoutElementsByGroup = getLayoutElementsByGroup;
	sb.LayoutDesigner.getLayoutElementsGroup = getLayoutElementsGroup;
	sb.LayoutDesigner.getLayoutElementById = getLayoutElementById;
	sb.LayoutDesigner.getLayoutElementByIdOrGuid = getLayoutElementByIdOrGuid;
	sb.LayoutDesigner.saveDUITableDesign = saveDUITableDesign;
	sb.LayoutDesigner.eventRedrawLayoutElement = null;
	sb.LayoutDesigner.eventUpdateChart = null;
	sb.LayoutDesigner.eventUpdateSimpleTable = null;
	sb.LayoutDesigner.eventRedrawLayoutGrid = null;
	sb.LayoutDesigner.endRequestReportTreePanel = endRequestReportTreePanel;
	sb.LayoutDesigner.setSlideshowMode = setSlideshowMode;
	sb.LayoutDesigner.slideShowMode = slideShowMode;
	sb.LayoutDesigner.deviceLimitEnabled = deviceLimitEnabled;
    sb.LayoutDesigner.exportReportAsScreenshot = exportReportAsScreenshot;
	sb.LayoutDesigner.imageQuality = imageQuality;
	sb.LayoutDesigner.enableMasterSlideLayout = enableMasterSlideLayout;
	sb.LayoutDesigner.showBgInExportOnly = showBgInExportOnly;
	sb.LayoutDesigner.initSlideNavigation = initSlideNavigation;
	sb.LayoutDesigner.updateSlideNavigation = updateSlideNavigation;
	sb.LayoutDesigner.moveSlide = moveSlide;
	sb.LayoutDesigner.getDocumentFormatAsString = getDocumentFormatAsString;
	sb.LayoutDesigner.getDocumentFormatFromString = getDocumentFormatFromString;
	sb.LayoutDesigner.getCurrentPageNo = getCurrentPageNo;
	sb.LayoutDesigner.setCurrentPageNo = setCurrentPageNo;
	sb.LayoutDesigner.setPageNoByLayoutElementId = setPageNoByLayoutElementId;
	sb.LayoutDesigner.getSlideNoByLayoutElementId = getSlideNoByLayoutElementId;
	sb.LayoutDesigner.scrollPageIntoLayoutElement = scrollPageIntoLayoutElement;
	sb.LayoutDesigner.getCachedContent = getCachedContent;
	sb.LayoutDesigner.resetCachedContentForElement = resetCachedContentForElement;
	sb.LayoutDesigner.clearElementContent = clearElementContent;
	sb.LayoutDesigner.clearAllLoadedContent = clearAllLoadedContent;
	sb.LayoutDesigner.getImageQualityDisplay = getImageQualityDisplay;
	sb.LayoutDesigner.setImageQualityDisplay = setImageQualityDisplay;
	sb.LayoutDesigner.isMyStoryMode = isMyStoryMode;
	sb.LayoutDesigner.openFormReportFromLink = openFormReportFromLink;
	sb.LayoutDesigner.getHFilterLayout = getHFilterLayout;
	sb.LayoutDesigner.getHFilterSelectionMode = getHFilterSelectionMode;
	sb.LayoutDesigner.setHFilterLayout = setHFilterLayout;
	sb.LayoutDesigner.groupElements = groupElements;
	sb.LayoutDesigner.ungroupElements = ungroupElements;
	sb.LayoutDesigner.clearGroups = clearGroups;
	sb.LayoutDesigner.getSelectedGroupId = getSelectedGroupId;
	sb.LayoutDesigner.getLayoutElementsAreaHeight = getLayoutElementsAreaHeight;
	sb.LayoutDesigner.saveLayoutElementState = saveLayoutElementState;
	sb.LayoutDesigner.saveLayoutElementName = saveLayoutElementName;
	sb.LayoutDesigner.checkInMemoryDataModelUpdated = checkInMemoryDataModelUpdated;
	sb.LayoutDesigner.updateInMemory = updateInMemory;
	sb.LayoutDesigner.translatedLayoutElements = translatedLayoutElements;
	sb.LayoutDesigner.updateLayoutElements = updateLayoutElements;
	sb.LayoutDesigner.autoUpdateLayoutElements = autoUpdateLayoutElements;
	sb.LayoutDesigner.invokeDynamicFiltering = invokeDynamicFiltering;
	sb.LayoutDesigner.updateStaticLayoutElements = updateStaticLayoutElements;
	sb.LayoutDesigner.clearLanguageDependentCache = clearLanguageDependentCache;
	sb.LayoutDesigner.inMemoryUpdateConfirm = inMemoryUpdateConfirm;
	// slides operations
	sb.LayoutDesigner.addLayoutSlide = addLayoutSlide;
	sb.LayoutDesigner.eventRedrawLayoutSlide = null;
	sb.LayoutDesigner.getCurrentSlide = getCurrentSlide;
	sb.LayoutDesigner.getSlideByIndex = getSlideByIndex;
	sb.LayoutDesigner.getSlideById = getSlideById;
	sb.LayoutDesigner.getSlideByLayoutElement = getSlideByLayoutElement;
	sb.LayoutDesigner.getLayoutSlides = getLayoutSlides;
	sb.LayoutDesigner.setDefaultMasterTemplateIDAllLayoutSlides = setDefaultMasterTemplateIDAllLayoutSlides;
	sb.LayoutDesigner.loadTokensInSlideSS = loadTokensInSlideSS;
	sb.LayoutDesigner.getLayoutElementsBySlide = getLayoutElementsBySlide;
	sb.LayoutDesigner.moveElementToSlide = moveElementToSlide;
	sb.LayoutDesigner.setSlidesSize = setSlidesSize;
	sb.LayoutDesigner.getCurrentSlideSize = getCurrentSlideSize;
	sb.LayoutDesigner.getBackgroundSlide = getBackgroundSlide;
	sb.LayoutDesigner.setCurrentBackgroundSlide = setCurrentBackgroundSlide;
	sb.LayoutDesigner.getLoadedSlideIds = getLoadedSlideIds;
    sb.LayoutDesigner.setLayoutAreaSize = setLayoutAreaSize;
    sb.LayoutDesigner.deleteSlide = deleteSlide;
    sb.LayoutDesigner.deleteLayoutSlide = deleteLayoutSlide;
    sb.LayoutDesigner.deleteLayoutElement = deleteLayoutElement;
    sb.LayoutDesigner.getHiddenSeriesFromSlide = getHiddenSeriesFromSlide;
    sb.LayoutDesigner.getHiddenSeries = getHiddenSeries;

	sb.LayoutDesigner.setExportOptions = setExportOptions;
	sb.LayoutDesigner.getExportOptions = getExportOptions;
	sb.LayoutDesigner.setEnabledScreenTypes = setEnabledScreenTypes;
	sb.LayoutDesigner.getEnabledScreenTypes = getEnabledScreenTypes;
	sb.LayoutDesigner.printStoryteller = printStoryteller;

	sb.LayoutDesigner.destroyExportPanel = destroyExportPanel;
	sb.LayoutDesigner.resetExportFileName = resetExportFileName;
	//exposed type
	sb.LayoutDesigner.LayoutElementItem = LayoutElementItem;
	sb.LayoutDesigner.loadFontSettings = loadFontSettings;
	sb.LayoutDesigner.getFonts = getFonts;
    sb.LayoutDesigner.getDefaultFont = getDefaultFont;
    sb.LayoutDesigner.setFontSettings = setFontSettings;
    sb.LayoutDesigner.queueExport = queueExport;

	sb.LayoutDesigner.loadMyStoryContent = loadMyStoryContent;
	sb.LayoutDesigner.getProcessedData = getProcessedData;
	sb.LayoutDesigner.loadChartCreatorFavoriteComplete = loadChartCreatorFavoriteComplete;
	sb.LayoutDesigner.getRespTablesSelectedVariablesInfo = getRespTablesSelectedVariablesInfo;

	sb.LayoutDesigner.deleteAction = deleteAction;

	sb.LayoutDesigner.isBulkHFilterExportEnabled = isBulkHFilterExportEnabled;

	//exposed methods for object creation (methods from chart creator)
	sb.LayoutDesigner.getObjectTypesHTML = getObjectTypesHTML;
	sb.LayoutDesigner.insertNewEmptyObject = insertNewEmptyObject;
	sb.LayoutDesigner.insertNewChartObject = insertNewChartObject;
	sb.LayoutDesigner.insertNewTableObject = insertNewTableObject;
	sb.LayoutDesigner.insertNewRespondentTableObject = insertNewRespondentTableObject;
	sb.LayoutDesigner.insertNewImageObject = insertNewImageObject;
	sb.LayoutDesigner.insertNewDynamicImageObject = insertNewDynamicImageObject;
	sb.LayoutDesigner.insertNewShapeObjectType = insertNewShapeObjectType;
	sb.LayoutDesigner.insertNewDynamicIconShapeObjectType = insertNewDynamicIconShapeObjectType;
	sb.LayoutDesigner.insertNewTextObject = insertNewTextObject;
	sb.LayoutDesigner.insertNewTextMediaObject = insertNewTextMediaObject;
	sb.LayoutDesigner.insertNewWordCloudObject = insertNewWordCloudObject;
	sb.LayoutDesigner.closeObjectTypesMenu = closeObjectTypesMenu;
	sb.LayoutDesigner.createObjectTypeControls = createObjectTypeControls;
	sb.LayoutDesigner.bindObjectTypeControlEvents = bindObjectTypeControlEvents;
	sb.LayoutDesigner.handleObjectClick = handleObjectClick;
	sb.LayoutDesigner.validateCharts = validateCharts;
	sb.LayoutDesigner.convertToItemType = convertToItemType;
	

})(window.Storyboard = (window.Storyboard || {}));

$(document).ready(function () {
	var isChartCreator = window.ContentType > 0 && window.ContentType === Storyboard.Constants.itemTypes.CHART;
	var isCrossTable = window.ContentType > 0 && window.ContentType === Storyboard.Constants.itemTypes.CROSSTABLE;

	//bind ui events
	Storyboard.LayoutDesigner.eventRedrawLayoutElement = Storyboard.GuiEvents.redrawLayoutElement;
	Storyboard.LayoutDesigner.eventUpdateChart = Storyboard.GuiEvents.updateChart;
	Storyboard.LayoutDesigner.eventUpdateSimpleTable = Storyboard.GuiEvents.updateSimpleTable;
	Storyboard.LayoutDesigner.eventRedrawLayoutGrid = Storyboard.GuiEvents.redrawLayoutGrid;
	Storyboard.LayoutDesigner.eventRedrawLayoutSlide = Storyboard.GuiEvents.redrawLayoutSlide;
	Storyboard.HighchartsWrapper.callbackShowChart = Storyboard.GuiEvents.showEnlargedChart;
	Storyboard.HighchartsWrapper.callbackShowDetailTable = Storyboard.GuiEvents.showDetailTable;

	// End request handler for reporttree panel.
	// Check and hide top tree node
	erq_ReportTreePanel();

	$('#pageWrapper')
		.click(function (evt) {
			var target = $(evt.target);
			
			if (isCrossTable || target.is('#pageWrapper') || target.is('#reportWrapper')) {
				Storyboard.GuiEvents.hideAllMenusAndPanels(evt);
			}
			
			if (Storyboard.LayoutDesigner.isAdmin && !isChartCreator && !Helpers.isPreview() && Storyboard.LayoutDesigner.getLayoutGrid() &&
				evt.which !== 3 && !target.is('#layoutArea') && !target.is('.layoutSlide') && !target.is('INPUT')) {
				Storyboard.GuiEvents.deselectAllBoxes();
				Storyboard.GuiEvents.deselectAllGroups();
				Storyboard.GuiEvents.updateTemplatesMenu();
				Storyboard.LayoutDesigner.LayoutElementsToolbar.updateToolbarState();
				$('body > .DUIContextMenu').remove();
			}
		})
		.delegate('#DUI-ST-R-SHOWFILTERPANEL', 'mousedown', function (evt) {
			//SHOW OPTIONAL FILTERS PANEL
			evt.stopPropagation();
			if (Storyboard.GuiEvents.isElementDisabled(evt.currentTarget)) {
				evt.stopImmediatePropagation();
				return false;
			}

			Storyboard.GuiEvents.hideAllMenusAndPanels();
			Storyboard.LayoutControls.showLoadingBar('Loading optional filters...');
			setTimeout(function () {
				GeneralSettingsAdmin.addAsDialog();
				Storyboard.LayoutControls.hideLoadingBar();
			}, 500);
		})
		.delegate('#DUI-ST-R-SHOWCHARTLABSETUP', 'mousedown', function (evt) {
			//SHOW CHART LAB WINDOW
			evt.stopPropagation();
			if (Storyboard.GuiEvents.isElementDisabled(evt.currentTarget)) {
				evt.stopImmediatePropagation();
				return false;
			}
			Storyboard.GuiEvents.hideAllMenusAndPanels();
			Storyboard.ChartLab.Setup.loadSettings();
		})
		.delegate('#DUI-ST-R-SHOWHFILTERSSETUP', 'mousedown', function (evt) {
			evt.stopPropagation();
			if (Storyboard.GuiEvents.isElementDisabled(evt.currentTarget)) {
				evt.stopImmediatePropagation();
				return false;
			}
			Storyboard.GuiEvents.hideAllMenusAndPanels();
			GeneralSettingsAdmin.hFilterSetupAsDialog();
		})
		.delegate('#DUI-ST-R-EXCLUDESLIDES', 'mousedown', function (evt) {
			evt.stopPropagation();
			if (Storyboard.GuiEvents.isElementDisabled(evt.currentTarget)) {
				evt.stopImmediatePropagation();
				return false;
			}
			Storyboard.GuiEvents.hideAllMenusAndPanels();
			GeneralSettingsAdmin.excludeSlidesSetupAsDialog();
		})
		.delegate('#DUI_ST_R_REFERENCEDATASETUP', 'mousedown', function (evt) {
			evt.stopPropagation();
			if (Storyboard.GuiEvents.isElementDisabled(evt.currentTarget)) {
				evt.stopImmediatePropagation();
				return false;
			}
			Storyboard.GuiEvents.hideAllMenusAndPanels();
			GeneralSettingsAdmin.referenceDataSetupAsDialog();
		})
		.delegate("#DUI_ST_R_DOCUMENTFORMATSETUP", "mousedown", function (evt) {
			evt.stopPropagation();
			if (Storyboard.GuiEvents.isElementDisabled(evt.currentTarget)) {
				evt.stopImmediatePropagation();
				return false;
			}
			Storyboard.GuiEvents.hideAllMenusAndPanels();
			Storyboard.LayoutDesigner.docFormatSetupAsDialog();
		});

	$('#bulkUploadsEdits').bind('click', function (evt) {
		evt.stopPropagation();
		$("#bulkUploadsAndEditsContainer").css("display", "block")
			.parent().addClass("DUISetupOuter").css("z-index", "10000");
	});

	// Setup EventHandlers for ExportPanel //
	$('#btnOpenExportPanel, #btnExportSTLayout, #btnOpenExportPanel_cc').bind("click", function (evt) {
		if (Storyboard.GuiEvents.isElementDisabled(evt.currentTarget)) {
			evt.stopImmediatePropagation();
			return false;
		}

		var formats = Storyboard.Constants.documentFormats;
		var exportOptions = Storyboard.LayoutDesigner.getExportOptions();
		var layoutType = Storyboard.LayoutDesigner.getLayoutGrid().layoutType;

		if (exportOptions.pdfExport ||
			((exportOptions.pptExport || exportOptions.pptNativeExport) && (layoutType == formats.PPTONLINE.hash || layoutType == formats.PPT_16_9.hash || layoutType == formats.CUSTOM.hash)) ||
			(exportOptions.excelExport && (layoutType != formats.A4LANDSCAPE_LEGACY.hash && layoutType != formats.A4PORTRAIT_LEGACY.hash))) {
			Storyboard.LayoutDesigner.downloadSelected();
		} else {
			Storyboard.LayoutDesigner.downloadSelectedFilters();
		}
	});
	// End setup EventHandlers for Exportpanel //

	//sharing
	$("#btnMyStoriesSetup").bind("click", function() {
		Storyboard.LayoutDesigner.docFormatSetupAsDialog();
	});
	var storyModal;
	$("#btnMyStoriesShare").bind("click", function() {
		storyModal = new DUIwindow2({
			title: '<h2>Share MyStory</h2>',
			preWrapSpace: false,
			width: 440,
			buttons: [],
			cssClass: 'storyCreatorTabsPanel',
			afterShow: function() {
				$(this.windowEl).find('.DUI-WINDOW-BODY').append($('#mystorySelectionContent_ms'));
			},
			beforeClose: function() {
				$('#mystorySelection_ms').append($('#mystorySelectionContent_ms'));
			}
		});
		$('#hidEditSharingStoryId').val($("#ddlMyStories").val());
		var isPmOrAdmin = window.UserType <= 3
		$('.storySharingCheck').hide();
		var shareWithAll = isPmOrAdmin || (Storyboard.LayoutDesigner.myStoriesSharingType & Storyboard.Constants.FavoriteSharingType.AllUsers) == Storyboard.Constants.FavoriteSharingType.AllUsers;
		if (shareWithAll)
			$('#cbShareWithAll_ms').parent().show();

		var shareWithAllGroups = ProjectHasUserGroups &&
			(isPmOrAdmin || (Storyboard.LayoutDesigner.myStoriesSharingType & Storyboard.Constants.FavoriteSharingType.AllGroups) == Storyboard.Constants.FavoriteSharingType.AllGroups);
		var shareWithOwnGroup = ProjectHasUserGroups && CurrentUserBelongsToGroups &&
			(Storyboard.LayoutDesigner.myStoriesSharingType & Storyboard.Constants.FavoriteSharingType.OwnGroup) == Storyboard.Constants.FavoriteSharingType.OwnGroup;
		if (shareWithAllGroups)
			$('#cbShareWithGroups_ms').parent().show();
		else if (shareWithOwnGroup)
			$('#cbShareWithOwnGroup_ms').parent().show();

		var shareWithIndividualUsers = isPmOrAdmin ||
			(Storyboard.LayoutDesigner.myStoriesSharingType & Storyboard.Constants.FavoriteSharingType.AllIndividualUsers) == Storyboard.Constants.FavoriteSharingType.AllIndividualUsers;
		var shareWithOwnGroupUsers = ProjectHasUserGroups && CurrentUserBelongsToGroups &&
			(Storyboard.LayoutDesigner.myStoriesSharingType & Storyboard.Constants.FavoriteSharingType.IndividualUsersWithinGroup) == Storyboard.Constants.FavoriteSharingType.IndividualUsersWithinGroup;
		var shareWithAdmins = isPmOrAdmin ||
			(Storyboard.LayoutDesigner.myStoriesSharingType & Storyboard.Constants.FavoriteSharingType.IndividualAdmins) == Storyboard.Constants.FavoriteSharingType.IndividualAdmins;

		// "all users" and "users within own group" are mutually exclusive
		var sharingType = shareWithIndividualUsers ? Storyboard.Constants.FavoriteSharingType.AllIndividualUsers :
			(shareWithOwnGroupUsers ? Storyboard.Constants.FavoriteSharingType.IndividualUsersWithinGroup : 0);
		// "administrators" is a separate option
		if (shareWithAdmins) sharingType += Storyboard.Constants.FavoriteSharingType.IndividualAdmins;

		if (sharingType > 0)
			$('#cbShareWithUsers_ms').attr('value', sharingType).parent().show();

		$('#tblAdminsToShareWith_ms, #shareWithAdminsTitle_ms, #shareWithRHUsersTitle_ms').toggle(shareWithAdmins);
		Storyboard.MyStories.setupSharingWithUsers(ProjectHasUserGroups);
		Storyboard.MyStories.setupSharingWithGroups(ProjectHasUserGroups);
		Storyboard.MyStories.BindStorySharingSettings(ProjectHasUserGroups);


	});

	$('#btnShareStory_ms').bind('click', function () { Storyboard.MyStories.saveStorySharingSettings(storyModal); });
	$('#btnCancelStoryShare_ms').bind('click', function() {
		if (storyModal != undefined) {
			storyModal.Close();
		}
	});

	$('.storySharingCheck > input:checkbox').unbind('change').bind('change', function() {
		if ($(this).is(':checked'))
			$('.storySharingCheck > input:checkbox[id!="' + $(this).attr('id') + '"]').removeAttr('checked');
		$('.storySharingWithUsers').toggle($('#cbShareWithUsers_ms').attr('checked'));
		$('.storySharingWithGroups').toggle(ProjectHasUserGroups && $('#cbShareWithGroups_ms').attr('checked'));
	});

    $("#lnkDeleteMyStoriesSlide").bind("click", function () {
        var currentSlide = Storyboard.LayoutDesigner.getCurrentSlide();
        if (currentSlide) {
            var message = '<p>' + locale.get('Do you really want to remove #SLIDE_NAME#?', 4).replace("#SLIDE_NAME#", "<b>" + HTMLHelpers.htmlEncode(currentSlide.slideName)) + '</b></p>';

            new DUIwindow2({
                width: 420,
                html: message,
                closeButton: false,
                buttons: [{
                    text:
                    locale.get("Cancel", 4),
                    cssClass: 'DUIButton',
                    closeWindow: true
                }, {
                    text: locale.get("Remove", 4),
                    cssClass: 'DUIButton',
                    focused: true,
                    onClick: function () {
                        MyStoriesProxy.removeSlides($("#ddlMyStories").val(), [ currentSlide ], function () {
                            DUImessage.show(locale.get("#SLIDE_NAME# removed from MyStories successfully", 4).replace("#SLIDE_NAME#", HTMLHelpers.htmlEncode(currentSlide.slideName)), 'Message-success', 5000);
                            Storyboard.LayoutDesigner.deleteSlide(currentSlide.slideIndex, true);

                            $('.DUI-ST-NAVIGATOR-LASTSLIDE').text(Storyboard.LayoutDesigner.getPageCount());
                            $('#slideBack').click();
                        });
                    }
                }]
            });
        }
    });

	$("#btnCTOptionalCS, #btnCrossTableSetup_ct").bind("click", function () {
		CrossTable2Setup.loadReportSetup();
    });

	$("#btnCCOptionalCS, #btnChartCreatorSlideMasterSetupLink_cc").bind("click", function () {
		if (window.ContentType === Storyboard.Constants.itemTypes.CHART && ChartCreatorSetup.getLayoutTemplateEnabledType() === "enableLayoutTemplates") {
			Storyboard.LayoutDesigner.layoutTemplatesInitiallyEnabled = true;
		}

		if (ChartCreatorSetup.isContentEditable()) {
			$('#layoutArea .layoutElementAdminFocused').removeClass('layoutElementAdminFocused');
			ChartCreatorSetup.disableContentEditing();
			ChartCreatorUI.hideCalculatePanel();
			ChartCreatorDataCom.StoreDataGroup().then(function() {
				ChartCreatorSetup.unloadDataGoup();
				ChartCreatorSetup.loadReportSetup();
			});
		} else {
			ChartCreatorSetup.loadReportSetup();
		}
	});

	$("#btnChartCreatorSlideMasterSetupLink_cc").bind("click", function () {
		$('#setupOptionalChartSettings .settingsFieldset.collapsable')
			.removeClass('collapsable')
			.addClass('expandable');

		$('#divLayoutTemplateSettings .settingsFieldset.expandable')
			.removeClass('expandable')
			.addClass('collapsable');
	});

	$("#btnPrintStory").bind("click", function () {
		// PDF print
		//Storyboard.LayoutDesigner.printStoryteller();

		// Storing selected settings for the Print Window pop-up
		GeneralSettings.printSelectedSettings = GeneralSettings.getSelectedSettings();

		// HTML print
		Storyboard.LayoutDesigner.storeSelectedRespondent();
		Storyboard.LayoutDesigner.storeSelectedDates();
		Storyboard.LayoutDesigner.storeSelections("[id^='lbSetting_']");
        Storyboard.LayoutDesigner.storeSelections("#ddlMyStories");
        Storyboard.LayoutDesigner.storeRespTablesVariables();

		if (self != top) {
			var formReportIFrame = $('iframe.formReport', parent.document).last();
			var width = formReportIFrame.closest(".DUI-WINDOW-2").width();
			var height = formReportIFrame.closest(".DUI-WINDOW-BODY").height();
			formReportIFrame.closest(".DUI-WINDOW-2").width(width + 150);
			formReportIFrame.closest(".DUI-WINDOW-BODY").height(height + 100);
		}

		var print_frame_html = "<iframe id='print-modal-content' name='print-frame' scrolling='no' style='width:100%; border: 0' />";

		new DUIwindow2({
			title: '',
			width: $("#layoutArea").width() + DUIWindowScrollbar.scrollbarWidth,
			height: 720,
			buttons: [],
			html: print_frame_html,
			modal: true
		});

		var drilldownattr = Storyboard.GeneralSettings.drilldownSettingsGuid ? '&drls=' + Storyboard.GeneralSettings.drilldownSettingsGuid : '';
		$('#print-modal-content').attr('src', $("#form1").attr('action') + drilldownattr);
	});
				
	Storyboard.LayoutDesigner.bindUpdateEvent();

	// Change Storyteller button ---------------------
	$("#pageWrapper").undelegate("#btnChangeStoryboard", "click");
	$("#pageWrapper").delegate("#btnChangeStoryboard", "click", function (evt) {
		if (Storyboard.LayoutDesigner.isAdmin) {
			$('#reportbar').css('top', $(evt.target).position().top + $(evt.target).height() + 8 + 'px');
			// Add warning for admin if there are unsaved things in panel
			if ($('#reportbar').is(':visible'))
				Storyboard.LayoutDesigner.hideReportTreePanel(evt);
			else {
				Storyboard.LayoutDesigner.showReportTreePanel(evt);
			}
		}
		else {
			$('#reportbar').css('top', $(evt.target).position().top + $(evt.target).height() + 7 + 'px').toggle();
		}
		$(evt.currentTarget).blur();
		evt.stopPropagation();
		return false;
	});
	// -----------------------------------------------

	// Eventhandlers for Slide navigator -------------
	$(document).undelegate('.DUI-ST-NAVIGATOR-SLIDEHANDLER', 'selected');
	$(document).delegate('.DUI-ST-NAVIGATOR-SLIDEHANDLER', 'selected', function (evt) {
		var selectedItem = $(this).DUIslideNavigator('selected')[0];
		Storyboard.LayoutDesigner.setCurrentPageNo(parseInt(selectedItem, 10));
		$('.layoutElementAdminFocused').find('.cancelEdit').click();
		Storyboard.GuiEvents.deselectAllBoxes();
	});
	// -----------------------------------------------

	$("#btnSaveDataFields").text(locale.get("Save"));
});

$(window).bind('unload', function(event) {
	Storyboard.HighchartsWrapper.destroyCharts();
});

window.layoutElementItemManipulation = function () {
	function move(evt) {
		var selectedElements = $(".ui-selected, .layoutElementsGroup", $('#layoutArea'));
		var stateObj = {eventName: "move", eventElements : []};
		var stepMove = Storyboard.LayoutDesigner.snapToGrid ? Storyboard.LayoutDesigner.gridSize : 1;
		var isArrowKey = evt.which > 36 && evt.which < 41;
		stepMove = stepMove || 1;

		if (isArrowKey)
			selectedElements.trigger('dragstart', null);

		switch (evt.which) {
			case 37:
				selectedElements.each(function() {
					$(this).css("left", function(i, style) { return parseInt(style) - stepMove; });
					movePositionUpdate(this, stateObj);
				});
				//left arrow key
				break;
			case 38:
				selectedElements.each(function() {
					$(this).css("top", function(i, style) { return parseInt(style) - stepMove; });
					movePositionUpdate(this, stateObj);
				});
				//up arrow key
				break;
			case 39:
				selectedElements.each(function() {
					$(this).css("left", function(i, style) { return parseInt(style) + stepMove; });
					movePositionUpdate(this, stateObj);
				});
				//right arrow key
				break;
			case 40:
				selectedElements.each(function() {
					$(this).css("top", function(i, style) { return parseInt(style) + stepMove; });
					movePositionUpdate(this, stateObj);
				});
				//bottom arrow key
				break;
			default:
				return false;
		}

		if (isArrowKey) {
			if ($(evt.target).hasClass('layoutElement'))
				Storyboard.GuiEvents.updateElementCoordsAndSizes(evt.target);

			if ($(evt.target).hasClass('layoutElementsGroup'))
				Storyboard.GuiEvents.updateGroupCoordsAndSizes(evt.target);

			Storyboard.LayoutDesigner.layoutElementsSizeOrCoordChanged(stateObj);
		}
	}

	function movePositionUpdate(elementItem, stateObj) {
		var oldTop		= parseInt($(elementItem).data('originalPositionTop'));
		var oldLeft		= parseInt($(elementItem).data('originalPositionLeft'));
		var position	= $(elementItem).position();
		var diffLeft	= Math.round(position.left) - oldLeft;
		var diffTop		= Math.round(position.top) - oldTop;
		var newTop, newLeft, groupId, curLayoutElements, curLayoutElement;

		function moveLayoutElement(layoutElement, props, stateObj) {
			var oldValues = {}, newValues = {};

			Object.keys(props).forEach(function(key) {
				if (layoutElement[key] !== props[key]) {
					oldValues[key] = layoutElement[key]
					newValues[key] = props[key];
					layoutElement[key] = props[key];
				}
			});

			stateObj.eventElements.push({
				guid: layoutElement.guid,
				oldValues: oldValues,
				newValues: newValues
			});

			Storyboard.LayoutDesigner.updateLayoutElement(layoutElement);
		}

		if ($(elementItem).hasClass('layoutElement')) {
			newTop 	= Math.round(position.top);
			newLeft	= Math.round(position.left);
			curLayoutElement = Storyboard.LayoutDesigner.getLayoutElementByGuid($(elementItem).attr('guid'));
			moveLayoutElement(curLayoutElement, {xCoord: newLeft, yCoord: newTop}, stateObj);
		}

		if ($(elementItem).hasClass('layoutElementsGroup')) {
			groupId = parseInt($(elementItem).attr('layoutelementsgroupid'));
			curLayoutElements = Storyboard.LayoutDesigner.getLayoutElementsByGroup(groupId);

			curLayoutElements.forEach(function(curLayoutElement) {
				newTop 	= Math.round(curLayoutElement.yCoord + diffTop);
				newLeft	= Math.round(curLayoutElement.xCoord + diffLeft);
				moveLayoutElement(curLayoutElement, {xCoord: newLeft, yCoord: newTop}, stateObj);
			})
		}
	}

	function snapToGridElements() {
		var stateObj = {eventName: "move", eventElements : []};

		$(".layoutElement", $('#layoutArea')).each(function () {
			var curLayoutElement = Storyboard.LayoutDesigner.getLayoutElementByGuid($(this).attr('guid'));
			var oldTop = parseInt($(this).css('top'), 10);
			var oldLeft = parseInt($(this).css('left'), 10);

			Storyboard.GuiEvents.alignElementToGrid(curLayoutElement);
			Storyboard.LayoutDesigner.updateLayoutElement(curLayoutElement);

			stateObj.eventElements.push({
				guid: curLayoutElement.guid,
				oldValues: { xCoord: oldLeft, yCoord: oldTop },
				newValues: { xCoord: curLayoutElement.xCoord, yCoord: curLayoutElement.yCoord }
			});
		});

		Storyboard.LayoutDesigner.layoutElementsSizeOrCoordChanged(stateObj);
	}

	return {
		move: move,
		Update: movePositionUpdate,
		SnapToGridElements: snapToGridElements
	};
}();